<template>

  <div class="container" id="firstCalcContainer" style="display:none;">
	<!--<div id="minimap-wrapper" style="background:white;height:300px;">
  map
  </div>-->
    <span id="topp"></span>
    <vue-html2pdf :show-layout="false" :enable-download="false" :preview-modal="false" filename="solkartan" :pdf-quality="1" :manual-pagination="true" pdf-format="a4" pdf-content-width="785px" pdf-orientation="portrait" :paginate-elements-by-height="800" @beforeDownload="beforeDownloadOld($event)" ref="html2Pdf" style="position:absolut;top:0">
      <section slot="pdf-content">
        <section class="pdf-item no-border">
<div>
                        <b-row class="py-2 mx-1">
						<b-col cols="12" class="no-border text-center">
						  <b-img class="m-3 text-center" src="./img/PV_Karlstad_RGB_POS_72.png" fluid alt="Logga" style=""></b-img>
						  </b-col>
						  </b-row>
                        <b-row class="py-1 mx-1 text-center" style="font-size:1.4em">
                          <b-col cols="6" class="no-border text-center">
                        <b-row class="py-2 mx-1 text-center">
                          <b-col cols="12" class="no-border text-center">
						  Ditt solcellssystem:
						  </b-col>
						  </b-row>
                        <b-row class="px-1 py-1 text-center" style="line-height:1.4em">
                          <b-col cols="4" class="border border-white text-center bg-secondary">
						  {{this.solarSystem.numPanels}}<br />paneler
						  </b-col>
                          <b-col cols="4" class="border border-white text-center bg-secondary p-1">
						  {{this.solarSystem.systemSize}}<br />kW
						  </b-col>
                          <b-col cols="4" class="border border-white text-center bg-secondary">
						  {{this.solarSystem.panelArea}}<br />m<sup>2</sup>
						  </b-col>
						  </b-row>
                        <b-row class="py-2 text-center" style="font-size:0.7em;">
                          <b-col cols="12" class="text-center">
						  <span id="printAddress" class="text-center"></span>
						  </b-col>
						
						  </b-row>
									   </b-col>
                          <b-col cols="6" class="no-border" id="printMap">
									   </b-col>
									   </b-row>
									   <!--
                        <b-row class="py-2 mx-1">
                          <b-col cols="9" class="no-border bg-secondary">
						 <h3>Solcellssystemet som ger dig den kortaste återbetalningstiden är (maybe...):</h3>
									   </b-col>
                          <b-col cols="3" class="no-border bg-secondary">
						  <h4 class="p-0 m-0"><span v-html="this.solarSystem.systemSize"></span> kW</h4>
						  <h4 class="p-0 m-0"><span v-html="this.solarSystem.panelArea"></span> m<sup style="line-height:inherit;margin-right:0.2rem;">2</sup></h4>
						  <h4 class="p-0 m-0"><span v-html="this.solarSystem.numPanels"></span> paneler</h4>
									   </b-col>
									   </b-row>
							-->		   
							
                        <b-row class="py-1 mx-5">		   
									   
							              <b-col cols="12" class="no-border">
                    <div class="text-center mb-0">
  <b-row>
    <b-col cols="12">
	<b-img src="./header.png" style="width:100%;" class="px-5"></b-img>
  <div class="text-center" style="width:100%;position:absolute;top:48%;left:0;border:0px solid black;">
  <span class="header-headings-big" style="font-size:16px;"><span v-html="this.formatNumber(this.solarSystem.pvYieldYearOne)"></span> kWh/år från ditt system!</span>
  </div>
	</b-col>
	
  </b-row>
  <b-row>
  
  <div style="width:35%;border:0px solid black;font-size:14px;font-weight:600;padding-left:12px">
  
  Till huset:<br />
  <span v-html="this.formatNumber(this.solarSystem.selfConsumption)"></span> kWh/år<br />
  
                      <span>Spara <span v-html="this.formatNumber(this.solarSystem.selfConsumptionValue)"></span> kr/år</span></div>
  <div class="" style="width:30%;border:0px solid black;margin-top:-30px;">
  Totalt <span v-html="this.formatNumber(this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue)" style="font-weight:bold"></span> kr/år på att göra din egen el!
  </div>
  <div style="width:35%;border:0px solid black;font-size:14px;font-weight:600;padding-left:14px">
  Till nätet:<br />
  <span v-html="this.formatNumber(this.solarSystem.overproduction)"></span> kWh/år<br />
                      <span>Tjäna <span v-html="this.formatNumber(this.solarSystem.overproductionValue)"></span> kr/år</span></div>
  
  </b-row>
                    </div>
              </b-col>	
			  <!--
              <b-col cols="6">
<b-row>
<irr-chart :chart-data="irrChartData" :options="irrChartData.options" :styles="irrChartData.styles" style="width:340px;height:280px" ref="nonsense" />
                
</b-row>
<b-row class="">
<b-col cols="6" class="text-center">
<h5 class="p-0 m-0"><span v-html="this.solarSystem.pvInvestment.outPvInvestment"></span> kr</h5>
solcellskostnad
              </b-col>
<b-col cols="6" class="text-center">
<h5 class="p-0 m-0"><span v-html="this.solarSystem.kpiPaybackTime"></span> år</h5>
återbetalningstid
              </b-col>
</b-row>
              </b-col>
			  -->
									   </b-row> 
									   
                        <b-row class="py-4 mx-1" align-v="center">	
                          <b-col cols="12" class="no-border text-center" align-v="center" style="font-size:1.5em">
						Kostnaden blir ca <span style="font-weight:bold" v-html="this.formatNumber(this.solarSystem.pvInvestment.outPvInvestment)"></span> kr med <span style="font-weight:bold" v-html="this.solarSystem.kpiPaybackTime"></span> år återbetalningstid
						</b-col>
									   </b-row> 
                        <b-row class="py-2 mx-1">		   
									   
							              <b-col cols="6" class="no-border" style="font-size:18px;">
										  <p style="font-size:1.5em">Med solceller kommer ditt tak:</p>
										  
<p class="no-border bg-secondary text-center">producera <span style="font-size:20px;font-weight:600">{{solarSystem.kpiSolarFraction}}%</span> av din årsförbrukning</p>
<p class="no-border bg-secondary text-center">minska köpt el med <span style="font-size:20px;font-weight:600">{{solarSystem.kpiSelfSufficiency}}%</span></p>
<p class="no-border bg-secondary text-center">minska CO<sub style="line-height:inherit;margin-right:0.2rem;">2</sub>-utsläpp med <span style="font-size:20px;font-weight:600">{{this.formatNumber(solarSystem.pvYieldYearOne * 0.047, {maximumSignificantDigits: 2})}} kg</span> per år</p>
<p class="no-border bg-secondary text-center">driva en elbil <span style="font-size:20px;font-weight:600">{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits: 2})}} mil</span> per år</p>
              </b-col>
							              <b-col cols="6" class="no-border">
<line-chart :chart-data="datacollection" :options="datacollection.options" :styles="datacollection.styles" style="width:340px;height:280px" />
              </b-col>
</b-row>
            <div class="html2pdf__page-break" />
			
                        <b-row class="py-2 mx-1">	
                          <b-col cols="12" class="no-border bg-secondary text-center" align-v="center">
						<h3>Detaljerade resultat och antaganden</h3>
						</b-col>
									   </b-row> 
                        <b-row class="py-2 mx-1">	
                          <b-col cols="6" class="no-border" style="font-size:0.8em;line-height:1.1em">
                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Byggnadsinput</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Elförbrukning</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vAnnualDemand), 3}} kWh/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Total takyta</b-td>
                            <b-td>{{this.formatNumber(Math.round(this.solarSystems[this.solarSystems.length - 1].roofArea))}} m<sup>2</sup></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Takyta tillgänglig för solceller</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.maxRoofArea)}} m<sup>2</sup></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årssolinstrålning *</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.irrYear)}} kWh/m<sup>2</sup>/år</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Total solinstrålning på taket</b-td>
                            <b-td>{{this.solarSystem.irrYear * this.solarValues.initialRoofArea}} kWh/m2/år</b-td>
                          </b-tr>
						  -->
                        </b-tbody>
                      </b-table-simple>

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Tekniska resultat</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Största möjliga systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.maxSystemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Rekommenderad systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.optimalSystem.systemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Vald systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.systemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellernas årsproduktion</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvYieldYearOne)}} kWh/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årsproduktion per kW</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvYield)}} kWh/kW/år</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Andel av elförbrukning du producerar själv</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiSolarFraction)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Egenanvändning av solelproduktion **</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.selfConsumptionFraction)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Minskning av el köpt från nätet</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiSelfSufficiency)}} %</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>CO2-utsläppsminskning</b-td>
                            <b-td>{{this.formatNumber(solarSystem.pvYieldYearOne * 0.047, {maximumSignificantDigits:2})}} kg/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Avstånd i elbil körd på solel</b-td>
                            <b-td>{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits:2})}} mil</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
					  
					  <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Tekniska förutsättningar</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Andel av takyta tillgänglig för solceller</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techRoofFraction, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellernas verkningsgrad</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefModuleEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Anläggningens effektivitet (efter solceller)</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefSysEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Total systemeffektivitet</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefSysEff * this.solarConstants.techDefModuleEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Local losses</b-td>
                            <b-td>{{this.solarConstants.techDefLocalLosses * 100}} %</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Solcellernas degradering</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vPvDegrad, {maximumSignificantDigits:2, style:'percent'})}}/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Nettoutsläpp för svensk elmix</b-td>
                            <b-td>47 g/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Energibehov elbil</b-td>
                            <b-td>0,2 kWh/km</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
					  
                      <b-table-simple striped hover small caption-top responsive>
                        <b-tbody>
                          <b-tr>
                            <b-td>* Solinstrålning har beräknats med hjälp av byggnadsdata i 3D från bland annat Lantmäteriet och soldata från SMHI
</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>
** Egenanvändning kalkyleras med maskininlärd modell utvecklad i samarbete med KTH (länk)
</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>

*** Priset kalkyleras med statistik från Energimyndigheten (länk)
</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
					  </b-col>
			
                          <b-col cols="6" class="no-border" style="font-size:0.8em;line-height:1.1em">
                     <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Ekonomiska resultat</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody class="table-body">
                          <b-tr>
                            <b-td>Solcellskostnad (exkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestmentExclVat, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellskostnad (inkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestmentExclRebates, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellskostnad (efter avdrag för grön teknik)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestment, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Jämförelsepris (inkl moms) ***</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vPVPrice)}} kr/kW</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årliga besparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsAnnual)}} kr/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Livslängds besparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsLifetime)}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årliga nettobesparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsNetAnnual)}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Livslängds nettobesparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsNetLifetime)}} kr</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Återbetalningstid</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiPaybackTime)}} år</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Återbetalningstid</b-td>
                            <b-td>{{this.solarSystem.kpiDiscountedPaybackTime}} år</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Nettonuvärde</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiNpv)}} kr</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Internränta</b-td>
                            <b-td>{{this.solarSystem.kpiIrr}} %</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Internränta</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiNominalIrr)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Jämförelsepris för solel</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiLcoe)}} kr/kWh</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
					  
                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Ekonomiska förutsättningar</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Pris på köpt el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vRetailPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Prisförändring för köpt el (utöver inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vRetailPriceInc)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Pris på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vSpotPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Prisförändring för såld el (utöver inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vSpotPriceInc)}} %</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Elcertifikat på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vElcertPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Elcertifikat livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefElcertLifetime)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Mikroproducent skattereduktion på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefMTCPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Mikroproducent skattereduktion livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vMtcLifetime)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Ursprungsgarantier för såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vGoPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Ekonomisk livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vLifelength)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Kalkylränta (exkl inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vDiscountRate, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Inflation</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefInflationRate, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Driftskostnad (% av kostnad exkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vOmCost, {maximumSignificantDigits:2, style:'percent'})}}/år</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Real discount rate</b-td>
                            <b-td>{{this.solarValues.vDiscountRate * 100}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Inflation rate</b-td>
                            <b-td>{{this.solarConstants.econDefInflationRate * 100}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Nominal discount rate</b-td>
                            <b-td>{{this.getNominalDiscountRate()}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>VAT</b-td>
                            <b-td>{{this.solarConstants.econVAT * 100}} %</b-td>
                          </b-tr>
						  -->
                        </b-tbody>
                      </b-table-simple>
					  </b-col>
					  </b-row>
          </div>
        </section>
      </section>
    </vue-html2pdf>
    <!-- <h1 class="text-center mb-4 mt-5"><span><b-icon icon="sun" scale="3" variant="secondary" aria-hidden="true"></b-icon></span>Solkalkylatorn</h1>-->
    <!--<h2 class="text-center py-3 my-1 header"><span><b-icon icon="sun" scale="2" variant="secondary" aria-hidden="true"></b-icon></span>Solkartan</h2>-->
<!--
    <div id="mapContainer" class="mapContainer" style="display:none;width:100%;height:100%;position:absolute;left:0;z-index:100000;background:white;">
      <div id="app-wrapper">
      </div>
      <div id="overlayWindow" style="width:200px;height:200px;position:absolute;left:0;bottom:30px;z-index:100000;background:white;opacity:0.8;">
        <div id="overlayWindowContent">ddd</div>
        <b-button @click="switchPage()">Gå vidare</b-button>
        <br />
        <b-button @click="clearSelection()">Rensa!</b-button>
        <span onclick="clearSelection()">Rensa!</span>
      </div>
    </div>
	-->
    <!--<div id="firstpage" class="firstpage" style="display:none">-->
	
	<!--
    <div id="firstpage" class="firstpage">
      <b-card class="h-100 d-flex flex-column mx-0 px-0 mt-2 text-center p-1 px-0" style="background-color:rgba(255,255,255,0.7)">
        <b-card-body class="p-0" style="margin:0 -15px">
          <div class="text-center px-0">
            <h4>Vad är din årsförbrukning?
			<b-icon icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-page1" shift-v="0" shift-h="0"></b-icon>
  <b-tooltip target="tooltip-page1" triggers="hover" placement="top"><div>
  <p> 
Årsförbrukningen är en viktig parameter i en solcellskalkyl.
</p>
<p>
En normal årsförbrukning för en villa med bergvärme är ungefär 12000kWh.
</p></div></b-tooltip>

  </h4>
          </div>
          <b-row align-h="center">
            <b-col sm="8">
              <b-form-input type="range" id="'rangeInput-usage" v-model="initialAnnualDemand" step="500" :min="2000" :max="30000" class="text-right"></b-form-input>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col sm="8">
              <b-input-group>
                <b-form-input type="number" id="numberInput-usage" v-model="initialAnnualDemand" step="500" :min="2000" :max="30000" class="text-right pr-1"></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>kWh</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row align-h="center" class="my-2">
            <b-button class="rounded mr-2 mappage-button" variant="danger" v-on:click="switchPage()">Fortsätt</b-button>
          </b-row>
        </b-card-body>
      </b-card>

      <b-img width="200" class="" src="./img/PV_Karlstad_RGB_POS_72.png" fluid alt="Logga" style="transform: translate(-50%, -50%);position:absolute;bottom:0;left:50%;"></b-img>
    </div>
-->
    <div id="calcContainer" class="calcContainer" style="width:100%;padding:0;margin-top:3rem;padding-top:0.2rem;">
      <!--<b-button ref="pdfButton" @click="generateReport" class="sticky-top" style="z-index:10000"><b-icon icon="file-earmark-arrow-down-fill" aria-hidden="true" variant="secondary" class="mx-2"></b-icon>Ladda ner sammanfattning som PDF</b-button>-->
      <div class="accordion mt-2" role="tablist" v-if="this.solarSystems.length > 0">

        <div>
          <div no-body class="mb-3 border-left border-right border-bottom border-secondary rounded-lg" style="overflow:inherit">
            <span id="accordion-1-top"></span>
            <!--<div id="accordion-card-1" class="rounded-top bg-secondary p-1 sticky-top" role="tabx" block variant="secondary">-->
            <div id="accordion-card-1" class="bg-white sticky-top border-top border-secondary rounded-lg pt-2 mt-2" role="tabx" block variant="secondary">
			<b-row align-v="end" align-h="center" class="pb-2">
			<b-img class="" src="./solkartan_small.png"  alt="Solkartan" style="width:80px;max-width:100%"></b-img>
                    <span class="span-bigger solar-bold pl-2 pb-0">
  <!--<b-icon scale=1.25 icon="sun" aria-hidden="true" class="mr-1"></b-icon>--> Ditt solcellssystem
  <b-icon icon="question-circle" v-b-tooltip.hover.right id="tooltip-target-1" scale=0.8 shift-v="5" shift-h="-2"></b-icon>
  <b-tooltip target="tooltip-target-1" custom-class="veryLongTooltip p-2" triggers="hover" placement="bottom">
    <div>
	<!--
<h5>Hur går beräkningen till?</h5>
<div class="text-left px-3">
<p>
Vi har räknat ut och föreslagit det system som ger den högsta internräntan, IRR. IRR är ett mått på vilken genomsnittlig årlig avkastning en investering genererar. 
</p><p> 
Vald takyta i kartan har en area på <span v-html="this.solarValues.initialRoofArea">-</span>m2 och beräknas kunna ha max <span v-html="this.solarValues.initialNumPanels">-</span>st paneler.
Den beräknade solinstrålningen är <span v-html="this.solarValues.initialIrrYear">-</span> kWh per m2 och år vilket betyder en produktion på <span v-html="this.solarValues.initialProduction">-</span>kWh per installerad kW. 
</p><p> 
Baserat på detta och en angiven årlig konsumtion på <span v-html="this.initialAnnualDemand">-</span> kWh har ett optimalt system beräknats.
Längre ner på sidan går det att laborera med dessa värden.<br />
</p>
-->
<p>
Ditt taks solinstrålning har beräknats med hjälp av bland annat byggnadsdata i 3D, laserdata från Lantmäteriet och soldata från SMHI.
</p>
<p>
Vi antar att 80% av ditt taks yta går att använda till att installera solceller och att effektiviteten är den av ett standardsystem som installeras idag.
</p>
<p>
Egenkonsumtion beräknas med hjälp av en ny maskininlärningsmodell utvecklad av KTH och Karlstads Energi. (Ladda ner mastersavhandling <a href="http://kth.diva-portal.org/smash/get/diva2:1589293/FULLTEXT01.pdf">här</a>)
</p>
<p>
Ekonomiska beräkningar bygger på KTH-forskning. (Ladda ner doktorsavhandling <a href="http://kth.diva-portal.org/smash/get/diva2:1371035/FULLTEXT01.pdf">här</a>)
</p>
<p>
Det rekommenderade systemet är det som ger kortast återbetalningstid.
</p>
<!--</div>-->
</div>
  </b-tooltip></span>
  </b-row>
  <!--
                <b-row class="text-center p-0 m-0 py-3" align-h="center" align-v="baseline">
                  <b-col md="12" class="px-0"><b-img class="" src="./solkartan_small.png"  alt="Solkartan" style="width:100px;max-width:100%"></b-img>
                    <span class="span-big font-bold">
  Ditt solcellssystem
  <b-icon icon="question-circle" v-b-tooltip.hover.right id="tooltip-target-1" scale=0.9 shift-v="5" shift-h="-2"></b-icon>
  <b-tooltip target="tooltip-target-1" custom-class="veryLongTooltip p-2" triggers="hover" placement="bottom">
    <div>
<p>
Ditt taks solinstrålning har beräknats med hjälp av byggnadsdata i 3D från bland annat Lantmäteriet och soldata från SMHI.
</p>
<p>
Vi antar att 80% av ditt taks yta går att använda till att installera solceller och att effektiviteten är den av ett standardsystem som installeras idag.
</p>
<p>
Kalkylatorn väljer ut det system som ger bäst internränta, men dessa värden kan ändras med hjälp av reglagen längre ner på sidan.
</p>
</div>
  </b-tooltip>
  </span>
                  </b-col>
                </b-row>
				-->
				<!--
                <b-row align-v="center">
                  <b-col xs="4">
                    <span class="mb-0 header-headings-big">Antal paneler</span>
                    <span v-html="this.solarSystem.numPanels" class="spanBig"></span><span class="spanSmall"> st</span>
                  </b-col>
                  <b-col xs="4" class="border-left border-right" style="border-color:#CC6050!important">
                    <h4 class="mb-0">Systemeffekt</h4>
                    <span v-html="this.solarSystem.systemSize" class="spanBig"></span><span class="spanSmall"> kW</span>
                  </b-col>
                  <b-col xs="4">
                    <h4 class="mb-0">Takyta</h4>
                    <h4 v-html="this.solarSystem.panelArea"></h4> m<sup>2</sup>
                  </b-col>
                </b-row>
				-->
				
                <b-row align-v="center" class="text-center pb-2">
                  <b-col cols="12" md="4">
                <b-row align-v="center">
                  <b-col cols="6" md="12">
                    <span class="mb-0 span-medium solar-bold">Antal paneler:</span>
                  </b-col>
                  <b-col cols="6" md="12">
                    <span v-html="this.solarSystem.numPanels" class="span-big font-normal"></span><span class="span-small"> st</span>
                  </b-col>
                </b-row>
                  </b-col>
                  <b-col cols="12" md="4">
                <b-row align-v="center">
                  <b-col cols="6" md="12">
                    <span class="mb-0 span-medium solar-bold">Systemeffekt:</span>
                  </b-col>
                  <b-col cols="6" md="12">
                    <span v-html="this.formatNumber(this.solarSystem.systemSize)" class="span-big solar-normal"></span><span class="span-medium solar-light"> kW</span>
                  </b-col>
                </b-row>
                  </b-col>
                  <b-col cols="12" md="4">
                <b-row align-v="center">
                  <b-col cols="6" md="12">
                    <span class="mb-0 span-medium solar-bold">Takyta:</span>
                  </b-col>
                  <b-col cols="6" md="12">
                    <span v-html="this.solarSystem.panelArea" class="span-big font-normal"></span><span class="span-small">  m<sup>2</sup></span>
                  </b-col>
                </b-row>
                  </b-col>
				  <!--
                  <b-col cols="12" md="4">
                    <h4 class="mb-0">Systemeffekt</h4>
                    <span v-html="this.solarSystem.systemSize" class="spanBig"></span><span class="spanSmall"> kW</span>
                  </b-col>
                  <b-col cols="12" md="4">
                    <h4 class="mb-0">Takyta</h4>
                    <h4 v-html="this.solarSystem.panelArea"></h4> m<sup>2</sup>
                  </b-col>
				  -->
                </b-row>
				
				
				
	<!--			
<div class="col-12 col-md-4">

	<div class="row">
	<div class="col-6 col-md-12">KEY: </div>
	<div class="col-6 col-md-12">VALUE</div>

	</div>

</div>
-->
				<!--
                <b-row align-v="center">
                  <b-col xs="6">
                    <h5 class="mb-0">Kostnad</h5>
                    <h5><span v-html="this.solarSystem.pvInvestment.outPvInvestment"></span> kr</h5>
                  </b-col>
                  <b-col xs="6" class="border-left" style="border-color:#CC6050!important">
                    <h5 class="mb-0">IRR</h5>
                    <h5><span v-html="this.solarSystem.kpiNominalIrr"></span> %</h5>
                  </b-col>
                </b-row>
				-->
            </div>
            <b-collapse id="accordion-1" visible accordion="no-accordions" role="tabpanel">

              <div class="text-center">
              </div>
              <b-col md="12" class="bg-white">
                <b-row align-v="center">
                  <b-col md="12" class="px-0 py-4">
                    <div class="text-center mb-0">
					<b-container class="bv-example-row">
					<b-row>
					
  <b-col cols="12" order-md="1" order="1" class="px-0 pb-2">
    <div class="text-center lh-medium">
  <span class="span-medium">Solel från ditt system:</span><br />
  <!--<span class="span-medium font-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}} kWh/år</span><br />-->
  <span class="span-bigger solar-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}}</span><span class="span-medium solar-bold"> kWh/år</span>
  </div>
  </b-col>
  <!--
  <b-col cols="false" cols-md="5" md="false" order-md="2" order="2" class="d-md-none">
    <div class="text-center lh-medium">
  <span class="span-medium">Solel från ditt :</span><br />
  <span class="span-big solar-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}}</span><span class="span-medium solar-bold"> kWh/år</span>
  </div>
  </b-col>
  -->
					</b-row>
  <b-row>
    <b-col>
	<b-img src="./solarpanel.svg" style="width:65%;"></b-img>
	<!--<b-img src="./header_bg_optimized2.svg" style="width:100%;" class="p-0"></b-img>-->
	<!--
  <div class="text-center lh-medium" style="width:100%;position:absolute;top:50%;border:0px solid black;">
  <span class="span-medium">Solel från ditt system:</span><br />
  <span class="span-big solar-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}}</span><span class="span-medium solar-bold"> kWh/år</span>
  </div>
  -->
  <!--
  <div class="text-center lh-medium" style="width:3%;position:absolute;top:15%;right:0;border:0px solid black;">
  <span class="span-small">{{this.formatNumber(this.solarSystem.overproduction)}}</span><span class="span-small"> kWh/år</span>
  </div>
  -->
  <!--
  <div class="text-center" style="position:absolute;top:0;left:0;border:0px solid black;">
  
  <span class="header-headings-big">
  Till huset:<br />
  <span v-html="this.solarSystem.selfConsumption"></span> kWh
  </span>
  </div>
  <div class="text-center" style="position:absolute;top:20%;right:0;border:0px solid black;">
  <span class="header-headings-big"><span v-html="this.solarSystem.overproduction"></span> kWh</span>
  </div>
  -->
	<!--<h5 class="text-center" style="max-width:50%;margin-left:auto;margin-right:auto;">
		<span v-html="this.solarSystem.pvYieldYearOne"></span> kWh/år från ditt system!
	</h5>-->
	</b-col>
	
  </b-row>
  <!--
  <b-row>
  
  <div class="headerDiv" style="width:29%;border:0px solid black;">
  <span class="span-small">Solel till ditt hus:</span><br />
  <span class="span-medium solar-bold">{{this.formatNumber(this.solarSystem.selfConsumption)}}</span><span class="span-small solar-bold"> kWh/år</span><br />
  <span class="span-small"><span v-html="this.formatNumber(this.solarSystem.selfConsumptionValue)"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-sumYield" scale=1.1 shift-v="5" class="ml-1"></b-icon>
	<b-tooltip target="tooltip-sumYield" triggers="hover" placement="top"><div><p>Baserat på ett elpris på {{this.solarValues.vRetailPrice}} kr/kWh och en prisförändring på {{this.solarValues.vRetailPriceInc}} % per år utöver inflation.</p>
	<p>Andelen egenkonsumerad el är beräknad från en modell. Det verkliga värdet kan vara högre eller lägre beroende på bland annat konsumtionsmönster och uppvärmningssätt.</p></div></b-tooltip>
  </div>
  
  <div class="headerCenterDiv border border-secondary rounded-top rounded-lg p-3" style="width:32%;margin:60px 5% 20px;">
  <span class="span-medium">Värde av att göra din egen el:</span><br />
  <span style="white-space:nowrap;"><span class="span-bigger solar-bold">{{this.formatNumber(this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue)}}</span><span class="span-medium solar-bold"> kr/år</span></span>
  </div>
  
  <div class="headerDiv" style="width:29%">
  <span class="span-small">Solel du säljer:</span><br />
  <span class="span-medium solar-bold">{{this.formatNumber(this.solarSystem.overproduction)}}</span><span class="span-small solar-bold"> kWh/år</span><br />
  <span class="span-small"><span v-html="this.formatNumber(this.solarSystem.overproductionValue)"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-sumGrid" scale=1.1 shift-v="5" class="ml-1"></b-icon>
  <b-tooltip target="tooltip-sumGrid" triggers="hover" placement="top"><div><p>Baserat på ett försäljningspris på {{this.solarValues.vSpotPrice}} kr/kWh, {{this.solarValues.vElcertPrice}} kr/kWh för elcertifikat i {{this.solarConstants.econDefElcertLifetime}} år och {{this.solarConstants.econDefMTCPrice}} kr/kWh i skattereduktion i {{this.solarValues.vMtcLifetime}} år.</p></div></b-tooltip>
  </div>
  
  </b-row>
  -->
  <b-row align-v="end" align-h="center">
  <b-col cols="5" md="4" order="1">
  <b-img src="./house.svg" style="width:50%;" class="p-0"></b-img>
  <div class="headerDiv" style="">
  <span class="span-small">Solel till ditt hus:</span><br />
  <span class="span-medium solar-bold">{{this.formatNumber(this.solarSystem.selfConsumption)}}</span><span class="span-small solar-bold"> kWh/år</span><br />
  <span class="span-small"><span v-html="this.formatNumber(this.solarSystem.selfConsumptionValue)"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-sumYield" scale=1.1 shift-v="5" class="ml-1"></b-icon>
	<b-tooltip target="tooltip-sumYield" triggers="hover" placement="top"><div class="text-left"><p>Baserat på ett elpris på {{this.solarValues.vRetailPrice}} kr/kWh och en prisförändring på {{this.solarValues.vRetailPriceInc}} % per år utöver inflation.</p>
	<p>Andelen egenkonsumerad el är beräknad från en modell. Det verkliga värdet kan vara högre eller lägre beroende på bland annat konsumtionsmönster och uppvärmningssätt.</p></div></b-tooltip>
  </div>
  </b-col>
  <b-col cols="2" md="0" order-md="5" order="2">
  <!--
    <div class="text-center lh-medium" style="width:100%;position:absolute;top:50%;border:0px solid black;">
  <span class="span-medium">Solel från ditt system:</span><br />
  <span class="span-medium font-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}} kWh/år</span><br />
  <span class="span-big solar-bold">{{this.formatNumber(this.solarSystem.pvYieldYearOne)}}</span><span class="span-medium solar-bold"> kWh/år</span>
  </div>
  -->
  </b-col>
  <b-col cols="10" md="4" order-md="3" order="4" class="px-0">
  <!--<div class="headerCenterDiv" style="width:32%;margin:-20px 5%;border:0px solid black">-->
  <div class="headerCenterDiv border border-secondary rounded-top rounded-lg p-2 mt-4">
  <span class="span-medium">Värde av att göra din egen el:</span><br />
  <span style="white-space:nowrap;"><span class="span-bigger solar-bold">{{this.formatNumber(this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue)}}</span><span class="span-medium solar-bold"> kr/år</span></span>
  <!--<span style="line-height:initial" class="span-medium font-bold">{{this.formatNumber(this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue)}} kr/år</span><br />genom att göra din egen el!</span>-->
  <!--<span class="header-headings-big align-bottom">Totalt {{this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue}} kr/år</span>-->
  </div>
  </b-col>
  <b-col cols="5" md="4" order-md="4" order="3">
  <b-img src="./robot.svg" style="width:50%;" class="p-0"></b-img>
  <div class="headerDiv" style="">
  <span class="span-small">Solel du säljer:</span><br />
  <span class="span-medium solar-bold">{{this.formatNumber(this.solarSystem.overproduction)}}</span><span class="span-small solar-bold"> kWh/år</span><br />
  <span class="span-small"><span v-html="this.formatNumber(this.solarSystem.overproductionValue)"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-sumGrid" scale=1.1 shift-v="5" class="ml-1"></b-icon>
  <b-tooltip target="tooltip-sumGrid" triggers="hover" placement="top"><div class="text-left"><p>Baserat på ett försäljningspris på {{this.solarValues.vSpotPrice}} kr/kWh, {{this.solarValues.vElcertPrice}} kr/kWh för elcertifikat i {{this.solarConstants.econDefElcertLifetime}} år och {{this.solarConstants.econDefMTCPrice}} kr/kWh i skattereduktion i {{this.solarValues.vMtcLifetime}} år.</p></div></b-tooltip>
  </div>
  </b-col>
  </b-row>
  <b-row class="text-left py-4 mt-3" style="display:inline-block;">
                      <b-col class="headerCenterDiv span-medium">
  Du producerar <span class="span-big solar-bold">{{solarSystem.kpiSolarFraction}} %</span> av din förbrukning och minskar köp av el med <span class="span-big solar-bold" style="white-space:nowrap;">{{solarSystem.kpiSelfSufficiency}} %</span>
  </b-col>
  </b-row>
                    <b-row align-v="center" class="text-left mt-3">
                      <b-col md="6">
                        <line-chart :chart-data="datacollection" :options="datacollection.options" :styles="datacollection.styles" />
                      </b-col>
                      <b-col md="6">
					  <p>Med solceller kan du bli självförsörjande på el. Den el du inte använder själv kan du sälja på elmarknaden.</p>
<p>Grafen visar din elförbrukning, hur stor del av din producerade el du kan använda själv och hur mycket du kan sälja. Staplarna för egenanvändning och såld el är anläggningens totala produktion.</p>
					  </b-col>
                    </b-row>
  
  
  <!--
  <b-row>
  <div class="text-center my-4" style="width:100%;border:0px solid black;">
  <span class="header-headings-big align-bottom">Totalt sparar/tjänar du <span v-html="this.formatNumber(this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue)" style="font-weight:bold"></span> kr/år på att göra din egen el!</span>
  </div>
  </b-row>
  -->
  
  <!--
  <b-row>
    <b-col class="p-0">
                      <h4 class="mb-0">Till huset:</h4>
                      <h4><span v-html="this.solarSystem.selfConsumption"></span> kWh/år</h4>
	</b-col>
    <b-col class="p-1" style="margin-top:-20vw;">
		<h4 class="mb-0">
		<span v-html="this.solarSystem.pvYieldYearOne"></span> kWh/år från ditt system!<br />
		Totalt {{this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue}} kr/år
		</h4>
	</b-col>
    <b-col class="p-0">
                      <h4 class="mb-0">Till nätet:</h4>
                      <h4><span v-html="this.solarSystem.overproduction"></span> kWh/år</h4>
	</b-col>
  </b-row>
  -->
</b-container>
<!--
					<div class="clearfix">
					<b-img left src="./arrow.svg"></b-img>
					<b-img src="./solar2.svg"></b-img>
					<b-img right src="./arrow.svg"></b-img>
					</div>
					-->
					<!--
					<b-card title="Titel"
      img-src="./solar2.svg">
  </b-card>
                     <object data="./solar2.svg" width="120" height="120" class="danger" variant="danger" style="filter: invert(50%) brightness(60%)"></object>
                     <object data="./solar2.svg" width="120" height="120" class="danger" variant="danger" style="filter: invert(50%) brightness(60%)"></object>
					 -->
 <!--<h4 class="mb-0">
 <span v-html="this.solarSystem.pvYieldYearOne"></span> kWh/år från ditt system!</h4>-->
                    </div>
					<!--
					<b-icon icon="arrow-down-left" aria-hidden="true" animation="throb" font-scale="6" shift-v="-15" shift-h="-15" style="position:relative;top:-80px;left:50px;"></b-icon>
					<b-icon icon="arrow-down-right" aria-hidden="true" animation="throb" font-scale="6" shift-v="-15" shift-h="15" style="position:relative;top:-80px;left:-50px;"></b-icon>
        --><!--             
    <b-iconstack font-scale="5">
      <b-icon stacked icon="sun" variant="info" scale="2"></b-icon>
      <b-icon stacked icon="solar" variant="danger"></b-icon>
    </b-iconstack>
	-->
	<!--<img src="./solar.svg" alt="Solar system"/>-->
	                  </b-col>
                </b-row>
				<!--
                <b-row>
                  <b-col xs="6" class="border-right">
                    <div class="text-center">
					<b-icon icon="arrow-down-left" aria-hidden="true" font-scale="3" shift-h="12"></b-icon><br />
                      <b-icon icon="house-fill" aria-hidden="true" font-scale="6"></b-icon>
                      <h4 class="mb-0">Till huset:</h4>
                      <h4><span v-html="this.solarSystem.selfConsumption"></span> kWh/år</h4>
                      <span>Spara <span v-html="this.solarSystem.selfConsumptionValue"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-sumYield" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-sumYield" triggers="hover" placement="top"><div><p>Baserat på ett elpris på {{this.solarValues.vRetailPrice}} kr/kWh och en prisförändring på {{this.solarValues.vRetailPriceInc}} % per år utöver inflation.</p>
  <p>Andelen egenkonsumerad el är beräknad från en modell. Det verkliga värdet kan vara högre eller lägre beroende på bland annat konsumtionsmönster och uppvärmningssätt.</p></div></b-tooltip>
                    </div>

                  </b-col>
                  <b-col xs="6">
                    <div class="text-center">
					<b-icon icon="arrow-down-right" aria-hidden="true" font-scale="3" shift-h="-12"></b-icon><br />
                      <b-icon icon="plug-fill" aria-hidden="true" font-scale="6"></b-icon>
                      <h4 class="mb-0">Till nätet:</h4>
                      <h4><span v-html="this.solarSystem.overproduction"></span> kWh/år</h4>
                      <span>Tjäna <span v-html="this.solarSystem.overproductionValue"></span> kr/år</span>
					  <b-icon icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-sumGrid" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-sumGrid" triggers="hover" placement="top"><div><p>Baserat på ett försäljningspris på {{this.solarValues.vSpotPrice}} kr/kWh, {{this.solarValues.vElcertPrice}} kr/kWh för elcertifikat i {{this.solarConstants.econDefElcertLifetime}} år och {{this.solarConstants.econDefMTCPrice}} kr/kWh i skattereduktion i {{this.solarValues.vMtcLifetime}} år.</p></div></b-tooltip>
                    </div>
                  </b-col>
                </b-row>
				-->
				<!--
                <b-row align-v="center">
                  <b-col md="12">
                    <div class="text-center mb-0">
					<h4 class="mb-0">Totalt {{this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue}} kr/år</h4>
                    </div>
	                  </b-col>
                </b-row>
				-->
              </b-col>
			  <!--
              <b-row v-if="this.solarSystems.length > 1" align-v="center">
                <b-col md="12">
                  <div class="text-center mb-2 mt-4">
                    <h5>Du har valt mer än ett tak i kartan. Se tabell:</h5>
                  </div>
                  <b-table-simple striped hover small caption-top responsive class="mt-2 rooftable">
                    <b-thead>
                      <b-tr>
                        <b-th colspan="1">System</b-th>
                        <b-th colspan="1">Poäng</b-th>
                        <b-th colspan="1">IRR</b-th>
                        <b-th colspan="1">kWp</b-th>
                        <b-th colspan="1">kWh</b-th>
                        <b-th colspan="1">Pris</b-th>
                        <b-th colspan="1">NPV</b-th>
                        <b-th colspan="1">SF</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-if="this.solarSystems.length > 0">
                        <b-td>S1</b-td>
                        <b-td>{{Math.round(this.solarSystems[0].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[0].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[0].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[0].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[0].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[0].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[0].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 1">
                        <b-td>S2</b-td>
                        <b-td>{{Math.round(this.solarSystems[1].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[1].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[1].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[1].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[1].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[1].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[1].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length === 3">
                        <b-td>S1+S2</b-td>
                        <b-td>{{Math.round(this.solarSystems[2].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[2].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[2].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[2].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[2].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[2].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[2].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 3">
                        <b-td>S3</b-td>
                        <b-td>{{Math.round(this.solarSystems[2].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[2].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[2].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[2].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[2].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[2].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[2].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 3">
                        <b-td>S1+S2</b-td>
                        <b-td>{{Math.round(this.solarSystems[3].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[3].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[3].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[3].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[3].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[3].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[3].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 3">
                        <b-td>S1+S3</b-td>
                        <b-td>{{Math.round(this.solarSystems[4].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[4].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[4].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[4].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[4].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[4].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[4].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 3">
                        <b-td>S2+S3</b-td>
                        <b-td>{{Math.round(this.solarSystems[5].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[5].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[5].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[5].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[5].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[5].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[5].kpiSolarFraction}}%</b-td>
                      </b-tr>
                      <b-tr v-if="this.solarSystems.length > 3">
                        <b-td>S1+S2+S3</b-td>
                        <b-td>{{Math.round(this.solarSystems[6].score * 100)}}%</b-td>
                        <b-td>{{this.solarSystems[6].kpiNominalIrr}}%</b-td>
                        <b-td>{{this.solarSystems[6].systemSize}}</b-td>
                        <b-td>{{this.solarSystems[6].pvYieldYearOne}}</b-td>
                        <b-td>{{this.solarSystems[6].pvInvestment.outPvInvestment}}kr</b-td>
                        <b-td>{{this.solarSystems[6].kpiNpv}}kr</b-td>
                        <b-td>{{this.solarSystems[6].kpiSolarFraction}}%</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
			  -->
            </b-collapse>
			</div>
<div>
<div>
<div>
<div>
<div>
              <b-list-group>
<!--
                <b-list-group-item class="pb-4">
                  <span id="solar-2-top" class="top-span"></span>
                  <b-row align-v="center" v-b-toggle.solar-2 v-on:click="scrollTo('solar-2-top')">
                    <b-col md="6">
                      <h4 class="mt-2 text-center"><b-icon icon="house" aria-hidden="true"></b-icon> Hemmet</h4>
                    </b-col>
                    <b-col md="6">
                      <b-row class="span-small" v-on:click.self.prevent align-v="center">
                        <b-icon icon="sun" aria-hidden="true" class="mx-2"></b-icon>Andel el du producerar själv: {{solarSystem.kpiSolarFraction}} %
						<b-icon v-on:click.stop icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-solarfraction" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-solarfraction" triggers="hover" placement="top"><div><p>Producerad solel relativt din förbrukning.</p></div></b-tooltip>
                      </b-row>
                      <b-row class="span-small" align-v="center">
                        <b-icon icon="sun" aria-hidden="true" class="mx-2"></b-icon>Minskning av köpt el: {{solarSystem.kpiSelfSufficiency}} %
						<b-icon v-on:click.stop icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-selfconsumption" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-selfconsumption" triggers="hover" placement="top"><div><p>Andel av din förbrukning som är egenproducerad el.</p></div></b-tooltip>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-collapse id="solar-2">
                    <b-row align-v="center" class="mt-3">
                      <b-col md="6">
					  <p>Med solceller kan du bli självförsörjande på el. Den el du inte använder själv kan du sälja på elmarknaden.</p>
<p>Grafen visar din elförbrukning, hur stor del av din producerade el du kan använda själv och hur mycket du kan sälja. Staplarna för egenanvändning och såld el är anläggningens totala produktion.</p>
					  </b-col>
                      <b-col md="6">
                        <line-chart :chart-data="datacollection" :options="datacollection.options" :styles="datacollection.styles" />
                      </b-col>
                    </b-row>
                  </b-collapse>
					
                      <b-row align-v="center" class="text-center p-1">
                    <b-col class="text-center">  
<b-button v-b-toggle.solar-2 v-on:click="scrollTo('solar-2-top')" class="mappage-button rounded text-center mt-4 mb-2 px-5">
<span class="when-open">
<b-icon v-if="!busy" icon="chevron-up" scale="1" aria-hidden="true"></b-icon>
Visa mindre...
</span>

<span class="when-closed">
<b-icon v-if="!busy" icon="chevron-down" scale="1" aria-hidden="true"></b-icon>
Visa mer...
</span>
</b-button>
                    </b-col>
                      </b-row>
					  
                  <span id="solar-2-bottom" class="bottom-span"></span>
                </b-list-group-item>

-->



                <b-list-group-item class="py-big">
                  <span id="solar-3-top" class="top-span"></span>
                  <b-row>
                    <b-col md="5" class="text-center mb-3">
					<!--
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
					  -->
                      <h4 class="mt-2 text-center span-big font-bold"><b-icon icon="cash-stack" aria-hidden="true"></b-icon> Ekonomi <!--<i>- ditt system i pengar</i>--></h4>
					  <span class="text-center span-mediumbig solar-light">Ditt system i pengar</span>
                    </b-col>
                    <b-col md="7">
					<!--
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>-->
                      <b-row class="span-small mb-1" style="display:block;">
                        <!--<b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon>{{solarSystem.pvInvestment.outPvInvestment}} kr investering-->
                        <!--<b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon>{{this.formatNumber(solarSystem.pvInvestment.outPvInvestment)}} kr investering-->
                        <b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon>Priset för ditt system: <span style="white-space:nowrap;"><span class="span-medium solar-bold">{{this.formatNumber(solarSystem.pvInvestment.outPvInvestment)}}</span><span class="span-small solar-bold">  kr</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-pvinvestment" scale=1.1 shift-v="5" class="ml-1"></b-icon>
	</span>
	
  <b-tooltip target="tooltip-pvinvestment" triggers="hover" placement="top"><div class="text-left"><p>Total installationskostnad inklusive moms med {{this.solarValues.vRebates}} % investeringsstöd avdraget. Priser baseras på data från installatörer och statistik från <a variant="danger" href="https://iea-pvps.org/national-survey-reports/?year_p=&country=25&order=DESC&keyword=" target="_blank">Energimyndigheten</a>.</p></div></b-tooltip>
                      </b-row>
					  <!--
                      <b-row align-v="center">
                        <b-icon icon="percent" aria-hidden="true" class="mx-2"></b-icon>{{solarSystem.kpiNominalIrr}} % internränta
						<b-icon v-on:click.stop icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-kpiirr" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-kpiirr" triggers="hover" placement="top"><div><p>Internränta är ett mått på avkastning av en investering.</p></div></b-tooltip>
                      </b-row>
					  -->
                      <b-row class="span-small" style="display:block;">
                        <b-icon icon="clock" aria-hidden="true" class="mx-2"></b-icon>Antal år att betala av ditt system: <span style="white-space:nowrap;"><span class="span-medium solar-bold">{{this.formatNumber(solarSystem.kpiPaybackTime)}}</span><span class="span-small solar-bold">  år</span>
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-kpipayback" scale=1.1 shift-v="5" class="ml-1"></b-icon>
	</span>
  <b-tooltip target="tooltip-kpipayback" triggers="hover" placement="top"><div class="text-left"><p>Solceller har en förväntad livslängd på minst 30 år.</p></div></b-tooltip>
                      </b-row>
                    </b-col>
                  </b-row>
				  
                  <b-collapse id="solar-3">
                    <b-row align-v="center" class="mt-3">
                      <b-col md="6">
					  <p>Hur snabbt din anläggning blir återbetald beror på flera saker. Hur mycket du investerat, vilken ränta du får och hur mycket el din anläggning producerar.</p>
					  <p>Grafen visar hur återbetalningstiden ändras baserat på anläggningens storlek.</p>
                      </b-col>
                      <b-col md="6">
                        <irr-chart :chart-data="irrChartData" :options="irrChartData.options" :styles="irrChartData.styles" ref="nonsense" />
                      </b-col>
                    </b-row>
                  </b-collapse>
					
                      <b-row align-v="center" class="text-center p-1">
                    <b-col class="text-center">  
<b-button v-b-toggle.solar-3 v-on:click="scrollTo('solar-3-top')" class="mappage-button button-rounded text-center mt-4 mb-2 px-5">
<span class="when-open" id="show-less-economy">
<b-icon v-if="!busy" icon="chevron-up" scale="1" aria-hidden="true"></b-icon>
Visa mindre...
</span>

<span class="when-closed" id="show-more-economy">
<b-icon v-if="!busy" icon="chevron-down" scale="1" aria-hidden="true"></b-icon>
Visa mer...
</span>
</b-button>
                    </b-col>
                      </b-row>
					  
                  <span id="solar-3-bottom" class="bottom-span"></span>
                </b-list-group-item>





                <b-list-group-item class="py-big border-top border-secondary">
                  <span id="solar-4-top" class="top-span"></span>
                  <b-row>
                    <b-col md="5" class="text-center mb-3">
					<!--
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
					  -->
					  <!--
                      <h4 class="mt-2 text-center span-big"><b-icon icon="cash-stack" aria-hidden="true"></b-icon> Miljö --><!--<i>- ditt system i pengar</i>-->
					  <!--<br />
					  <span class="span-big text-center font-normal"><i>- ditt system i klimatnytta</i></span></h4>-->
                      <h4 class="mt-2 text-center span-big solar-extra-bold"><b-icon icon="cloud" aria-hidden="true"></b-icon> Miljö <!--<i>- ditt system i pengar</i>--></h4>
					  <span class="text-center span-mediumbig solar-light">Ditt system i klimatnytta</span>
                    </b-col>
					<!--
                    <b-col md="6">
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <h4 class="mt-2 text-center"><b-icon icon="sun" aria-hidden="true"></b-icon> Miljö</h4>
                    </b-col>
					-->
                    <b-col md="7">
					<!--
                      <b-row class="span-small" style="display:inline-block;">
                        <b-icon icon="battery-charging" aria-hidden="true" class="mx-2"></b-icon>{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits: 2})}} mil elbil per år
					  <b-icon v-on:click.stop icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-ev" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-ev" triggers="hover" placement="top"><div><p>Baserat på ett antagande om en förbrukning på 0,2kWh/km</p></div></b-tooltip>
                      </b-row>
					  -->
                      <b-row class="span-small mb-1" style="display:block;">
                        <b-icon icon="battery-charging" aria-hidden="true" class="mx-2"></b-icon>Solelen från ditt system motsvarar <span style="white-space:nowrap;"><span class="span-medium solar-bold">{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits: 2})}}</span><span class="span-small solar-bold"> mil</span> med elbil
					  <b-icon icon="question-circle" aria-hidden="true" id="tooltip-ev" scale=1.1 shift-v="5" class="ml-1"></b-icon>
					  <!--
					  <span v-b-tooltip.hover.top id="link-button">
  <b-icon icon="question-circle" variant="dark" aria-hidden="true" scale=1.1 shift-v="5" class="ml-0"></b-icon>
  </span>
<b-tooltip target="link-button" title="Tooltip title" triggers="focus">
  Tooltip title
</b-tooltip>
					  <span v-b-tooltip.hover.top id="link-button2">
  <b-icon icon="question-circle" variant="dark" aria-hidden="true" scale=1.1 shift-v="5" class="ml-0"></b-icon>
  </span>
<b-tooltip target="link-button2" title="Tooltip title" triggers="hover">
  Tooltip title
</b-tooltip>
					  <span v-b-tooltip.hover.top id="link-button3">
  <b-icon icon="question-circle" variant="dark"></b-icon>
  </span>
<b-tooltip target="link-button3" title="Tooltip title" triggers="hover">
  Tooltip title
</b-tooltip>
<b-button id="link-button4" href="#" tabindex="0">
  Button
</b-button>
<b-tooltip target="link-button4" title="Tooltip title" triggers="focus">
  Tooltip title
</b-tooltip>
<b-button id="link-button5" href="#" tabindex="0">
  Button
</b-button>
<b-tooltip target="link-button5" title="Tooltip title" triggers="hover">
  Tooltip title
</b-tooltip>
<b-button id="link-button6" href="#" tabindex="0">
  Button
</b-button>
<b-tooltip target="link-button6" title="Tooltip title" triggers="hover focus">
  Tooltip title
</b-tooltip>
-->
	</span>
  <b-tooltip target="tooltip-ev" triggers="hover" placement="top"><div class="text-left"><p>Baserat på ett antagande om en förbrukning på 0,2kWh/km</p></div></b-tooltip>
       <!--                       <span v-b-tooltip.hover.top title="Baserat på ett antagande om en förbrukning på 0,2kWh/km">
  <b-icon icon="question-circle" variant="dark" aria-hidden="true" scale=1.1 shift-v="5" class="ml-0"></b-icon>
  </span>
  -->
                      </b-row>
					  <!--
                      <b-row class="span-small" style="display:inline-block;">
                        <b-icon icon="cloud" aria-hidden="true" class="mx-2"></b-icon>{{this.formatNumber(solarSystem.pvYieldYearOne * 0.047, {maximumSignificantDigits: 2})}} kg CO<sup style="line-height:inherit;margin-right:0.2rem;">2</sup>utsläppsminskning per år
    <b-icon v-on:click.stop icon="question-circle" aria-hidden="true" font-scale="1" id="tooltip-co2" shift-v="0" shift-h="4"></b-icon>
  <b-tooltip target="tooltip-co2" triggers="hover" placement="top"><div><p>Baserat på ett antagande om 47g CO<sup>2</sup>/kWh i svensk elmix enligt <a href="https://www.energimyndigheten.se/fornybart/hallbarhetskriterier/hallbarhetslagen/fragor-och-svar/vaxthusgasberakning/" target="_blank">Energimyndigheten</a>.</p></div></b-tooltip>
                      </b-row>
					  -->
                      <b-row class="span-small" style="display:block;">
                        <b-icon icon="cloud" aria-hidden="true" class="mx-2"></b-icon>Ditt system minskar CO<sub style="line-height:inherit;margin-right:0.2rem;">2</sub>-utsläppen med <span style="white-space:nowrap;"><span class="span-medium solar-bold">{{this.formatNumber(solarSystem.pvYieldYearOne * 0.047, {maximumSignificantDigits: 2})}}</span> <span class="span-small solar-bold"> kg</span> per år<span id="tooltip-co2" href="#"><b-icon icon="question-circle" aria-hidden="true" scale=1.1 shift-v="5" class="m-1"></b-icon>
  <b-tooltip target="tooltip-co2" triggers="hover"><div><p>Baserat på ett antagande om 47g CO<sub>2</sub>/kWh i svensk elmix enligt <a href="https://www.energimyndigheten.se/fornybart/hallbarhetskriterier/hallbarhetslagen/fragor-och-svar/vaxthusgasberakning/" target="_blank">Energimyndigheten</a>.</p></div></b-tooltip></span>
  <!--
<span id="link-button5" href="#" tabindex="0">
  <b-icon icon="question-circle" scale="1.1" aria-hidden="true" class="ml-3 mr-1"></b-icon>
</span>
<b-tooltip target="link-button5" title="Tooltip title" triggers="hover">
  <div><p>Baserat på ett antagande om 47g CO<sup>2</sup>/kWh i svensk elmix enligt <a href="https://www.energimyndigheten.se/fornybart/hallbarhetskriterier/hallbarhetslagen/fragor-och-svar/vaxthusgasberakning/" target="_blank">Energimyndigheten</a>.</p></div>
</b-tooltip>
-->
</span>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-collapse id="solar-4" class="mt-3">
                    <p>Med din anläggning kan en elbil köra <span style="white-space:nowrap;">{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits: 2})}} mil</span> per år. Denna beräkning baseras på den totala elproduktionen från din anläggning.</p>
					<p>Din anläggning bidrar dessutom till att minska mängden koldioxid vilket är en viktig insats för miljön.</p>
                  </b-collapse>
					
                      <b-row align-v="center" class="text-center p-1">
                    <b-col class="text-center">  
<b-button v-b-toggle.solar-4 v-on:click="scrollTo('solar-4-top')" class="mappage-button button-rounded text-center mt-4 mb-2 px-5">
<span class="when-open" id="show-less-climate">
<b-icon v-if="!busy" icon="chevron-up" scale="1" aria-hidden="true"></b-icon>
Visa mindre...
</span>

<span class="when-closed" id="show-more-climate">
<b-icon v-if="!busy" icon="chevron-down" scale="1" aria-hidden="true"></b-icon>
Visa mer...
</span>
</b-button>

                    </b-col>
                      </b-row>
					  
                  <span id="solar-4-bottom" class="bottom-span"></span>
                </b-list-group-item>





                <b-list-group-item class="py-big border-top border-secondary">
                  <span id="solar-5-top" class="top-span"></span>
                  <b-row>
                    <b-col md="5" class="text-center mb-3">
					<h4 class="mt-2 text-center span-big solar-extra-bold"><b-icon icon="calculator" aria-hidden="true"></b-icon> Kalkylatorn <!--<i>- ditt system i pengar</i>--></h4>
					  <span class="text-center span-mediumbig solar-light">Räkna enkelt själv!</span>
                    </b-col>
					<!--
                    <b-col md="6">
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <h4 class="mt-2 text-center"><b-icon icon="calculator" aria-hidden="true"></b-icon> Kalkylatorn</h4>
                    </b-col>-->
                     <b-col md="7">
                      <b-row class="span-small mb-1" style="display:block;">
                        <b-icon icon="sun" aria-hidden="true" class="mx-2"></b-icon><span class="span-medium solar-bold">{{solarSystem.kpiSelfSufficiency}} %</span> självförsörjning
                      </b-row>
                      <b-row class="span-small mb-1" style="display:block;">
                        <!--<b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon>{{solarSystem.pvInvestment.outPvInvestment}} kr investering -->
                        <b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon><span class="span-medium solar-bold">{{this.formatNumber(solarSystem.pvInvestment.outPvInvestment)}} kr</span> investering
                        <!--<b-icon icon="cash-stack" aria-hidden="true" class="mx-2"></b-icon>{{solarSystem.pvInvestment.outPvInvestment.toLocaleString().replace(/,/g," ",)}} kr investering-->
                      </b-row>
                      <b-row class="span-small" style="display:block;">
                        <b-icon icon="clock" aria-hidden="true" class="mx-2"></b-icon><span class="span-medium solar-bold">{{solarSystem.kpiPaybackTime}} år</span> återbetalningstid
                      </b-row>
					  
                        <b-row class="span-small mt-3" style="display:block;">
                          <b-col sm="12">
                            <label :for="'rangeInput-'+solarForm.vSystemSize+'2'">
                              {{ solarForm.vSystemSize.title }}: <span class="span-medium solar-bold">{{solarValues.vSystemSize}} {{solarForm.vSystemSize.unit}}</span><span class="text-left">
                              <span v-b-tooltip.hover.top :title="solarForm.vSystemSize.tooltip" class="pl-1 text-left"><b-icon icon="question-circle" aria-hidden="true" id="tooltip-vSystemSize2" scale=1.1 shift-v="5" class="ml-1"></b-icon>
  </span>
  </span>
                            </label>
                          </b-col>
                          <b-col cols="12" class="align-self-center">
						  <b-form-input type="range" @change.native="doCalcs(solarForm.vSystemSize, $event)" :id="'rangeInput-'+solarForm.vSystemSize.name+'2'" :disabled=solarForm.vSystemSize.disabled :step="solarForm.vSystemSize.step" :min="solarForm.vSystemSize.min" :max="solarForm.vSystemSize.max" :class="$v.solarValues[solarForm.vSystemSize.name].$model < solarForm.vSystemSize.min || solarForm.vSystemSize.max < $v.solarValues[solarForm.vSystemSize.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[solarForm.vSystemSize.name].$model" :state="validateForm(solarForm.vSystemSize.name)">
                            </b-form-input>
                            <b-form-checkbox @input="doCalcs()" v-if="solarForm.vSystemSize.showSwitch" v-model="solarForm.vSystemSize.disabled" name="check-button" switch>
                              Beräkna värde
                            </b-form-checkbox>
                          </b-col>
                          <b-tooltip :show="validateTooltip(solarForm.vSystemSize.name)" :triggers="'manual'" :target="'numberInput-'+solarForm.vSystemSize.name" placement="top" custom-class="validation-tooltip">
                            {{ solarForm.vSystemSize.validationError() }}
                          </b-tooltip>
                        </b-row>
					  
					  
					  
					  
					  
					  
					  
					  
                    </b-col>
                  </b-row>
                  <b-collapse id="solar-5" role="tabpanel" class="p-0" style="margin-left:-20px;margin-right:-20px;">
                    <!--<b-col v-if="this.solarSystems.length > 1" v-bind:class="[stickyDiagram() ? 'sticky-diagrams' : '', 'diagrams', 'mx-0']">-->
                    <b-col v-bind:class="[stickyDiagram() ? 'sticky-diagrams' : '', 'diagrams', 'mx-0']">
                      <b-row align-v="center" class="p-1 mb-2">
                        <b-col xs="6">
                          <b-button block variant="secondary" v-b-toggle="'collapse-irrchart collapse-distribution'" class="button-rounded calc-button" id="toggleDiagram">
                            <b-icon icon="bar-chart-fill" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Diagram
                          </b-button>
                        </b-col>
                        <b-col xs="6">
                          <b-button block variant="danger" @click="confirmReset" class="button-rounded calc-button" id="resetCalc">
                            <b-icon icon="arrow-repeat" aria-hidden="true" variant="secondary" class="mr-1"></b-icon>Återställ</b-button>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="6">
                          <b-collapse id="collapse-distribution">
                            <line-chart :chart-data="datacollection" :options="datacollection.options" :styles="datacollection.styles" />
                          </b-collapse>
                        </b-col>
                        <b-col md="6">
                          <b-collapse id="collapse-irrchart">
                            <irr-chart :chart-data="irrChartData" :options="irrChartData.options" :styles="irrChartData.styles" ref="nonsense" />
                          </b-collapse>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-form class="rangeForm">
					<!--
                      <b-row class="py-2 px-1">
                        <b-col sm="12">
                          <label for="inputHeatingSystem">
                            Årlig förbrukning (kWh)
                            <span v-b-tooltip.hover.top title="Årlig förbrukning (kWh)" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                          </label>
                        </b-col>
                        <b-col cols="8" class="align-self-center">
                          <b-form-input type="range" @input.native="doCalcs()" id="'rangeInput-usage" v-model="solarValues.vAnnualDemand" step="500" :min="2000" :max="30000" class="text-right"></b-form-input>
                        </b-col>
                        <b-col cols="4">
                          <b-input-group>
                            <b-form-input type="number" @input.native="doCalcs({name:'vAnnualDemand', value: solarValues.vAnnualDemand}, $event)" id="numberInput-usage" v-model="solarValues.vAnnualDemand" step="500" :min="2000" :max="30000" class="text-right pr-1"></b-form-input>
                            <b-input-group-append class="d-none d-sm-block">
                              <b-input-group-text>kWh</b-input-group-text>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
					  -->
                      <div v-for="(item) in solarForm" v-if="!item.advanced" :key="item.name">
                        <b-row class="py-2 px-1">
                          <b-col sm="12">
                            <label :for="'rangeInput-'+item.name">
                              {{ item.title }}
                              <span v-b-tooltip.hover.top :title="item.tooltip" :id="'tooltip-'+item.name">
  <b-icon icon="question-circle" variant="dark" aria-hidden="true" scale=1.1 shift-v="5" class="ml-0"></b-icon>
  </span>
                            </label>
                          </b-col>
                          <b-col cols="8" class="align-self-center">
						  <b-form-input type="range" @change.native="doCalcs(item, $event)" :id="'rangeInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)">
                            <!-- <b-form-input type="range" @change.native="doCalcs(item, $event)" :id="'rangeInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)"> -->
                            <!-- <b-form-input type="range" @change.native="doCalcs(item, $event)" :id="'rangeInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" :state="validateForm(item.name)" :value="$v.solarValues[item.name].$model" @input="v => $v.solarValues[item.name].$model = v">--> <!-- v-model.lazy="$v.solarValues[item.name].$model"  -->
                            </b-form-input>
                            <b-form-checkbox @input="doCalcs()" v-if="item.showSwitch" v-model="item.disabled" name="check-button"  :id="'chkbx-'+item.name" switch>
                              Beräkna värde
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="4">
                            <b-input-group>
                              <b-form-input type="number" @input.native="doCalcs(item, $event)" :id="'numberInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" class="pr-1 text-right" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)"></b-form-input>
                              <b-input-group-append class="d-none d-sm-block">
                                <b-input-group-text>{{ item.unit }}</b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                          <b-tooltip :show="validateTooltip(item.name)" :triggers="'manual'" :target="'numberInput-'+item.name" placement="top" custom-class="validation-tooltip">
                            {{ item.validationError() }}
                          </b-tooltip>
                        </b-row>
                      </div>
                    </b-form>
                    <b-row align-v="center" class="b-0 no-border border-0">
                      <b-col xs="6">
                        <b-list-group-item class="d-flex justify-content-between align-items-center m-0" variant="light" v-b-toggle="'collapse-advanced-parameters'" id="toggleAdvanced">
                          Avancerade parametrar
                          <b-icon icon="chevron-double-down" scale="1.5" variant="danger" class="ml-1 when-closede"></b-icon>
                          <b-icon icon="chevron-double-up" scale="1.5" variant="danger" class="ml-1 when-openede"></b-icon>
                        </b-list-group-item>
                        <b-list-group-item class="py-0">
                          <b-collapse id="collapse-advanced-parameters">
                            <b-form class="rangeForm">
							
							
							
					<!--		
                      <div v-for="(item) in solarForm" v-if="item.advanced" :key="item.name">
                        <b-row class="py-2 px-1">
                          <b-col sm="12">
                            <label :for="'rangeInput-'+item.name">
                              {{ item.title }}
                              <span v-b-tooltip.hover.top :title="item.tooltip" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                            </label>
                          </b-col>
                          <b-col cols="8" class="align-self-center">
                            <b-form-input type="range" @input.native="doCalcs(item, $event)" :id="'rangeInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)">
                            </b-form-input>
                            <b-form-checkbox @input="doCalcs()" v-if="item.showSwitch" v-model="item.disabled" name="check-button" switch>
                              Beräkna värde
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="4">
                            <b-input-group>
                              <b-form-input type="number" @input.native="doCalcs(item, $event)" :id="'numberInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" class="pr-1 text-right" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)"></b-form-input>
                              <b-input-group-append class="d-none d-sm-block">
                                <b-input-group-text>{{ item.unit }}</b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                          <b-tooltip :show="validateTooltip(item.name)" :triggers="'manual'" :target="'numberInput-'+item.name" placement="top" custom-class="validation-tooltip">
                            {{ item.validationError() }}
                          </b-tooltip>
                        </b-row>
                      </div>
					  -->
					  	
                      <div v-for="(item) in solarForm" v-if="item.advanced" :key="item.name">
                        <b-row class="py-2">
                          <b-col md="6">
                            <label :for="'rangeInput-'+item.name">
                              {{ item.title }}: {{formatNumber($v.solarValues[item.name].$model * (item.multiply || 1))}} {{ item.unit }}
                              <span v-b-tooltip.hover.top :title="item.tooltip" :id="'tooltip-'+item.name">
  <b-icon icon="question-circle" variant="dark" aria-hidden="true" scale=1.1 shift-v="5" class="ml-0"></b-icon>
  </span>
                            </label>
                          </b-col>
                                <b-col md="6">
                            <b-form-input type="range" @change.native="doCalcs(item, $event)" :id="'rangeInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)">
                            </b-form-input>
                            <b-form-checkbox @input="doCalcs()" v-if="item.showSwitch" v-model="item.disabled" name="check-button" :id="'chkbx-'+item.name" switch>
                              Beräkna värde
                            </b-form-checkbox>
                          </b-col>
						  <!--
                          <b-col cols="4">
                            <b-input-group>
                              <b-form-input type="number" @input.native="doCalcs(item, $event)" :id="'numberInput-'+item.name" :disabled=item.disabled :step="item.step" :min="item.min" :max="item.max" class="pr-1 text-right" :class="$v.solarValues[item.name].$model < item.min || item.max < $v.solarValues[item.name].$model ? 'is-invalid' : 'is-valid'" v-model="$v.solarValues[item.name].$model" :state="validateForm(item.name)"></b-form-input>
                              <b-input-group-append class="d-none d-sm-block">
                                <b-input-group-text>{{ item.unit }}</b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
						  -->
                          <b-tooltip :show="validateTooltip(item.name)" :triggers="'manual'" :target="'numberInput-'+item.name" placement="top" custom-class="validation-tooltip">
                            {{ item.validationError() }}
                          </b-tooltip>
                        </b-row>
                      </div>
					  
					  
					  
					  
					  
			<!--		  
					  
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vPvDegrad">
                                    Effektminskning: {{Math.round(this.solarValues.vPvDegrad * 1000) / 10}} %/år
                                    <span v-b-tooltip.hover.top title="Effektminskning" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>

                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vPvDegrad" v-model="solarValues.vPvDegrad" step="0.001" :min="0" :max="0.01" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
							  -->
							  <!--
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vElcertPrice">
                                    Elcertifikat pris: {{Math.round(this.solarValues.vElcertPrice * 100)}} öre
                                    <span v-b-tooltip.hover.top title="Elcertifikat pris" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vElcertPrice" v-model="solarValues.vElcertPrice" step="0.01" min="0" max="0.1" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
							  -->
<!--                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="econDefElcertLifetime">
                                    Elcertifikat: {{Math.round(this.solarConstants.econDefElcertLifetime)}} år
                                    <span v-b-tooltip.hover.top title="Elcertifikat" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="econDefElcertLifetime" v-model="solarConstants.econDefElcertLifetime" step="1" min="0" max="30" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
-->
<!--
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vGoPrice">
                                    Ursprungsgaranti pris: {{Math.round(this.solarValues.vGoPrice * 100)/100}} kr
                                    <span v-b-tooltip.hover.top title="Ursprungsgaranti" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vGoPrice" v-model="solarValues.vGoPrice" step="0.01" min="0" max="0.1" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
							  -->
<!--
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="econDefMTCPrice">
                                    Skattereduktion: {{Math.round(this.solarConstants.econDefMTCPrice * 100) / 100}} kr
                                    <span v-b-tooltip.hover.top title="Skattereduktion" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="econDefMTCPrice" v-model="solarConstants.econDefMTCPrice" step="0.01" min="0" max="1" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
-->
<!--
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vMtcLifetime">
                                    Skattereduktion för såld el: {{Math.round(this.solarValues.vMtcLifetime)}} år
                                    <span v-b-tooltip.hover.top title="Skattereduktion" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vMtcLifetime" v-model="solarValues.vMtcLifetime" step="1" min="0" max="30" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
							  -->
							  <!--
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vOmCost">
                                    Omkostnader: {{Math.round(this.solarValues.vOmCost * 1000)/10}} %/år
                                    <span v-b-tooltip.hover.top title="Omkostnader" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vOmCost" v-model="solarValues.vOmCost" step="0.001" min="0" max="0.05" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
                              <b-row class="py-2">
                                <b-col md="6">
                                  <label for="vDiscountRate">
                                    Ränta: {{Math.round(this.solarValues.vDiscountRate * 1000) / 10}}%
                                    <span v-b-tooltip.hover.top title="Ränta" class="pl-1">
  <b-icon icon="question-circle" scale=1></b-icon>
  </span>
                                  </label>
                                </b-col>
                                <b-col md="6">
                                  <b-form-input type="range" @input="doCalcs()" id="vDiscountRate" v-model="solarValues.vDiscountRate" step="0.001" min="0" max="0.1" class="text-right"></b-form-input>
                                </b-col>
                              </b-row>
							  -->
                            </b-form>

                          </b-collapse>
                        </b-list-group-item>
                      </b-col>
                    </b-row>
                  </b-collapse>
					
                      <b-row align-v="center" class="text-center p-1">
                    <b-col class="text-center">  
<b-button v-b-toggle.solar-5 v-on:click="scrollTo('solar-5-top')" class="mappage-button button-rounded text-center mt-4 mb-2 px-5">
<span class="when-open" id="show-less-calc">
<b-icon v-if="!busy" icon="chevron-up" scale="1" aria-hidden="true"></b-icon>
Visa mindre...
</span>

<span class="when-closed" id="show-more-calc">
<b-icon v-if="!busy" icon="chevron-down" scale="1" aria-hidden="true"></b-icon>
Visa mer...
</span>
</b-button>
                    </b-col>
                      </b-row>
					  
                  <span id="solar-5-bottom" class="bottom-span"></span>
                </b-list-group-item>


                <b-list-group-item class="py-big border-top border-bottom border-secondary">
                  <span id="solar-6-top" class="top-span"></span>
                  <b-row align-v="center">
                    <b-col md="5" class="text-center mb-3">
					<!--
                      <b-icon icon="chevron-down" font-scale="2" variant="danger" class="when-closed float-right float-md-left mt-2 ml-1 mr-1"></b-icon>
                      <b-icon icon="chevron-up" font-scale="2" variant="danger" class="when-opened float-right float-md-left mt-2 ml-1 mr-1"></b-icon>-->
                      <h4 class="mt-2 text-center span-big solar-extra-bold"><b-icon icon="card-text" aria-hidden="true"></b-icon> Sammanfattning <!--<i>- ditt system i pengar</i>--></h4>
					  <span class="text-center span-mediumbig solar-light">Spara och skriv ut din kalkyl</span>
                    </b-col>
 <b-col md="7" class="mb-3 text-center">
                        <div>
                          <b-button variant="secondary" v-on:click.stop @click="triggerClick" class="mappage-button button-rounded mt-1 mb-2 px-4 w-75" id="downloadButton">
                            <b-icon icon="file-earmark-arrow-down" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Ladda ner resultat
                          </b-button>
                        </div>
                        <div>
                          <b-button variant="secondary" @click="sharePage()" class="mappage-button button-rounded mt-1 mb-2 px-4 w-75" id="shareButton">
                            <b-icon icon="share" aria-hidden="true" variant="danger" class="mr-1"></b-icon>
							Dela
							</b-button>
                        </div>
                    </b-col>
                  </b-row>
                  <b-collapse id="solar-6" class="mt-3">
<!--
                      <b-row align-v="center" class="p-1 mb-2">
                        <b-col xs="4">
                          <b-button block variant="secondary" v-on:click.stop @click="triggerClick" class="mappage-button rounded text-center mt-4 mb-2 px-5 ">
                            <b-icon icon="file-earmark-arrow-down" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Ladda ner resultat
                          </b-button>
                        </b-col>
                        <b-col xs="4">
                          <b-button block variant="secondary" @click="sharePage()" class="rounded calc-button">
                            <b-icon icon="share" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Dela</b-button>
                        </b-col>
                        <b-col xs="4">
                          <b-button block variant="danger" @click="switchPage()" class="rounded calc-button">
                            <b-icon icon="arrow-repeat" aria-hidden="true" variant="secondary" class="mr-1"></b-icon>Återställ</b-button>
                        </b-col>
                      </b-row>
-->
					  <!--
                    <b-col md="12" class="text-center">
						<b-button v-on:click.stop @click="triggerClick" class="calc-button float-none float-md-left rounded mx-2">
							<b-icon icon="file-earmark-arrow-down-fill" aria-hidden="true" variant="danger" class="mx-2"></b-icon>
							Ladda ner resultat					
						</b-button>
                        <b-button v-on:click.stop @click="switchPage()" variant="danger" class="calc-button float-none float-md-right rounded mx-2">
                            <b-icon icon="arrow-repeat" aria-hidden="true" variant="secondary" class="mr-1"></b-icon>
							Återställ
						</b-button>
                    </b-col>
-->
                    <div id="summary">

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Byggnadsinput</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Elförbrukning</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vAnnualDemand), 3}} kWh/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Total takyta</b-td>
                            <b-td>{{this.formatNumber(Math.round(this.solarSystems[this.solarSystems.length - 1].roofArea))}} m<sup>2</sup></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Takyta tillgänglig för solceller</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.maxRoofArea)}} m<sup>2</sup></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årssolinstrålning</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.irrYear)}} kWh/m<sup>2</sup>/år</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Total solinstrålning på taket</b-td>
                            <b-td>{{this.solarSystem.irrYear * this.solarValues.initialRoofArea}} kWh/m2/år</b-td>
                          </b-tr>
						  -->
                        </b-tbody>
                      </b-table-simple>

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Tekniska resultat</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Största möjliga systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.maxSystemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Rekommenderad systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.optimalSystem.systemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Vald systemstorlek</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.systemSize)}} kW</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellernas årsproduktion</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvYieldYearOne)}} kWh/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årsproduktion per kW</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvYield)}} kWh/kW/år</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Andel av elförbrukning du producerar själv</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiSolarFraction)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Egenanvändning av solelproduktion</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.selfConsumptionFraction)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Minskning av el köpt från nätet</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiSelfSufficiency)}} %</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>CO2-utsläppsminskning</b-td>
                            <b-td>{{this.formatNumber(solarSystem.pvYieldYearOne * 0.047, {maximumSignificantDigits:2})}} kg/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Avstånd i elbil körd på solel</b-td>
                            <b-td>{{this.formatNumber(solarSystem.pvYieldYearOne / 2, {maximumSignificantDigits:2})}} mil</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Ekonomiska resultat</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody class="table-body">
                          <b-tr>
                            <b-td>Solcellskostnad (exkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestmentExclVat, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellskostnad (inkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestmentExclRebates, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellskostnad (efter avdrag för grön teknik)</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.pvInvestment.outPvInvestment, {maximumSignificantDigits:4})}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Jämförelsepris (inkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vPVPrice)}} kr/kW</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årliga besparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsAnnual)}} kr/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Livslängds besparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsLifetime)}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Årliga nettobesparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsNetAnnual)}} kr</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Livslängds nettobesparingar</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.savingsNetLifetime)}} kr</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Återbetalningstid</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiPaybackTime)}} år</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Återbetalningstid</b-td>
                            <b-td>{{this.solarSystem.kpiDiscountedPaybackTime}} år</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Nettonuvärde</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiNpv)}} kr</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Internränta</b-td>
                            <b-td>{{this.solarSystem.kpiIrr}} %</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Internränta</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiNominalIrr)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Jämförelsepris för solel</b-td>
                            <b-td>{{this.formatNumber(this.solarSystem.kpiLcoe)}} kr/kWh</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Tekniska förutsättningar</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Andel av takyta tillgänglig för solceller</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techRoofFraction, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Solcellernas verkningsgrad</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefModuleEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Anläggningens effektivitet (efter solceller)</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefSysEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Total systemeffektivitet</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.techDefSysEff * this.solarConstants.techDefModuleEff, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
						  <!--
                          <b-tr>
                            <b-td>Local losses</b-td>
                            <b-td>{{this.solarConstants.techDefLocalLosses * 100}} %</b-td>
                          </b-tr>
						  -->
                          <b-tr>
                            <b-td>Solcellernas degradering</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vPvDegrad, {maximumSignificantDigits:2, style:'percent'})}}/år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Nettoutsläpp för svensk elmix</b-td>
                            <b-td>47 g/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Energibehov elbil</b-td>
                            <b-td>0,2 kWh/km</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>

                      <b-table-simple striped hover small caption-top responsive>
                        <b-thead>
                          <b-tr>
                            <b-th colspan="2">Ekonomiska förutsättningar</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>Pris på köpt el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vRetailPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Prisförändring för köpt el (utöver inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vRetailPriceInc)}} %</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Pris på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vSpotPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Prisförändring för såld el (utöver inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vSpotPriceInc)}} %</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Elcertifikat på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vElcertPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Elcertifikat livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefElcertLifetime)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Mikroproducent skattereduktion på såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefMTCPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Mikroproducent skattereduktion livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vMtcLifetime)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Ursprungsgarantier för såld el</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vGoPrice)}} kr/kWh</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Ekonomisk livslängd</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vLifelength)}} år</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Kalkylränta (exkl inflation)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vDiscountRate, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Inflation</b-td>
                            <b-td>{{this.formatNumber(this.solarConstants.econDefInflationRate, {maximumSignificantDigits:2, style:'percent'})}}</b-td>
                          </b-tr>
                          <b-tr style="background:white;height:1.2em">
                            <b-td></b-td>
                            <b-td></b-td>
                          </b-tr>
                          <b-tr>
                            <b-td>Driftskostnad (% av kostnad exkl moms)</b-td>
                            <b-td>{{this.formatNumber(this.solarValues.vOmCost, {maximumSignificantDigits:2, style:'percent'})}}/år</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </div>
                      <b-row align-v="center" class="p-1">
                        <b-col cols="8" offset="2" md="4" offset-md="0" class="text-center">
                          <b-button variant="secondary" v-on:click.stop @click="triggerClick" class="button-rounded calc-button mt-3 px-3 w-100" id="downloadButton2">
                            <b-icon icon="file-earmark-arrow-down" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Ladda ner resultat
                          </b-button>
                        </b-col>
                        <b-col cols="8" offset="2" md="4" offset-md="0" class="text-center">
                          <b-button variant="secondary" @click="sharePage()" class="button-rounded calc-button mt-3 px-3 w-100" id="shareButton2">
                            <b-icon icon="share" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Dela</b-button>
                        </b-col>
                        <b-col cols="8" offset="2" md="4" offset-md="0" class="text-center">
                          <b-button variant="danger" @click="confirmReset" class="button-rounded calc-button mt-3 px-3 w-100" id="resetCalc2">
                            <b-icon icon="arrow-repeat" aria-hidden="true" variant="secondary" class="mr-1"></b-icon>Återställ</b-button>
                        </b-col>
                      </b-row>
                  </b-collapse>
					
                      <b-row align-v="center" class="text-center p-1">
                    <b-col class="text-center">  
<b-button v-b-toggle.solar-6 v-on:click="scrollTo('solar-6-top')" class="mappage-button button-rounded text-center mt-5 mb-2 px-5">
<span class="when-open" id="show-less-summary">
<b-icon v-if="!busy" icon="chevron-up" scale="1" aria-hidden="true"></b-icon>
Visa mindre...
</span>

<span class="when-closed" id="show-more-summary">
<b-icon v-if="!busy" icon="chevron-down" scale="1" aria-hidden="true"></b-icon>
Visa mer...
</span>
</b-button>
                    </b-col>
                      </b-row>
					  
                  <span id="solar-6-bottom" class="bottom-span"></span>
                </b-list-group-item>
              </b-list-group>




          </div>
        </div>
      </div>
      <div class="text-center">
        <b-img width="200" class="m-3" src="./img/PV_Karlstad_RGB_POS_72.png" fluid alt="Logga" style=""></b-img>
      </div>
    </div>
	<!--
<div>
<h1>PDF EXPORT LAYOUT</h1>
<div>
                        <b-row class="py-2">
                          <b-col cols="6">
									   <b-card
    img-src="https://picsum.photos/600/300/?image=25"
    img-alt="Image"
    img-top
    tag="article"
    style="max-width: 100rem;"
    class="mb-2"
  >
    <b-card-text>
      Some quick example text to build on the card title and make up the bulk of the card's content.
    </b-card-text>

    <b-button href="#" variant="primary">Go somewhere</b-button>
  </b-card>
									   </b-col>
                          <b-col cols="6">
						  MAP IMAGE
									   </b-col>
									   </b-row>
									   
									   
                        <b-row class="py-2">
                          <b-col cols="8" class="border">
						  INFOBOX
									   </b-col>
                          <b-col cols="4">
						               <b-list-group>
                <b-list-group-item>Adam</b-list-group-item>
                <b-list-group-item>Bertil</b-list-group-item>
                <b-list-group-item>Cesar</b-list-group-item>
						               </b-list-group>
									   </b-col>
									   </b-row>
									   
									   
                        <b-row class="py-2">
                          <b-col cols="8">
						  SUMMARY IMAGE
									   </b-col>
                          <b-col cols="4">
                GRAPH
                        <b-row class="py-2">
                          <b-col cols="4">
                Bertil
									   </b-col>
                          <b-col cols="4">
                Cesar
									   </b-col>
									   </b-row>
									   </b-col>
									   </b-row>
									   
									   
                        <b-row class="py-2">
<h1>Med det här solcellssystemet ska ditt tak...</h1>
									   </b-row>
                        <b-row class="py-2">
                          <b-col cols="6">
						  GRAPH
									   </b-col>
                          <b-col cols="6">
						               <b-list-group>
                <b-list-group-item>Adam</b-list-group-item>
                <b-list-group-item>Bertil</b-list-group-item>
						               </b-list-group>
						  
									   </b-col>
									   </b-row>

</div>
</div>
-->
<!--
<span id="link-button4" href="#" tabindex="0">
  <b-icon icon="arrow-right-circle" scale="1.5" aria-hidden="true" class="ml-3 mr-1"></b-icon>
</span>
<b-tooltip target="link-button4" title="Tooltip title" triggers="focus">
  Tooltip title
</b-tooltip>
-->
        <div class="text-center w-100 pb-2" style="position: sticky;bottom: 0; left: 0px; width: 100%; background-color:white;z-index:11;">

<b-button class="button-rounded p-2 my-2" variant="warning" v-on:click="proceedToForm()" id="goToAction">
<span class="solar-bold span-medium">Gå vidare med intresseanmälan</span>
<b-icon icon="arrow-right-circle" scale="1.5" aria-hidden="true" class="ml-3 mr-1"></b-icon>
</b-button>
        </div>
</div>
</div>
</div>
</div>
		  <template>
    <div>
<b-modal visible id="modal-1" centered title="Solkartan"  v-model="showModal">
      <template #modal-header>
        <div class="text-center w-100">
	  <h2 class="text-center py-3 my-1 header"><span><b-icon icon="sun" scale="2" variant="secondary" aria-hidden="true"></b-icon></span>Solkartan</h2>

<!--<h2 class="text-center py-3"><span><b-icon icon="sun" scale="3" variant="secondary" aria-hidden="true"></b-icon></span>Solkalkylatorn</h2>-->
        </div>
      </template>
		<!--
        <b-row class="mb-1">
<h2 class="text-center py-3"><span><b-icon icon="sun" scale="3" variant="secondary" aria-hidden="true"></b-icon></span>Solkalkylatorn</h2>
        </b-row>
<h2 class="text-center py-3"><span><b-icon icon="sun" scale="3" variant="secondary" aria-hidden="true"></b-icon></span>Solkalkylatorn</h2>
-->
    <h5 class="p-3">Kopiera och klistra in länken för att dela kartan.</h5>
<div class="text-center">
<b-form-input type="text" id="shareMapUrlOut" v-model="shareMapUrl" class="text-right pr-1" onclick="this.select()"></b-form-input>
<b-button variant="secondary" @click="copyShareMapUrl" class="mappage-button button-rounded text-center mt-3 mb-3 px-5"><b-icon icon="clipboard" aria-hidden="true" variant="danger" class="mr-1"></b-icon>Kopiera länk</b-button></div>
<div id="confirmationMessage"><i>{{confirmationMessage}}</i></div>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button
            variant="danger"
            size="lg"
            class="button-rounded mappage-button"
			 @click="closeModal()" 
          >
            Stäng
          </b-button>
        </div>
      </template>
</b-modal>
    </div>
</template>
  </div>
  
</template>
<script>
  import VueHtml2pdf from 'vue-html2pdf';
import MiniMap from './MiniMap.vue';
  import {
    validationMixin
  }
  from "vuelidate";
  import {
    required, between
  }
  from "vuelidate/lib/validators";

  export default {
    mixins: [validationMixin],
    data() {
      return {
		  busy:false,
confirmationMessage:'',
		  showModal: false,
		  shareMapUrl: 'www',
	  showMiniMap:false,
	  solarSystem:{pvInvestment:{outPvInvestment:0}}, 
        solarSystems: [{roofArea:0}],
        roofs: window.roofs,
        initialAnnualDemand: 12000,
        stickyDiagram: function() {
          return window.matchMedia('(min-width: 768px)').matches
        },
        stickyDiagrame: undefined,
        viewPage: '',
        text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `,
        userRoofArea: 100, // Roof Area (m2). Needs to be actual area, not a 2d value.
        solarMapIrradianceMonth: [1009, 3349, 8349, 17663, 24132, 26679, 22226, 18524, 12995, 4685, 1845, 789],
        solarMapClasses: [0, 19.6, 40.7, 39.3, 40.4, 35.9, 0, 0],
        datacollection: {
          labels: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
          datasets: this.chartDataset,
          options: {
            scales: {
              yAxes: [{
                ticks: {
							callback: function(value) {
                        return value + ' kWh';
                    },
                  beginAtZero: true
					}
              }]
            },
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index] + ' kWh'; },
						label: function(tooltipItems) {
							return tooltipItems.yLabel + ' kWh';
						}
					}
				},
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }

        },
        irrChartData: {
          labels: ["ett", "två"],
          datasets: [
		  /*{
            label: 'IRR',
            yAxisID: 'IRR',
            borderColor: '#FC2525',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: 'white',
            data: [1,2]
          }, */
		  {
            label: 'Payback',
            yAxisID: 'payback',
            borderColor: '#FC2525',
            pointBackgroundColor: 'white',
            pointStyle: ['point', 'point'],
            pointRadius: '15',
            borderWidth: 1,
            pointBorderColor: 'red',
            pointBorderWidth: 5,
            data: [2,2]
          }],
          options: {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }
        },
        irrChartDatasets: [],
        irrChartLabels: [],
        solarForm: {
          vAnnualDemand: {
            name: 'vAnnualDemand',
            title: 'Ungefärlig årsförbrukning (kWh)',
            unit: 'kWh',
            min: 2000,
            max: 30000,
            step: 500,
            tooltip: 'En normal årsförbrukning för en villa är 5 000 kWh med fjärrvärme, 12 000 kWh med bergvärme och 20 000 kWh med direktel',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vSystemSize: {
            name: 'vSystemSize',
            title: 'Installerad effekt (kW)',
            unit: 'kW',
            min: 2,
            max: 25,
            step: 0.5,
            tooltip: 'Ett system i en villa är vanligtvis mellan 3 och 10 kW',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vProduction: {
            disabled: true,
            showSwitch: true,
            name: 'vProduction',
            title: 'Årsproduktion (kWh/kW)',
            unit: 'kWh/kW',
            min: 600,
            max: 1250,
            step: 25,
            tooltip: 'Årsproduktionen är ett mått på systemets effektivitet och beror på bland annat takets riktning, lutning, eventuell skuggning och systemförluster. De flesta solcellssystem i Sverige producerar 800-1000 kWh/kW.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vPVPrice: {
            disabled: true,
            showSwitch: true,
            name: 'vPVPrice',
            title: 'Investeringskostnad (kr/kW inkl. moms)',
            unit: 'kr',
            min: 8000,
            max: 35000,
            step: 500,
            tooltip: 'Beräknat värde är en genomsnittlig kostnad baserad på statistik men priser kan variera +/-20% beroende på val av utrustning, installatör och typ av tak. Kostnad är inkl moms före eventella rabatter/avdrag.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vRetailPrice: {
            name: 'vRetailPrice',
            title: 'Elpris köp (kr/kWh)',
            unit: 'kr',
            min: 0,
            max: 3,
            step: 0.1,
            tooltip: 'Priset du betalar för el från din elleverantör och nätägare. Inkluderar inte eventuella månadsavgifter.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vRetailPriceInc: {
            name: 'vRetailPriceInc',
            title: 'Elpris förändring (%/år)',
            unit: '%',
            min: -3,
            max: 3,
            step: 0.5,
            tooltip: 'Förändringen av elpriset per år utöver inflation. Historiskt har priserna ökat 1-3% pga skatteökningar.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vLifelength: {
            name: 'vLifelength',
            title: 'Livslängd (år)',
            unit: 'år',
            min: 5,
            max: 50,
            step: 1,
            tooltip: 'Solcellssystem förväntas ha en livslängd på 25-30 år men kan vara längre. Den kan också vara kortare om billiga komponenter/komponenter av låg kvalitet används.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
		  
		  //Below are advanced inputs
          vSelfConsumption: {
            advanced: true,
            disabled: true,
            showSwitch: true,
            name: 'econKPISelfConsumption',
            title: 'Solel direkt till huset',
            unit: '%',
            min: 0,
            max: 100,
            step: 5,
            tooltip: 'Andel av solelen som används direkt i huset. Beräknade värden baseras på en maskininlärd modell från KTH. Verkliga värden varierar vanligtvis +/-5% men kan vara +/-20% i extremfall.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vRebates: {
            advanced: true,
            name: 'vRebates',
            title: 'Skattereduktion för grön teknik',
            unit: '%',
            min: 0,
            max: 20,
            step: 1,
            tooltip: 'Grön teknik får skattereduktion på investeringskostnaden med upp till 50 000 k (330 000 kr max investering). Alternativt kan man få ROT-avdrag med ca 9%.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vSpotPrice: {
            advanced: true,
            name: 'vSpotPrice',
            title: 'Elpris försäljning',
            unit: 'kr/kWh',
            min: 0,
            max: 3,
            step: 0.1,
            tooltip: 'Priset du kan sälja ditt överskott till elnätet för. Priserna är individuella men följer i regel Nord Pools historiska snittpriser.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vSpotPriceInc: {
            advanced: true,
            name: 'vSpotPriceInc',
            title: 'Elpris försäljning förändring',
            unit: '%/år',
            min: -3,
            max: 3,
            step: 0.5,
            tooltip: 'Förändring av elpris (Nord Pool Spotpris) per år utöver inflation. Priserna varierar från år till år och den långsiktiga trenden svår att förutse men troligtvis ligger den mellan +/-1%.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vElcertPrice: { //econDefElcertPrice
            advanced: true,
            name: 'vElcertPrice',
            title: 'Elcertifikat pris',
            unit: 'öre/kWh',
            min: 0,
            max: 0.1,
            step: 0.01,
			multiply: 100,
            tooltip: 'Elcertifikatpriser bestäms på marknaden och har varit så höga som 0.30 kr/kWh men förnybar energi har tryckt ner priserna och förväntas kortsiktigt vara värda 0.01-0.02 kr/kWh.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vGoPrice: { //econDefGOPrice
            advanced: true,
            name: 'vGoPrice',
            title: 'Ursprungsgaranti pris',
            unit: 'öre/kWh',
            min: 0,
            max: 0.1,
            step: 0.01,
			multiply: 100,
            tooltip: 'Det är möjligt att sälja sin el med ursprungsgaranti, men värdet för små solcellsystem är liten och osäkerheten stor.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vMtcLifetime: { //econDefMTCLifetime
            advanced: true,
            name: 'vMtcLifetime',
            title: 'Antal år med skattereduktion',
            unit: 'år',
            min: 0,
            max: 30,
            step: 1,
			multiply: 1,
            tooltip: 'Solel som säljs till nätet kan ge 0.60 kr/kWh i skattereduktion (upp till 18 000 kr/år). Det finns ingen tidsgräns för detta stöd och kan försvinna närsomhelst. Antagandet om 10 år vi använder som standard är detsamma som Energimyndighetens Solelportalen.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
		  /*
          vDiscountRate: { //econDefOMCost
            advanced: true,
            name: 'vDiscountRate',
            title: 'Kalkylränta',
            unit: '%',
            min: 0,
            max: 0.1,
            step: 0.001,
			multiply: 100,
            tooltip: 'Kalkylränta är den ränta som kunde ha erhållits ifall en solcellsinvestering inte gjorts. Värdet är högst individuellt men privatpersoner använder vanligtvis 1-4% som är jämförbart med banklån. Företag använder vanligen en högre siffra (6-10%).',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },*/
          vOmCost: { //econDefOMCost
            advanced: true,
            name: 'vOmCost',
            title: 'Driftskostnader',
            unit: '%/år',
            min: 0,
            max: 0.02,
            step: 0.001,
			multiply: 100,
            tooltip: 'Solceller behöver litet om ens något underhåll men behöver ses över varje år för skador (tex från djur). Kostnaden inkluderar även byte av inverter efter 15 år.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          },
          vPvDegrad: { //techDefPvDegrad
            advanced: true,
            name: 'vPvDegrad',
            title: 'Effektminskning',
            unit: '%/år',
            min: 0,
            max: 0.01,
            step: 0.001,
			multiply: 100,
            tooltip: 'Solceller blir mindre effektiva med tiden, likt batterier i mobiltelefoner. I Sverige är denna effekt ganska liten pga våra låga temperaturer. I länder med mycket sol och värme kan effektminskningen vara 0.5 - 1.0 %/år.',
            type: 'range',
            validationError() {
              return 'Värde ska vara mellan ' + this.min + ' och  ' + this.max + '.'
            }
          }
        },
        optimalSystem: {
          numPanels: 0,
          systemSize: 0,
          panelArea: 0,
          pvYield: 0,
          sc: 0,
          scValue: 0,
          op: 0,
          opValue: 0,
          kpi: 0,
          cost: 0,
          solarFraction: 0,
        },
		solarConstants: {
		  techStandardIrradiation: 1000, // Irradiation at standard test conditions (STC) (W/m2)
          techDefModuleEff: 0.2, // PV Module Efficiency (%)
          techDefSysEff: 0.85, // PV System Efficiency (%)
          techDefLocalLosses: 0, // Local Losses (%)
          //techDefPvDegrad: 0.003, // PV Degradation (%/year)
          techRoofFraction: 0.8, // Fraction to reduce roof area to represent the realistic potential system size rather than the actually size of the roof.
         // econDefElcertPrice: 0.06, // Elcertifikat Price (kr/kWh)
          econDefElcertLifetime: 15, // Elcertifikat Lifetime (years)
          //econDefGOPrice: 0.00, // Guarantee of Origin (GO) Price (kr/kWh)
          econDefMTCPrice: 0.6, // Microproducer Tax Credit (MTC) Price (kr/kWh) 
          //econDefMTCLifetime: 10, // Microproducer Tax Credit (MTC) Lifetime (years)
          //econDefOMCost: 0.008, // O&M Cost (%)
          econVAT: 0.25, // VAT (%)
          //econDefDiscountRate: 0.02, // Discount Rate (%)
          econDefInflationRate: 0.02, // Inflation Rate (%)
		}, 
		solarCalcOutput: {
		
		},
		defaultValues: {
          vRebates: 15,
          vSpotPrice: 0.3,
          vSpotPriceInc: 0,
          vRetailPrice: 1.3,
          vRetailPriceInc: 1,
          vLifelength: 30,
		  vElcertPrice: 0.06,
		  vPvDegrad: 0.003,
		  vGoPrice: 0,
		  vMtcLifetime: 10, //econDefMTCLifetime
		  vOmCost: 0.010, 
		  vDiscountRate: 0.02, 
		
		},
        solarValues: {
          vSystemSize: 5,
          vPVPrice: 18500,
          vRebates: 15,
          vProduction: 900,
          vSpotPrice: 0.3,
          vSpotPriceInc: 0,
          vRetailPrice: 1.3,
          vRetailPriceInc: 1,
          vLifelength: 30,
          vAnnualDemand: 12000, // Total amount of electricity used in the house per year (kWh/yr)
          //vInitialAnnualDemand: 12000, // Total amount of electricity used in the house per year (kWh/yr)
		  vElcertPrice: 0.06,
		  vPvDegrad: 0.003,
		  vGoPrice: 0,
		  vMtcLifetime: 10, //econDefMTCLifetime
		  vOmCost: 0.010, 
		  vDiscountRate: 0.02, 
          userRoofArea: 100, // Roof Area (m2). Needs to be actual area, not a 2d value.
          maxRoofArea: 0,
          userIrrMonthDistr: [], // Specific solar Irradiation per month, array
          userIrrMonthDistrQ: [], // Distribution of irradiation over the year
          userIrrYear: 1000, // Specific solar Irradiation (kWh/m2/yr)
          userIrradiation: 1200, // Specific solar Irradiation (kWh/m2/yr)
          userRoofAzimuth: 0, // (degrees from south, 180 to +180)
          userRoofTilt: 45, // (Roof Tilt (degrees from horizontal))
          userRoofLatitude: 60, // Latitude (degrees from equator)
          econKPISelfConsumption: 50,
          econCashFlow: [{
            totals: [0]
          }],
          econValueOfSavings: {
            selfConsumptionValue: [0],
            overproductionValue: [0]
          },
          econSelfConsumption: {
            selfConsumption: [0],
            overproduction: [0]
          },
          activeRequest: {
            status: false,
            item: ''
          },
          outPVInvestment: 0,
          outPVInvestmentExclVAT: 0,
          outPVInvestmentExclRebates: 0,
          outPVYieldArray: [10],
          outPVYield: 0,
          outKPINominalIRR: 0,
          outKPIIRR: 0,
          outKPINPV: 0,
          outKPILCOE: 0,
          outKPINetSavings: 0,
          outKPIAnnualSavings: 0,
          outKPIRevenueSources: 0,
          outKPISolarFraction: 0,
          outKPISelfSufficiency: 0,
          outKPIPaybackTime: 0,
          outNumPanels: 0,
          outPanelArea: 0,
          outOverproduction: 0,
          outOverproductionValue: 0,
          outSelfConsumption: 0,
          outSelfConsumptionValue: 0,
          outLifetimeRetailPrices: {},
          outLifetimeGridSalePrices: {},
          outLoadDistribution: [],
          outSelfConsumptionDistribution: [],
          outOverproductionDistribution: [],
          optimalNumPanels: 0,
          optimalSystemSize: 0,
          optimalPanelArea: 0,
		  techDefModuleEff: 0.2
        },
        formData: {},
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    validations() {
      return {
        solarValues: {
          vAnnualDemand: {
            required,
            between: between(this.solarForm['vAnnualDemand'].min, this.solarForm['vAnnualDemand'].max)
          },
          vSystemSize: {
            required,
            between: between(this.solarForm['vSystemSize'].min, this.solarForm['vSystemSize'].max)
          },
          vRebates: {
            required,
            between: between(this.solarForm['vRebates'].min, this.solarForm['vRebates'].max)
          },
          vPVPrice: {
            required,
            between: between(this.solarForm['vPVPrice'].min, this.solarForm['vPVPrice'].max)
          },
          vProduction: {
            required,
            between: between(this.solarForm['vProduction'].min, this.solarForm['vProduction'].max)
          },
          vSpotPriceInc: {
            required,
            between: between(this.solarForm['vSpotPriceInc'].min, this.solarForm['vSpotPriceInc'].max)
          },
          vRetailPriceInc: {
            required,
            between: between(this.solarForm['vRetailPriceInc'].min, this.solarForm['vRetailPriceInc'].max)
          },
          vRetailPrice: {
            required,
            between: between(this.solarForm['vRetailPrice'].min, this.solarForm['vRetailPrice'].max)
          },
          vSpotPrice: {
            required,
            between: between(this.solarForm['vSpotPrice'].min, this.solarForm['vSpotPrice'].max)
          },
          vLifelength: {
            required,
            between: between(this.solarForm['vLifelength'].min, this.solarForm['vLifelength'].max)
          },
          econKPISelfConsumption: {
            required,
            between: between(this.solarForm['vSelfConsumption'].min, this.solarForm['vSelfConsumption'].max)
          },
          vElcertPrice: {
            required,
            between: between(this.solarForm['vElcertPrice'].min, this.solarForm['vElcertPrice'].max)
          },
          vPvDegrad: {
            required,
            between: between(this.solarForm['vPvDegrad'].min, this.solarForm['vPvDegrad'].max)
          },
          vGoPrice: {
            required,
            between: between(this.solarForm['vGoPrice'].min, this.solarForm['vGoPrice'].max)
          },
          vMtcLifetime: {
            required,
            between: between(this.solarForm['vMtcLifetime'].min, this.solarForm['vMtcLifetime'].max)
          },
          vOmCost: {
            required,
            between: between(this.solarForm['vOmCost'].min, this.solarForm['vOmCost'].max)
          },
		  /*
          vDiscountRate: {
            required,
            between: between(this.solarForm['vDiscountRate'].min, this.solarForm['vDiscountRate'].max)
          }
		  */
        }
      }
    },
    methods: {
	proceedToForm: function(){
var url = encodeURIComponent(this.createSharePageUrl());
window.parent.location.href = `https://www.karlstadsenergi.se/kundservice/test-solkartan/resultat-solkartan/?solkartanUrl=${url}`;
},
	formatNumber: function(num, options){
  const defaultOptions = {
    maximumSignificantDigits:3
  };
  const localeOptions = Object.assign(defaultOptions, options);
	if(!isNaN(num)){
	/*
	if(options){
	return num.toLocaleString('sv-SE', options);
	}
	*/
	//console.log(localeOptions);
	return num.toLocaleString('sv-SE', localeOptions);
	} else {
	return num;
	}
	},
	
      scrollTo: function(index) {
        var element = document.getElementById(index);

        function isInView(el) {
          let box = el.getBoundingClientRect();
          return box.top < window.innerHeight && box.bottom >= 0;
        }

        window.setTimeout(function() {
          //console.log(isInView(element));
          if (!isInView(element) || !isInView(document.getElementById('solar-3-bottom'))) {
            element.scrollIntoView({
              behavior: "smooth"
            })
          }
        }, 500)
      },
      socketish: function() {
        //var that = this;
        /*
	var solarValues = this.solarValues;
	
	
	let socket = new WebSocket("ws://localhost:3001/origoserver/kdservice/websocket/trams");
socket.onopen = function() {
  //alert("[open] Connection established");
  //alert("Sending to server");
  socket.send("My name is John");
};

socket.onmessage = function(event) {
//console.log(event);
//console.log(this);
//console.log($v);
//console.log($v.solarValues);

  //alert(`[message] Data received from server: ${event.data}`);
  //console.log(event);
  if(parseInt(event.data) > 0){
  //console.log("yes");
  //setSolarValue(parseInt(event.data));
  //this.solarValues.vAnnualDemand = parseInt(event.data);
  console.log(window);
  console.log(document);
  console.log(this);
  console.log(solarValues);
  solarValues.vSystemSize = parseInt(event.data);
  //that.doCalcs();
  }
};

socket.onclose = function(event) {
  if (event.wasClean) {
    alert(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
  } else {
    // e.g. server process killed or network down
    // event.code is usually 1006 in this case
    alert('[close] Connection died');
  }
};

socket.onerror = function(error) {
  alert(`[error] ${error.message}`);
};
*/
      },
      urlParams: function() {
        console.log("äää");
      },
	  getSharePageSearchParams: function(){
	  //var params = new URLSearchParams(this.solarValues);
	  let roofs;
	  if(this.solarSystems.length === 1){
	  roofs = this.solarSystems[0].id;
	  } else if(this.solarSystems.length === 3){
	  roofs = this.solarSystems[0].id + ";" + this.solarSystems[1].id;
	  } else if(this.solarSystems.length === 7){
	  roofs = this.solarSystems[0].id + ";" + this.solarSystems[1].id + ";" + this.solarSystems[2].id;
	  } else {
//		  console.log("NO ROOFS");
		  roofs = "NO ROOFS";
	  }
	  var pk_ab_test, pk_abe, pk_abv = '';
	  if (window.location.href.indexOf("index2.html") != -1){
	  console.log("Original");
	  pk_ab_test = 'Original';
	  pk_abe = 'button_colors';
	  pk_abv = 'Original';
	  }
	  else if (window.location.href.indexOf("/1/") != -1){
	  console.log("Variant 1");
	  pk_ab_test = 'Variation1';
	  pk_abe = 'button_colors';
	  pk_abv = 'Variation1';
	  }
	  else if (window.location.href.indexOf("/2/") != -1){
	  console.log("Variant 2");
	  pk_ab_test = 'Variation2';
	  pk_abe = 'button_colors';
	  pk_abv = 'Variation2';
	  }
	  else if (window.location.href.indexOf("/3/") != -1){
	  console.log("Variant 3");
	  pk_ab_test = 'Variation3';
	  pk_abe = 'button_colors';
	  pk_abv = 'Variation3';
	  }
	  //&&pk_abe=button_colors&pk_abv=Variation3
	  return new URLSearchParams({
		  roofs: roofs, 
		  vAnnualDemand: this.solarValues.vAnnualDemand,
		  vSystemSize: this.solarValues.vSystemSize,
		  vProduction: this.solarValues.vProduction,
		  vProductionDisabled: this.solarForm.vProduction.disabled,
		  vPVPrice: this.solarValues.vPVPrice,
		  vPVPriceDisabled: this.solarForm.vPVPrice.disabled,
		  vRetailPrice: this.solarValues.vRetailPrice,
		  vRetailPriceInc: this.solarValues.vRetailPriceInc,
		  vLifelength: this.solarValues.vLifelength,
		  econKPISelfConsumption: this.solarValues.econKPISelfConsumption,
		  econKPISelfConsumptionDisabled: this.solarForm.vSelfConsumption.disabled,
		  vRebates: this.solarValues.vRebates,
		  vSpotPrice: this.solarValues.vSpotPrice,
		  vSpotPriceInc: this.solarValues.vSpotPriceInc,
		  vElcertPrice: this.solarValues.vElcertPrice,
		  vGoPrice: this.solarValues.vGoPrice,
		  vMtcLifetime: this.solarValues.vMtcLifetime,
		  vOmCost: this.solarValues.vOmCost,
		  vPvDegrad: this.solarValues.vPvDegrad,
		  mapExtent: this.solarValues.mapExtent,
		  pk_ab_test: pk_ab_test,
		  pk_abe: pk_abe,
		  pk_abv: pk_abv,
		  });
	  },
		createSharePageUrl: function() {
		/*
	  //var params = new URLSearchParams(this.solarValues);
	  let roofs;
	  if(this.solarSystems.length === 1){
	  roofs = this.solarSystems[0].id;
	  } else if(this.solarSystems.length === 3){
	  roofs = this.solarSystems[0].id + ";" + this.solarSystems[1].id;
	  } else if(this.solarSystems.length === 7){
	  roofs = this.solarSystems[0].id + ";" + this.solarSystems[1].id + ";" + this.solarSystems[2].id;
	  } else {
//		  console.log("NO ROOFS");
		  roofs = "NO ROOFS";
	  }
	  let urlstuff = {
		  roofs: roofs, 
		  vAnnualDemand: this.solarValues.vAnnualDemand,
		  vSystemSize: this.solarValues.vSystemSize,
		  vProduction: this.solarValues.vProduction,
		  vProductionDisabled: this.solarForm.vProduction.disabled,
		  vPVPrice: this.solarValues.vPVPrice,
		  vPVPriceDisabled: this.solarForm.vPVPrice.disabled,
		  vRetailPrice: this.solarValues.vRetailPrice,
		  vRetailPriceInc: this.solarValues.vRetailPriceInc,
		  vLifelength: this.solarValues.vLifelength,
		  econKPISelfConsumption: this.solarValues.econKPISelfConsumption,
		  econKPISelfConsumptionDisabled: this.solarForm.vSelfConsumption.disabled,
		  vRebates: this.solarValues.vRebates,
		  vSpotPrice: this.solarValues.vSpotPrice,
		  vSpotPriceInc: this.solarValues.vSpotPriceInc,
		  vElcertPrice: this.solarValues.vElcertPrice,
		  vGoPrice: this.solarValues.vGoPrice,
		  vMtcLifetime: this.solarValues.vMtcLifetime,
		  vOmCost: this.solarValues.vOmCost,
		  vPvDegrad: this.solarValues.vPvDegrad,
		  mapExtent: this.solarValues.mapExtent,
		  };
		  var url = new URL(window.location);
		  */
		  //let urlstuff = getSharePageSearchParams();
    //var searchParams = new URLSearchParams(urlstuff)
		  var url = new URL(window.location);
//url.search = new URLSearchParams(urlstuff);
url.search = this.getSharePageSearchParams();
    //var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    //history.pushState(null, '', newRelativePathQuery);
var new_url = url.toString();
//this.setStateUrl();
/*
			var Aurl = new_url;
		  this.shareMapUrl = Aurl;
		  var AnewUrl = new URL(Aurl);
		  console.log('setStateUrl', AnewUrl);
		  */
		  this.setStateUrl();
return new_url;
},
setStateUrl: function() {
var searchParams = this.getSharePageSearchParams();
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.replaceState(null, '', newRelativePathQuery);
},
      copyShareMapUrl: function() {
var that = this;
navigator.clipboard.writeText(this.shareMapUrl).then(function() {
that.confirmationMessage = "Länk kopierad till urklipp!";
  //console.log('Async: Copying to clipboard was successful!');
}, function(err) {
that.confirmationMessage = "Länk kunde inte kopieras!";
  //console.error('Async: Could not copy text: ', err);
});
},
closeModal: function() {
this.showModal=false;
this.confirmationMessage=''}, 
      sharePage: function() {
		  this.showModal = true;
			var url = this.createSharePageUrl();
		  this.shareMapUrl = url;

/*		  var inputModal = document.getElementById('modal-1');
		  var input = document.getElementById('input-1');
		  console.log(inputModal);
		  console.log(input);
		  input.value = 'test';
input.select();*/
window.parent.postMessage({message:"solkartanUrl", value:url}, "*")
	  },
      confirmReset() {
        this.$bvModal.msgBoxConfirm('Vill du återställa dina värden till det rekommenderade systemet?')
          .then(value => {
		  if(value){
            this.switchPage('reset');
			}
          })
          .catch(err => {
            // An error occurred
          })
      },
      switchPage: function(param) {
	  var loadSaved = param === 'load' ? true : false;
	  var reset = param === 'reset' ? true : false;
	  console.log("loadSaved: ", loadSaved);
	  console.log("reset: ", reset);
	  this.solarForm.vProduction.disabled = true;
	  this.solarForm.vPVPrice.disabled = true;
	  this.solarForm.vSelfConsumption.disabled = true;
	  this.solarValues = Object.assign(this.solarValues, this.defaultValues);
	  //console.log(this);
	  /*
	  origo.api().getLayer('Vektorlager').getSource().clear()
origo.api().getLayer('Vektorlager').getSource().addFeatures(new Origo.ol.format.GeoJSON().readFeatures(geojsonObject))
this.vuesite.$root.$refs.SolarMap.origo2.api().getMap().getLayers().
*/
var source = this.$root.$refs.SolarMap.origo2.api().getLayer('Vektorlager').getSource();
//map.getView().fit(searchResultSource.getExtent());
source.clear();
source.addFeatures(this.$root.$refs.SolarMap.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());
this.$root.$refs.SolarMap.origo2.api().getMap().getView().fit(source.getExtent(), {padding: [60,60,60,60]});
console.log(this.$root.$refs.SolarMap.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getFeatures());


        //this.solarValues.vAnnualDemand = this.initialAnnualDemand;
        this.solarValues.vAnnualDemand = this.$root.annualDemand;
        this.solarValues.mapExtent = this.$root.$refs.SolarMap.origo.api().getSelectionManager().getUrval().get('solarmap_05m').getSourceLayer().getSource().getExtent();
        this.loadData();
        //var firstpage = document.getElementById('firstpage');
        this.viewPage = 'firstSection'
        //firstpage.style.display = 'none';
        //this.solarValues.vAnnualDemand = this.initialAnnualDemand;
		this.solarValues.vAnnualDemand = this.$root.annualDemand;
		this.showMiniMap = true;
		//this.minimap = Origo('./minimap.json', { target: '#minimap-wrapper' });
		
		var system = this.solarSystem;
		system.roofs.forEach(element => {
		//console.log(element);
		this.$root.$refs.SolarMap.origo2.api().getLayer('Vektorlager').getSource().getFeatureById(element.id).set('trams', Math.round(element.quote *100) + '% / ' + (element.size ? element.size : '-') + 'kW');
		});
		//console.log(document.getElementById('printMap'));
		//console.log(document.getElementById('app-wrapper2'));
		var printElement = document.getElementById('printMap');
		var mapWrapper = document.getElementById('app-wrapper2');
		if(printElement && mapWrapper){
		printElement.appendChild(mapWrapper);
		}
  /*var test = setInterval(moveMap, 1000);
  function moveMap() {
    if (document.getElementById('solar-5')) {
		document.getElementById('hiddenDiv').appendChild(  document.getElementById('app-wrapper2') );
      clearInterval(test);
    }
  }
  */
		const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
  
if(loadSaved && urlParams.has('roofs') && urlParams.has('mapExtent')){
const qRoofs = urlParams.get('roofs');
const mapExtent = urlParams.get('mapExtent');
var roofArray = qRoofs.split(';').filter(i => i);
//console.log(this.$root.$refs.SolarMap.origo.api());
if(urlParams.get('vSystemSize') >= 1){
	this.solarValues.vSystemSize = urlParams.get('vSystemSize');
}
if(urlParams.get('vProduction') > 300){
	this.solarValues.vProduction = urlParams.get('vProduction');
}
if(urlParams.get('vProductionDisabled') === "false"){
	this.solarForm.vProduction.disabled = false;
} else if(urlParams.get('vProductionDisabled') === "true"){
	this.solarForm.vProduction.disabled = true;
}
if(urlParams.get('vPVPrice') > 5000){
	this.solarValues.vPVPrice = urlParams.get('vPVPrice');
}
if(urlParams.get('vPVPriceDisabled') === "false"){
	this.solarForm.vPVPrice.disabled = false;
} else if(urlParams.get('vPVPriceDisabled') === "true"){
	this.solarForm.vPVPrice.disabled = true;
}
if(urlParams.get('vRetailPrice') > 0){
	this.solarValues.vRetailPrice = urlParams.get('vRetailPrice');
}
if(parseFloat(urlParams.get('vRetailPriceInc')) > -4){
	this.solarValues.vRetailPriceInc = urlParams.get('vRetailPriceInc');
}
if(urlParams.get('vLifelength') > 10){
	this.solarValues.vLifelength = urlParams.get('vLifelength');
}
if(urlParams.get('econKPISelfConsumption') >= 0){
	this.solarValues.econKPISelfConsumption = urlParams.get('econKPISelfConsumption');
}
if(urlParams.get('econKPISelfConsumptionDisabled') === "false"){
	this.solarForm.vSelfConsumption.disabled = false;
} else if(urlParams.get('econKPISelfConsumptionDisabled') === "true"){
	this.solarForm.vSelfConsumption.disabled = true;
}
if(urlParams.get('vRebates') >= 0){
	this.solarValues.vRebates = urlParams.get('vRebates');
}
if(urlParams.get('vSpotPrice') >= 0){
	this.solarValues.vSpotPrice = urlParams.get('vSpotPrice');
}
if(urlParams.get('vSpotPriceInc') >= -4){
	this.solarValues.vSpotPriceInc = urlParams.get('vSpotPriceInc');
}
if(urlParams.get('vElcertPrice') >= 0){
	this.solarValues.vElcertPrice = urlParams.get('vElcertPrice');
}
if(urlParams.get('vGoPrice') >= 0){
	this.solarValues.vGoPrice = urlParams.get('vGoPrice');
}
if(urlParams.get('vMtcLifetime') >= 0){
	this.solarValues.vMtcLifetime = urlParams.get('vMtcLifetime');
}
if(urlParams.get('vOmCost') >= 0){
	this.solarValues.vOmCost = urlParams.get('vOmCost');
}
if(urlParams.get('vPvDegrad') >= 0){
	this.solarValues.vPvDegrad = urlParams.get('vPvDegrad');
}






//this.solarValues.vSystemSize = urlParams.get('vSystemSize');
this.doCalcs();
/*
var newURL = this.updateURLParameter(window.location.href, 'locId', 'newLoc');
newURL = this.updateURLParameter(newURL, 'resId', 'newResId');

window.history.replaceState('', '', updateURLParameter(window.location.href, "param", "value"));
*/
}
this.setStateUrl();
//console.log("A");
if(!loadSaved && !reset){
console.log("continue");
//console.log("B");
var url = "//gi.karlstad.se/api/solar/";
/*
fetch(url, {
  method: 'POST',
  body: {"content":"testing;from;my;app"},
  credentials: 'include'
});
console.log("fetched");
*/ 
//console.log(window);
//var uid = window.matomoUser || "";
var visitor_id;
if(window._paq){
window._paq.push([ function() { visitor_id = this.getVisitorId(); }]);
} else {
visitor_id = null;
}
var x = this.solarValues.mapExtent[0] + (this.solarValues.mapExtent[2] - this.solarValues.mapExtent[0]) / 2;   
var y = this.solarValues.mapExtent[1] + (this.solarValues.mapExtent[3] - this.solarValues.mapExtent[1]) / 2;
var timestamp = Math.round(new Date(new Date().toUTCString().slice(0, -4)).getTime()/1000);

var csvstring = `${this.solarValues.vAnnualDemand};${Math.round(this.solarSystems[this.solarSystems.length - 1].roofArea)};${this.solarSystem.maxRoofArea};${this.solarSystem.irrYear};${this.solarSystem.numPanels};${this.solarSystem.panelArea};${this.solarSystem.systemSize};${this.solarSystem.pvYieldYearOne};${this.solarSystem.pvYield};${this.solarSystem.selfConsumption};${this.solarSystem.selfConsumptionValue};${this.solarSystem.overproduction};${this.solarSystem.overproductionValue};${this.solarSystem.overproductionValue + this.solarSystem.selfConsumptionValue};${this.solarSystem.kpiSolarFraction};${this.solarSystem.kpiSelfSufficiency};${this.solarSystem.pvInvestment.outPvInvestment};${this.solarSystem.savingsLifetime};${this.solarSystem.savingsAnnual};${this.solarSystem.savingsNetAnnual};${this.solarSystem.kpiNpv};${this.solarSystem.kpiNominalIrr};${this.solarSystem.kpiPaybackTime};${this.solarSystem.pvYieldYearOne * 0.047};${Math.round(x)};${Math.round(y)};${visitor_id};${timestamp}`;

fetch(url, {
  method: 'post',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({"content":csvstring})
}).then(result => {
        // do something with the result
        console.log("Added system");
    }).catch(err => {
        // if any error occured, then catch it here
        console.error(err);
    })
if(this.$root.$refs.SolarMap.clicks > 1){
console.log("new visit");
if(window._paq){
  window._paq.push(['appendToTrackingUrl', 'new_visit=1']); // forces a new visit

// the two lines must be above the call to track* function
window._paq.push(["trackPageView"]);

window._paq.push(['appendToTrackingUrl', '']); // do not force a new visit anymore (only do it once)
} else {
console.log("no _paq");
}
}
}
/*
fetch(url, {
    method:"POST",
    body: JSON.stringify({
        content: "testing;from;my;app"
        })
    }).then(result => {
        // do something with the result
        console.log("Completed with result:", result);
    }).catch(err => {
        // if any error occured, then catch it here
        console.error(err);
    });
}
*/
      },
/*	  
	  updateURLParameter: function(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) 
    {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
        if(TheAnchor)
            additionalURL = TheParams;

        tempArray = additionalURL.split("&");

        for (var i=0; i<tempArray.length; i++)
        {
            if(tempArray[i].split('=')[0] != param)
            {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }        
    }
    else
    {
        var tmpAnchor = baseURL.split("#");
        var TheParams = tmpAnchor[0];
            TheAnchor  = tmpAnchor[1];

        if(TheParams)
            baseURL = TheParams;
    }

    if(TheAnchor)
        paramVal += "#" + TheAnchor;

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
},
*/
      doOnPointerDown: function() {
        console.log("pointerdown")
      },
      solarCalculations: function() {
	  //console.log("solarCalculations!!!!");
	  this.funcGetIrradiation();
	  if(this.solarValues.vSystemSize){
	  //this.solarValues.userIrrYear = this.funcGetIrradiation();
	  }
       // this.solarValues.outLifetimeRetailPrices = this.funcLifetimeRetailPrices();
       // this.solarValues.outLifetimeGridSalePrices = this.funcLifetimeGridSalePrices();
        if (this.solarForm.vProduction.disabled) {
          //vSystemSize get max from best roof then second best etc.
          //this.solarValues.userIrrYear = this.funcGetIrradiation();
          this.solarValues.vProduction = this.funcPvYield();
          //console.log(this.funcPvYield());
          //console.log(this.solarValues.userIrrYear);
        }
        if (this.solarForm.vPVPrice.disabled) {
          this.solarValues.vPVPrice = this.funcPVPrice();
        }

        this.solarValues.outPVInvestment = this.funcPVInvestment();
        this.solarValues.outPVYieldArray = this.funcPvLifetime();

        if (this.solarForm.vSelfConsumption.disabled) {
          this.solarValues.econKPISelfConsumption = this.funcGetSelfConsumption();
        }

          //console.log(this.solarValues.outPVYieldArray);
          //console.log(this.solarValues.vSystemSize);
        this.solarValues.econSelfConsumption = this.funcSelfConsumption();
        this.solarValues.outPVYield = Math.round(this.solarValues.outPVYieldArray[0] / 10) * 10;
        this.solarValues.outSelfConsumption = Math.round(this.solarValues.outPVYieldArray[0] * this.solarValues.econKPISelfConsumption / 1000) * 10;
        this.solarValues.outOverproduction = this.solarValues.outPVYield - this.solarValues.outSelfConsumption;
        this.solarValues.econValueOfSavings = this.funcValueOfSavings();
        this.solarValues.outSelfConsumptionValue = Math.round(this.solarValues.econValueOfSavings.selfConsumptionValue[0] / 10) * 10;
        this.solarValues.outOverproductionValue = Math.round(this.solarValues.econValueOfSavings.overproductionValue[0] / 10) * 10;
        this.solarValues.econCashFlow = this.funcCashFlow();
        this.solarValues.econDiscountedCashFlow = this.funcDiscountedCashFlow();
        this.solarValues.outNumPanels = this.funcNumPanels();
        this.solarValues.maxRoofArea = this.funcMaxRoofArea();
        this.solarValues.outPanelArea = this.funcPanelArea();
        this.solarValues.outKPISelfSufficiency = Math.round(this.funcKPISelfSufficiency() * 100);
        this.solarValues.outKPISolarFraction = Math.round(this.funcKPISolarFraction() * 100);
        this.solarValues.outKPIPaybackTime = this.funcKPIPaybackTime();
        this.solarValues.outKPIDiscountedPaybackTime = this.funcKPIDiscountedPaybackTime();
        this.solarValues.outKPINPV = Math.round(this.funcKPINPV() / 10) * 10;
        this.solarValues.outKPIIRR = Math.round(this.funcKPIIRR() * 100000) / 1000;
        this.solarValues.outKPINominalIRR = Math.round(this.funcKPINominalIRR() * 10000) / 100;
        this.solarValues.outKPILCOE = Math.round(this.funcKPILCOE() * 100) / 100;
        this.solarValues.outLoadDistribution = this.funcLoadDistribution();
        this.solarValues.outSelfConsumptionDistribution = this.funcSelfConsumptionDistribution();
        this.solarValues.outOverproductionDistribution = this.funcOverproductionDistribution();
      },

      doCalcs: function(updateCharts = true) {
	  var fraction = 1;
	  if(!this.solarForm.vPVPrice.disabled){
	  var calculatedPrice = this.getPvPrice(this.solarValues.vSystemSize);
	  var inputPrice = this.solarValues.vPVPrice;
	  fraction = inputPrice / calculatedPrice;
	  }
		var system = this.getSystem({
		size: this.solarValues.vSystemSize,
		production: this.solarForm.vProduction.disabled ? undefined : this.solarValues.vProduction,
		price: {price: this.solarForm.vPVPrice, fraction: fraction},
		//price: this.solarForm.vPVPrice.disabled ? undefined : this.solarValues.vPVPrice,
		selfConsumption: this.solarForm.vSelfConsumption.disabled ? undefined : this.solarValues.econKPISelfConsumption
		});
		this.solarSystem = system;
		console.log(system.systemSize);
        this.solarValues.vSystemSize = system.systemSize;
        this.solarValues.vPVPrice = system.pvPrice;
        this.solarValues.vProduction = system.pvYield;
        this.solarValues.econKPISelfConsumption = system.selfConsumptionFraction;
		//console.log(system);
        if (updateCharts) {
          this.doUpdateCharts(system);
        }
		//irr_year
		//this.
		//this.$root.$refs.SolarMap
		//this.$root.$refs.SolarMap.origo.api().getLayer('solarmap_herrhagen').getSource().getFeatureById('solarmap_herrhagen.1047').set('trams', '88');
		//console.log('system');
		//console.log(system);
		system.roofs.forEach(element => {
		//console.log(element);
		this.$root.$refs.SolarMap.origo2.api().getLayer('Vektorlager').getSource().getFeatureById(element.id).set('trams', Math.round(element.quote *100) + '% / ' + (element.size ? element.size : '-') + 'kW');
		});
		//this.$root.$refs.SolarMap.origo.api().getLayer('solarmap_herrhagen').getSource().getFeatureById('solarmap_herrhagen.1047').set('trams', '88')
		
		
		  this.setStateUrl();
      },
      onReset(event) {
        event.preventDefault()
          // Reset our form values
        this.form.email = ''
        this.form.name = ''
        this.form.food = null
        this.form.checked = []
          // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
      onChange(event) {
        event.preventDefault();
      },
      doUpdateCharts(system) {
//console.log("updates charts");
        this.chartDataset = [{
          label: 'Förbrukning',
          backgroundColor: '#8D2927',
          data: system.loadDistribution,
          stack: 'Consumption'
        }, {
          label: 'Egenanvändning',
          backgroundColor: '#D0661C',
          data: system.selfConsumptionDistribution,
          stack: 'Production'
        }, {
          label: 'Såld el',
          backgroundColor: '#F2CB13',
          data: system.overProductionDistribution,
          stack: 'Production'
        }]
        this.datacollection = {
          labels: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
          datasets: this.chartDataset,
          options: {
            scales: {
              yAxes: [{
                ticks: {
							callback: function(value) {
                        return value + ' kWh';
                    },
                  beginAtZero: true
					}
              }]
            },
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index] + ' kWh'; },
						label: function(tooltipItems) {
							return tooltipItems.yLabel + ' kWh';
						}
					}
				},
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }

        }
	  if(this.solarSystems[this.solarSystems.length - 1].maxSystemSize > 0 && this.solarSystems[this.solarSystems.length - 1].maxSystemSize <= 25){
	  var maxSize = this.solarSystems[this.solarSystems.length - 1].maxSystemSize || 25;
	  } else {
	  var maxSize = 25;
	  }
	  var chartData = {}
        chartData.labels = [];
        chartData.datasets = [{}, {}];
        chartData.datasets[0].data = [];
        chartData.datasets[0].pointStyle = [];
        chartData.datasets[1].data = [];
        chartData.datasets[0].pointRadius = [];
        chartData.datasets[1].pointRadius = [];
		
	  var fraction = 1;
	  if(!this.solarForm.vPVPrice.disabled){
	  var calculatedPrice = this.getPvPrice(this.solarValues.vSystemSize);
	  var inputPrice = this.solarValues.vPVPrice;
	  fraction = inputPrice / calculatedPrice;
	  }
	  
        for (var i = 1; i <= Math.ceil(maxSize); (i = i + 0.5)) {
 //       for (var i = 5; i <= 5; (i = i + 1)) {
		  var testSystemSize = i;
		var testSystem = this.getSystem({
		size: testSystemSize,
		production: this.solarForm.vProduction.disabled ? undefined : this.solarValues.vProduction,
		//price: this.solarForm.vPVPrice.disabled ? undefined : this.solarValues.vPVPrice,
		price: {price: this.solarForm.vPVPrice, fraction: fraction},
		selfConsumption: this.solarForm.vSelfConsumption.disabled ? undefined : this.solarValues.econKPISelfConsumption
		
		});
          chartData.labels.push(i);
         chartData.datasets[0].data.push(testSystem.kpiNominalIrr);
          chartData.datasets[1].data.push(testSystem.kpiPaybackTime);
          chartData.datasets[0].pointStyle.push('point');
          chartData.datasets[0].pointRadius.push(3);
        }
        var optimalSizeIndex = chartData.datasets[0].data.indexOf(Math.max.apply(Math, chartData.datasets[0].data));
        var shortestPayback = chartData.datasets[1].data.indexOf(Math.min.apply(Math, chartData.datasets[1].data.filter(n => !isNaN(n))));
        chartData.datasets[0].pointRadius[optimalSizeIndex] = 6;
        chartData.datasets[1].pointRadius[shortestPayback] = 6;
	//console.log(this);
        this.irrChartData = {
          labels: chartData.labels,
          datasets: [
		  /*{
            label: 'Internränta',
            yAxisID: 'IRR',
            backgroundColor: this.$refs.nonsense.gradient,
            borderColor: '#555555',
            pointBackgroundColor: 'white',
            pointStyle: chartData.datasets[0].pointStyle,
            borderWidth: 1,
            pointBorderColor: 'rgba(25, 135, 84, 1)',
            pointBorderWidth: 3,
            pointRadius: chartData.datasets[0].pointRadius,
            data: chartData.datasets[0].data
          }, 
		  */
		  {
            label: 'Återbet.tid',
            yAxisID: 'payback',
            backgroundColor: this.$refs.nonsense.gradient2,
            borderColor: '#555555',
            pointBackgroundColor: 'white',
            pointStyle: [],
            borderWidth: 1,
            pointBorderColor: 'rgba(204, 0, 3, 1)',
            pointBorderWidth: 3,
            pointRadius: chartData.datasets[1].pointRadius,
            data: chartData.datasets[1].data
          }],
          options: {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }
        };
		
      },
      validateState(name) {
        const {
          $dirty, $error
        } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      validateForm(name) {
        const {
          $dirty, $error
        } = this.$v.solarValues[name];
        return $dirty ? !$error : null;
      },
      validateTooltip(name) {
        const {
          $error
        } = this.$v.solarValues[name];
        return $error;
      },
      validateTooltipState(name) {
        const {
          $error
        } = this.$v.form[name];
        return $error;
      },
      resetForm() {
        this.form = {
          name: null,
          food: null
        };

        this.$nextTick(() => {
          this.$v.$reset();
        });
      },
      onSubmit() {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }

        alert("Form submitted!");
      },
      setSolarValue() {
        console.log(this);
      },
      fillData() {},
      loadData() {
              this.solarSystems = [];
	             var toClone = this.$root.$refs.SolarMap.roofs;
				 console.log(toClone);
              var roofs = [...toClone].sort(function(a, b) {
                return a.irr_year - b.irr_year;
              }).reverse();
	
              var system = 1;
              if (roofs.length === 2) {

                var area1 = roofs[0].area_slope / (roofs[0].area_slope + roofs[1].area_slope);
                var area2 = roofs[1].area_slope / (roofs[0].area_slope + roofs[1].area_slope);

                var sum = Object.keys(roofs[0])
                  .reduce(function(obj, k) {
                    if (k.includes("irr")) {
                      obj[k] = (obj[k] || 0) * area2 + roofs[0][k] * area1;
                    } else {
                      obj[k] = (obj[k] || 0) + roofs[0][k];
                    }
                    return obj;
                  }, Object.assign({}, roofs[1]))
                roofs[2] = sum;

              } else if (roofs.length === 3) {

                var area1 = roofs[0].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope);
                var area2 = roofs[1].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope);
                var area3 = roofs[2].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope);

                var sum = Object.keys(roofs[0])
                  .reduce(function(obj, k) {
                    if (k.includes("irr")) {
                      obj[k] = (obj[k] || 0) * (roofs[1].area_slope / (roofs[0].area_slope + roofs[1].area_slope)) + roofs[0][k] * (roofs[0].area_slope / (roofs[0].area_slope + roofs[1].area_slope));
                    } else {
                      obj[k] = (obj[k] || 0) + roofs[0][k];
                    }
                    return obj;
                  }, Object.assign({}, roofs[1]))
                roofs[3] = sum;

                sum = Object.keys(roofs[0])
                  .reduce(function(obj, k) {
                    if (k.includes("irr")) {
                      obj[k] = (obj[k] || 0) * (roofs[2].area_slope / (roofs[0].area_slope + roofs[2].area_slope)) + roofs[0][k] * (roofs[0].area_slope / (roofs[0].area_slope + roofs[2].area_slope));
                    } else {
                      obj[k] = (obj[k] || 0) + roofs[0][k];
                    }
                    return obj;
                  }, Object.assign({}, roofs[2]))
                roofs[4] = sum;

                sum = Object.keys(roofs[1])
                  .reduce(function(obj, k) {
                    if (k.includes("irr")) {
                      obj[k] = (obj[k] || 0) * (roofs[2].area_slope / (roofs[1].area_slope + roofs[2].area_slope)) + roofs[1][k] * (roofs[1].area_slope / (roofs[2].area_slope + roofs[1].area_slope));
                    } else {
                      obj[k] = (obj[k] || 0) + roofs[1][k];
                    }
                    return obj;
                  }, Object.assign({}, roofs[2]))
                roofs[5] = sum;

                sum = Object.keys(roofs[0])
                  .reduce(function(obj, k) {
                    if (k.includes("irr")) {
                      obj[k] = (obj[k] || 0) * (roofs[2].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope)) + roofs[1][k] * (roofs[1].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope)) + roofs[0][k] * (roofs[0].area_slope / (roofs[0].area_slope + roofs[1].area_slope + roofs[2].area_slope));
                    } else {
                      obj[k] = (obj[k] || 0) + roofs[1][k] + roofs[0][k];
                    }
                    return obj;
                  }, Object.assign({}, roofs[2]))
                roofs[6] = sum;
              }	
	
	roofs.forEach((roof, index) => {
			var jsonObject = roofs[index];
			//console.log(jsonObject);
			var irrArray = [jsonObject.irr_01 || 0, jsonObject.irr_02 || 0, jsonObject.irr_03 || 0,
			jsonObject.irr_04 || 0, jsonObject.irr_05 || 0, jsonObject.irr_06 || 0, jsonObject.irr_07 || 0, jsonObject.irr_04 || 0,
			jsonObject.irr_09 || 0, jsonObject.irr_10 || 0, jsonObject.irr_11 || 0, jsonObject.irr_12 || 0
			];
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
			roofs[index].irrArray = irrArray;
			roofs[index].irrArrayQ = irrArray.map(x => x / sum);
			roofs[index].irrYear = Math.round(sum);
			roofs[index].production = this.getPvYield(roofs[index].irrYear);
			roofs[index].roofArea = jsonObject.area_slope;
			roofs[index].maxSystemSize = parseFloat(this.getMaxSystemSize(roofs[index].roofArea));
			roofs[index].systemSize = parseFloat(this.getMaxSystemSize(roofs[index].roofArea));
			roofs[index].maxPvYieldArray = this.getPvYieldArray(roofs[index].production, roofs[index].maxSystemSize);
                roofs[index].system = system;
                system++;
				this.solarSystems[index] = this.calculateSystem(roofs[index]);
			});
			//console.log(this.$root.$refs.SolarMap.roofs);
			//console.log(this.solarSystems);
			
              var maxIRR = Math.max.apply(Math, this.solarSystems.map(function(o) {
                return o.kpiNominalIrr;
              }))
              var maxSF = Math.max.apply(Math, this.solarSystems.map(function(o) {
                return o.kpiSolarFraction;
              }))
              //console.log(this.solarSystems);
              this.solarSystems.forEach(obj => obj.score = ((obj.kpiNominalIrr / maxIRR) * 0.5 + (obj.kpiSolarFraction / maxSF) * 0.5));
              //console.log(this.solarSystems);
       /* this.irrChartData = {
          labels: [],
          datasets: [{
            label: 'IRR',
            yAxisID: 'IRR',
          //  backgroundColor: this.$refs.nonsense.gradient,
            borderColor: '#777777',
            pointBackgroundColor: 'white',
            pointStyle: [],
            borderWidth: 1,
            pointBorderColor: 'rgba(0, 200, 0, 0.9)',
            pointBorderWidth: 3,
            pointRadius: [],
            data: []
          }, {
            label: 'Payback',
            yAxisID: 'payback',
           // backgroundColor: this.$refs.nonsense.gradient2,
            borderColor: '#777777',
            pointBackgroundColor: 'white',
            pointStyle: [],
            borderWidth: 1,
            pointBorderColor: 'rgba(200, 0, 0, 0.9)',
            pointBorderWidth: 3,
            pointRadius: [],
            data: []
          }],
          options: {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }
        };
       this.chartDataset = [{
          label: 'Förbrukning',
          backgroundColor: '#f87979',
          data: [],
          stack: 'Consumption'
        }, {
          label: 'Egenanvändning',
          backgroundColor: '#1EFFFF',
          data: [],
          stack: 'Production'
        }, {
          label: 'Såld el',
          backgroundColor: '#3D5B96',
          data: [],
          stack: 'Production'
        }]
        this.datacollection = {
          labels: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
          datasets: this.chartDataset,
          options: {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }

        }*/
			 this.setOptimalSystem();
			 
			// console.log(this.irrChartData);
			 
 
		//this.doUpdateCharts(this.optimalSystem);
		
       // this.socketish();
      },
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },

      funcMonthlyDemand() {
        /*
        var array[0.14, 0.12, 0.12, 0.10, 0.06, 0.04, 0.03, 0.03, 0.05, 0.08, 0.10, 0.13];
        const map1 = array1.map(x => x * 2);
        */
        //return false;
        return this.solarValues.userMonDemand();
      },
	  
	   getNominalDiscountRate() {
		 // console.log(this);
            return (Math.round(((1 + this.solarValues.vDiscountRate) * (1 + this.solarConstants.econDefInflationRate) - 1) * 1000) / 10)
          }, // Discount Rate (%)

      funcMaxSystemSize() {
        /*
        Uses basic info about the PV system and roof to determine what is the largest possible PV system 
        that could fit in terms of rated kW. This sets the upper limit for the parametric optimization.

        Outputs Single value for Maximum System Size (kWp) - Π_STC
        */
        var size = this.solarValues.userRoofArea * this.solarConstants.techStandardIrradiation / 1000 * this.solarConstants.techDefModuleEff * this.solarConstants.techRoofFraction;
        console.log(this.solarValues.userRoofArea);
        console.log(this.solarConstants.techStandardIrradiation);
        console.log(this.solarConstants.techDefModuleEff);
        console.log(this.solarConstants.techRoofFraction);
        return size.toFixed(1);
      },

      getMaxSystemSize(roofArea) {
        /*
        Uses basic info about the PV system and roof to determine what is the largest possible PV system 
        that could fit in terms of rated kW. This sets the upper limit for the parametric optimization.

        Outputs Single value for Maximum System Size (kWp) - Π_STC
        */
        var size = roofArea * this.solarConstants.techStandardIrradiation / 1000 * this.solarConstants.techDefModuleEff * this.solarConstants.techRoofFraction;
        return size.toFixed(1);
      },

      funcMaxRoofArea() {
        /*
         */
        var size = this.solarValues.userRoofArea * this.solarConstants.techRoofFraction;
        return size.toFixed(1);
      },

      getMaxRoofArea(roofArea) {
        /*
         */
        var size = roofArea * this.solarConstants.techRoofFraction;
        return size.toFixed(1);
      },

      funcPvYield() {
        /*
        This is the specific annual generation that can produced on a given roof with 1 kWp. Using this value 
        allows us to scale the PV system size as needed for any part of the analysis.
        Single value for PV yield (kWh/kWp/yr) - Y_(PV,0)
        */

        var pvPower = this.solarConstants.techStandardIrradiation * this.solarConstants.techDefModuleEff / 1000; // 150
        var annualYield = (this.solarValues.userIrrYear * this.solarConstants.techDefModuleEff * this.solarConstants.techDefSysEff * (1 - this.solarConstants.techDefLocalLosses)) / pvPower;
        return Math.round(annualYield); // Should be around 1000
        console.log(this.solarValues.userIrrYear);
        console.log(this.solarConstants.techDefModuleEff);
        console.log(this.solarConstants.techDefSysEff);
        console.log((1 - this.solarConstants.techDefLocalLosses));
        console.log(Math.round(this.solarValues.userIrrYear * this.solarConstants.techDefModuleEff * this.solarConstants.techDefSysEff * (1 - this.solarConstants.techDefLocalLosses)));
        return Math.round(this.solarValues.userIrrYear * this.solarConstants.techDefModuleEff * this.solarConstants.techDefSysEff * (1 - this.solarConstants.techDefLocalLosses)); // Should be around 1000
      },

      getPvYield(irrYear) {
        /*
        This is the specific annual generation that can produced on a given roof with 1 kWp. Using this value 
        allows us to scale the PV system size as needed for any part of the analysis.
        Single value for PV yield (kWh/kWp/yr) - Y_(PV,0)
        */

        var pvPower = this.solarConstants.techStandardIrradiation * this.solarConstants.techDefModuleEff / 1000; // 150
        var annualYield = (irrYear * this.solarConstants.techDefModuleEff * this.solarConstants.techDefSysEff * (1 - this.solarConstants.techDefLocalLosses)) / pvPower;
        return Math.round(annualYield); // Should be around 1000
      },

      funcPVPrice() {
        /*

        */

        return Math.round((8.6 + 15.9 * this.solarValues['vSystemSize'] ** (-0.55)) * (1 + this.solarConstants.econVAT) * 10) * 100; // 
      },

      getPvPrice(systemSize) {
        /*

        */

        return Math.round((8.6 + 15.9 * systemSize ** (-0.55)) * (1 + this.solarConstants.econVAT) * 10) * 100; // 
      },

      funcSystemPvYield() { // First years production
        return Math.round(this.solarValues.vProduction * this.solarValues.vSystemSize / 100) * 100;
      },

      getSystemPvYield(production, systemSize) { // First years production
        return Math.round(this.solarValues.vProduction * this.solarValues.vSystemSize / 100) * 100;
      },

      funcPvLifetime() {
        /*
        PV modules degrade over time, so this function takes the year one generation (single value) and turns it 
        into an array/vector of generation values for the lifetime of the system.
        Array/vector of annual PV generation for the lifetime (kWh/yr) - □((E_PV ) ⃗ )
        */
        var array = [];
        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          array.push(this.solarValues.vProduction * (Math.pow(1 - this.solarValues.vPvDegrad, i)) * this.solarValues.vSystemSize)
        }
		
        console.log(this.solarValues.vProduction);
        console.log(this.solarValues.vSystemSize);
        console.log(array);
        return array;
      },

      getPvYieldArray(production, systemSize) {
        /*
        PV modules degrade over time, so this function takes the year one generation (single value) and turns it 
        into an array/vector of generation values for the lifetime of the system.
        Array/vector of annual PV generation for the lifetime (kWh/yr) - □((E_PV ) ⃗ )
        */
        var array = [];
        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          array.push(production * (Math.pow(1 - this.solarValues.vPvDegrad, i)) * systemSize)
        }
		
        return array;
      },

      funcSelfConsumption() {
        /*
        A polynomial regression model is used to convert several key parameters of the PV system and house into a self-consumption 
        value for each year of the PV system’s lifetime.
        Array of PV self-consumption for the system lifetime (kWh/yr) - (E_SC ) ⃗
        Array of PV overproduction for the system lifetime (kWh/yr) - (E_OP ) ⃗
        */
        //console.log("SC!");
        // https://gi.karlstad.se/api/pvselfconsumption?load=510000&yield=540000&lat=59.4
        var selfConsumption = this.solarValues.outPVYieldArray.map(x => x * this.solarValues.econKPISelfConsumption / 100); //Self-consumption
        var overproduction = this.solarValues.outPVYieldArray.map(x => x * (1 - this.solarValues.econKPISelfConsumption / 100)); //Overproduction
        //const response = await fetch('https://gi.karlstad.se/api/pvselfconsumption?load=510000&yield=540000&lat=59.4');
        //console.log(response.json());
        /*await fetch('https://gi.karlstad.se/api/pvselfconsumption?load=510000&yield=540000&lat=59.4')
          .then(response => response.json())
          .then(data => console.log(data));*/
        // econKPISelfConsumption
        //console.log("A");
        //console.log(selfConsumption);
        return {
          selfConsumption, overproduction
        };
      },

      getSelfConsumptionArray(pvYieldArray, selfConsumptionFraction) {
        /*
        A polynomial regression model is used to convert several key parameters of the PV system and house into a self-consumption 
        value for each year of the PV system’s lifetime.
        Array of PV self-consumption for the system lifetime (kWh/yr) - (E_SC ) ⃗
        Array of PV overproduction for the system lifetime (kWh/yr) - (E_OP ) ⃗
        */
        var selfConsumption = pvYieldArray.map(x => x * selfConsumptionFraction / 100); //Self-consumption
        var overproduction = pvYieldArray.map(x => x * (1 - selfConsumptionFraction / 100)); //Overproduction
        return {
          selfConsumption, overproduction
        };
      },

      funcSelfConsumptionPolynomial() {
        /*
        A polynomial regression model is used to convert several key parameters of the PV system and house into a self-consumption 
        value for each year of the PV system’s lifetime.
        Array of PV self-consumption for the system lifetime (kWh/yr) - (E_SC ) ⃗
        Array of PV overproduction for the system lifetime (kWh/yr) - (E_OP ) ⃗
        */
        var a = this.solarValues.vAnnualDemand;
        var b = this.solarValues.outPVYieldArray[0];
        var c = 58;
        var annual_SC = 0.6286327937737457 + 3.55080846e-08 * a + -6.44122666e-08 * b + -4.03518201e-07 * c + -3.48986799e-16 * a ** 2 + -2.42141369e-16 * a * b + -6.96671160e-11 * a * c + 1.42085112e-15 * b ** 2 + 4.78724507e-11 * b * c + -4.73073580e-05 * c ** 2

        return annual_SC > 1 ? 1 : annual_SC;
      },

      funcLifetimeRetailPrices() {
        /*
        Using the input price (representing the price today) and the expected change in price over time, 
        a vector matching the system lifetime length is generated.
        Array/vector of retail prices for system lifetime (kr/kWh) - (P_r ) ⃗
        */
        var array = [];
        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          array.push(this.solarValues.vRetailPrice * (Math.pow(1 + (this.solarValues.vRetailPriceInc / 100), i)))
        }
        return array;
      },

      getLifetimeRetailPrices() {
        /*
        Using the input price (representing the price today) and the expected change in price over time, 
        a vector matching the system lifetime length is generated.
        Array/vector of retail prices for system lifetime (kr/kWh) - (P_r ) ⃗
        */
        var array = [];
        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          array.push(this.solarValues.vRetailPrice * (Math.pow(1 + (this.solarValues.vRetailPriceInc / 100), i)))
        }
        return array;
      },


      funcLifetimeGridSalePrices() {
        /*
        Combines all of the possible ways of generating income from grid sales into a single vector/array of 
        prices for the lifetime of the system.
        Array of grid sale prices for system lifetime (kr/kWh) - (P_s ) ⃗
        */
        var npSpot = [];
        var go = [];
        var elCert = [];
        var mtc = [];

        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          npSpot.push(this.solarValues.vSpotPrice * (Math.pow(1 + (this.solarValues.vSpotPriceInc / 100), i)));
          //go.push(this.solarConstants.econDefGOPrice || 0);
          go.push(this.solarValues.vGoPrice || 0);
        }
        //for (i = 0; i < this.solarConstants.econDefMTCLifetime; i++) {
        for (i = 0; i < this.solarValues.vMtcLifetime; i++) {
          mtc.push(this.solarConstants.econDefMTCPrice || 0);
        }
        for (i = 0; i < this.solarConstants.econDefElcertLifetime; i++) {
          elCert.push(this.solarValues.vElcertPrice || 0);
        }

        return {
          npSpot, go, elCert, mtc
        };
      },


      getLifetimeGridSalePrices() {
        /*
        Combines all of the possible ways of generating income from grid sales into a single vector/array of 
        prices for the lifetime of the system.
        Array of grid sale prices for system lifetime (kr/kWh) - (P_s ) ⃗
        */
        var npSpot = [];
        var go = [];
        var elCert = [];
        var mtc = [];

        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          npSpot.push(this.solarValues.vSpotPrice * (Math.pow(1 + (this.solarValues.vSpotPriceInc / 100), i)));
          //go.push(this.solarConstants.econDefGOPrice || 0);
          go.push(this.solarValues.vGoPrice || 0);
        }
       // for (i = 0; i < this.solarConstants.econDefMTCLifetime; i++) {
        for (i = 0; i < this.solarValues.vMtcLifetime; i++) {
          mtc.push(this.solarConstants.econDefMTCPrice || 0);
        }
        for (i = 0; i < this.solarConstants.econDefElcertLifetime; i++) {
          elCert.push(this.solarValues.vElcertPrice || 0);
          //elCert.push(this.solarConstants.econDefElcertPrice || 0);
        }

        return {
          npSpot, go, elCert, mtc
        };
      },


      funcValueOfSavings() {
        /*
        Single function to describe the simple multiplication of generation (kWh/yr) by prices (kr/kWh). 
        Applies to self-consumption ((E_SC ) ⃗) and overproduction ((E_OP ) ⃗) vectors.
        Array of annual savings/revenues for the system lifetime (kr/yr) - V ⃗
        */
        var retailPrices = this.getLifetimeRetailPrices();
        var gridSalePrices = this.getLifetimeGridSalePrices();
        var sc = this.solarValues.econSelfConsumption.selfConsumption;
        var op = this.solarValues.econSelfConsumption.overproduction;
        var vAnnualDemand = this.solarValues.vAnnualDemand;

        //This needs some work, only up to max comsumption gets mtc, maximum 18000kr/year

        var selfConsumptionValue = sc.map(function(x, index) {
          return retailPrices[index] * x
        });

        var overproductionValue = op.map(function(x, index) {
          var opMtc = vAnnualDemand - sc[index] > 0 ? vAnnualDemand - sc[index] : 0;
          var xMtc = x > opMtc ? opMtc : x;
          return (gridSalePrices.elCert[index] || 0) * x + // Skip this unless >200kr/year? Should also remove 200kr/year
            (gridSalePrices.go[index] || 0) * x +
            (gridSalePrices.mtc[index] || 0) * xMtc +
            (gridSalePrices.npSpot[index] || 0) * x;
        });

        return {
          selfConsumptionValue, overproductionValue
        };
      },


      getValueOfSavings(econSelfConsumption) {
        /*
        Single function to describe the simple multiplication of generation (kWh/yr) by prices (kr/kWh). 
        Applies to self-consumption ((E_SC ) ⃗) and overproduction ((E_OP ) ⃗) vectors.
        Array of annual savings/revenues for the system lifetime (kr/yr) - V ⃗
        */
        //this.solarValues.outLifetimeRetailPrices = this.funcLifetimeRetailPrices();
        //this.solarValues.outLifetimeGridSalePrices = this.funcLifetimeGridSalePrices();
        var retailPrices = this.getLifetimeRetailPrices();
        var gridSalePrices = this.getLifetimeGridSalePrices();
        var sc = econSelfConsumption.selfConsumption;
        var op = econSelfConsumption.overproduction;
        var vAnnualDemand = this.solarValues.vAnnualDemand;
        //This needs some work, only up to max comsumption gets mtc, maximum 18000kr/year

        var selfConsumptionValue = sc.map(function(x, index) {
          return retailPrices[index] * x
        });

        var overproductionValue = op.map(function(x, index) {
          var opMtc = vAnnualDemand - sc[index] > 0 ? vAnnualDemand - sc[index] : 0;
          var xMtc = x > opMtc ? opMtc : x;
          return (gridSalePrices.elCert[index] || 0) * x + // Skip this unless >200kr/year? Should also remove 200kr/year
            (gridSalePrices.go[index] || 0) * x +
            (gridSalePrices.mtc[index] || 0) * xMtc +
            (gridSalePrices.npSpot[index] || 0) * x;
        });

        return {
          selfConsumptionValue, overproductionValue
        };
      },


      funcPVInvestment() {
        /*
        Uses default inputs and the size of the PV system to return a total investment cost
        Total investment for the PV system (kr) - C_0
        */
        this.solarValues.outPVInvestmentExclVAT = Math.round(this.solarValues.vSystemSize * this.solarValues.vPVPrice / (1 + this.solarConstants.econVAT) / 100) * 100;
        this.solarValues.outPVInvestmentExclRebates = Math.round(this.solarValues.vSystemSize * this.solarValues.vPVPrice / 100) * 100;
        return Math.round((this.solarValues.vSystemSize * this.solarValues.vPVPrice * ((100 - this.solarValues.vRebates) / 100)) / 100) * 100;
      },


      getPvInvestment(systemSize, pvPrice) {
        /*
        Uses default inputs and the size of the PV system to return a total investment cost
        Total investment for the PV system (kr) - C_0
        */
        return {
		  outPvInvestmentExclVat: Math.round(systemSize * pvPrice / (1 + this.solarConstants.econVAT) / 100) * 100,
		  outPvInvestmentExclRebates: Math.round(systemSize * pvPrice / 100) * 100,
		  outPvInvestment: 	Math.round((systemSize * pvPrice * ((100 - this.solarValues.vRebates) / 100)) / 100) * 100
		}
      },


      funcOMCost() {
        /*
        Uses the total investment cost and a fixed percentage to return annual operations and 
        maintenance costs for use in the cash flows.
        O&M Cost (kr) - C_OM
        */

        //return this.solarValues.vSystemSize * this.solarValues.vPVPrice * this.solarConstants.econDefOMCost;
        return this.solarValues.vSystemSize * this.solarValues.vPVPrice * this.solarValues.vOmCost;
      },


      getOMCost(systemSize, pvPrice) {
        /*
        Uses the total investment cost and a fixed percentage to return annual operations and 
        maintenance costs for use in the cash flows.
        O&M Cost (kr) - C_OM
        */

        //return systemSize * pvPrice * this.solarConstants.econDefOMCost;
        return systemSize * pvPrice * this.solarValues.vOmCost;
      },


      funcCashFlow() {
        /*
        No actual calculations to be made here, it is just reorganizing all of the costs and 
        benefits into a single cash flow array. It could be more effective to combine the PV 
        investment, O&M cost, and value of savings/sales functions into a single function that 
        returns the cash flow array. This array is the basis for all economic indicators.
        Cash flow array
        */
        var cashFlowArray = [];
        var gridSalePrices = this.getLifetimeGridSalePrices();
        var valueOfSavings = this.solarValues.econValueOfSavings.selfConsumptionValue;
        var op = this.solarValues.econSelfConsumption.overproduction;
        var sc = this.solarValues.econSelfConsumption.selfConsumption;
        var vAnnualDemand = this.solarValues.vAnnualDemand;

        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          var obj = {};
          var opMtc = vAnnualDemand - sc[i] > 0 ? vAnnualDemand - sc[i] : 0;
          var xMtc = op[i] > opMtc ? opMtc : op[i];
          var investment = i === 0 ? this.solarValues.outPVInvestment : 0;
          obj.costs = {
            'investments': investment,
            'om': this.funcOMCost()
          };
          obj.benefits = {
            'valueOfSavings': valueOfSavings[i] || 0,
            'valueOfGridSales': {
              'npSpot': (gridSalePrices['npSpot'][i] || 0) * op[i],
              'go': (gridSalePrices['go'][i] || 0) * op[i],
              'elCert': (gridSalePrices['elCert'][i] || 0) * op[i],
              'mtc': (gridSalePrices['mtc'][i] || 0) * xMtc
            }
          };
          const sumCosts = Object.values(obj.costs).reduce((a, b) => a + b);
          const sumBenefits = obj.benefits.valueOfSavings + Object.values(obj.benefits.valueOfGridSales).reduce((a, b) => a + b);
          const netCashFlow = sumBenefits - sumCosts;
          const cumulativeCashFlow = i === 0 ? netCashFlow : netCashFlow + cashFlowArray[i - 1].totals.cumulativeCashFlow
          obj.totals = {
            'costs': sumCosts,
            'benefits': sumBenefits,
            netCashFlow,
            cumulativeCashFlow
          }
          cashFlowArray.push(obj);
        }
        //console.log(cashFlowArray)
        return cashFlowArray;
      },


      getCashFlow(valueOfSavings, selfConsumptionArray, pvInvestment, systemSize, pvPrice) {
        /*
        No actual calculations to be made here, it is just reorganizing all of the costs and 
        benefits into a single cash flow array. It could be more effective to combine the PV 
        investment, O&M cost, and value of savings/sales functions into a single function that 
        returns the cash flow array. This array is the basis for all economic indicators.
        Cash flow array
        */
        var cashFlowArray = [];
        var gridSalePrices = this.getLifetimeGridSalePrices();
        var valueOfSavings = valueOfSavings.selfConsumptionValue;
        var op = selfConsumptionArray.overproduction;
        var sc = selfConsumptionArray.selfConsumption;
        var vAnnualDemand = this.solarValues.vAnnualDemand;
		var inflationRate = this.solarConstants.econDefInflationRate;

        for (var i = 0; i < this.solarValues.vLifelength; i++) {
          var obj = {};
          var opMtc = vAnnualDemand - sc[i] > 0 ? vAnnualDemand - sc[i] : 0;
          var xMtc = op[i] > opMtc ? opMtc : op[i];
          var investment = i === 0 ? pvInvestment.outPvInvestment : 0;
          obj.costs = {
            'investments': investment,
            'om': this.getOMCost(systemSize, pvPrice)
          };
          obj.benefits = {
            'valueOfSavings': valueOfSavings[i] || 0,
            'valueOfGridSales': {
              'npSpot': (gridSalePrices['npSpot'][i] || 0) * op[i],
              'go': (gridSalePrices['go'][i] || 0) * op[i],
              'elCert': (gridSalePrices['elCert'][i] || 0) * op[i],
              'mtc': (gridSalePrices['mtc'][i] || 0) * xMtc
            }
          };
          const sumCosts = Object.values(obj.costs).reduce((a, b) => a + b);
          const sumBenefits = obj.benefits.valueOfSavings + Object.values(obj.benefits.valueOfGridSales).reduce((a, b) => a + b);
          const netCashFlow = sumBenefits - sumCosts;
          const cumulativeCashFlow = i === 0 ? netCashFlow : netCashFlow + cashFlowArray[i - 1].totals.cumulativeCashFlow;
          const cumulativeCashFlowNominal = i === 0 ? netCashFlow : netCashFlow * ((1 + inflationRate) ** (i + 1)) + cashFlowArray[i - 1].totals.cumulativeCashFlowNominal;
          obj.totals = {
            'costs': sumCosts,
            'benefits': sumBenefits,
            netCashFlow,
            cumulativeCashFlow,
			cumulativeCashFlowNominal
          }
          cashFlowArray.push(obj);
        }
        //console.log(cashFlowArray)
        return cashFlowArray;
      },


      funcDiscountedCashFlow() {
        /*
        Convert the cash flow array into discounted cash flow
        Discounted cash flow array with same dimensions as cash flow array
        */
        var cf = this.solarValues.econCashFlow;
        var rate = Number(this.solarValues.vDiscountRate);

        function discount(x, y) {
          return x / ((1 + rate) ** (y + 1));
        }
        var cumulative = 0;
        var discountedCashFlow = cf.map(function(x, index) {
          if (index === 0) {
            cumulative = discount(x.totals.benefits, index) - (x.costs.investments + discount(x.costs.om, index));
            return ({
              costs: {
                investments: x.costs.investments,
                om: discount(x.costs.om, index)
              },
              benefits: {
                valueOfSavings: discount(x.benefits.valueOfSavings, index),
                valueOfGridSales: {
                  npSpot: discount(x.benefits.valueOfGridSales.npSpot, index),
                  go: discount(x.benefits.valueOfGridSales.go, index),
                  elCert: discount(x.benefits.valueOfGridSales.elCert, index),
                  mtc: discount(x.benefits.valueOfGridSales.mtc, index)
                }
              },
              totals: {
                costs: x.costs.investments + discount(x.costs.om, index),
                benefits: discount(x.totals.benefits, index),
                netCashFlow: discount(x.totals.benefits, index) - (x.costs.investments + discount(x.costs.om, index)),
                cumulativeCashFlow: cumulative
              }
            });
          } else {
            cumulative = cumulative + discount(x.totals.netCashFlow, index);
            return ({
              costs: {
                investments: discount(x.costs.investments, index),
                om: discount(x.costs.om, index)
              },
              benefits: {
                valueOfSavings: discount(x.benefits.valueOfSavings, index),
                valueOfGridSales: {
                  npSpot: discount(x.benefits.valueOfGridSales.npSpot, index),
                  go: discount(x.benefits.valueOfGridSales.go, index),
                  elCert: discount(x.benefits.valueOfGridSales.elCert, index),
                  mtc: discount(x.benefits.valueOfGridSales.mtc, index)
                }
              },
              totals: {
                costs: discount(x.totals.costs, index),
                benefits: discount(x.totals.benefits, index),
                netCashFlow: discount(x.totals.netCashFlow, index),
                cumulativeCashFlow: cumulative
              }
            });
          }

        });

        return discountedCashFlow;
      },


      getDiscountedCashFlow(cashFlow) {
        /*
        Convert the cash flow array into discounted cash flow
        Discounted cash flow array with same dimensions as cash flow array
        */
        var cf = cashFlow;
        var rate = Number(this.solarValues.vDiscountRate);

        function discount(x, y) {
          return x / ((1 + rate) ** (y + 1));
        }
        var cumulative = 0;
        var discountedCashFlow = cf.map(function(x, index) {
          if (index === 0) {
            cumulative = discount(x.totals.benefits, index) - (x.costs.investments + discount(x.costs.om, index));
            return ({
              costs: {
                investments: x.costs.investments,
                om: discount(x.costs.om, index)
              },
              benefits: {
                valueOfSavings: discount(x.benefits.valueOfSavings, index),
                valueOfGridSales: {
                  npSpot: discount(x.benefits.valueOfGridSales.npSpot, index),
                  go: discount(x.benefits.valueOfGridSales.go, index),
                  elCert: discount(x.benefits.valueOfGridSales.elCert, index),
                  mtc: discount(x.benefits.valueOfGridSales.mtc, index)
                }
              },
              totals: {
                costs: x.costs.investments + discount(x.costs.om, index),
                benefits: discount(x.totals.benefits, index),
                netCashFlow: discount(x.totals.benefits, index) - (x.costs.investments + discount(x.costs.om, index)),
                cumulativeCashFlow: cumulative
              }
            });
          } else {
            cumulative = cumulative + discount(x.totals.netCashFlow, index);
            return ({
              costs: {
                investments: discount(x.costs.investments, index),
                om: discount(x.costs.om, index)
              },
              benefits: {
                valueOfSavings: discount(x.benefits.valueOfSavings, index),
                valueOfGridSales: {
                  npSpot: discount(x.benefits.valueOfGridSales.npSpot, index),
                  go: discount(x.benefits.valueOfGridSales.go, index),
                  elCert: discount(x.benefits.valueOfGridSales.elCert, index),
                  mtc: discount(x.benefits.valueOfGridSales.mtc, index)
                }
              },
              totals: {
                costs: discount(x.totals.costs, index),
                benefits: discount(x.totals.benefits, index),
                netCashFlow: discount(x.totals.netCashFlow, index),
                cumulativeCashFlow: cumulative
              }
            });
          }

        });

        return discountedCashFlow;
      },

      // Key Performance Indicators

      funcKPISelfConsumption() {
        /*
        Self-consumption is the fraction of PV generation used directly in the building 
        relative to the total generation, most commonly shown as a percentage.
        Self-consumption - SC
        */

        return 0.5;
      },

      funcKPISolarFraction() {
        /*
        Solar Fraction is the fraction of the building’s total load relative to the total PV generation 
        produced on the building’s roof. Most commonly shown as a percentage.
        Solar Fraction - SF
        */

        //return false;
        return this.solarValues.outPVYield / this.solarValues.vAnnualDemand;
      },

      getKpiSolarFraction(pvYieldYearOne) {
        /*
        Solar Fraction is the fraction of the building’s total load relative to the total PV generation 
        produced on the building’s roof. Most commonly shown as a percentage.
        Solar Fraction - SF
        */

        //return false;
        return pvYieldYearOne / this.solarValues.vAnnualDemand;
      },

      funcKPISelfSufficiency() {
        /*
        Self-sufficiency is fraction of the building’s total load covered by solar PV. Therefore, 
        it only includes the self-consumed PV in the numerator. Most commonly shown as a percentage.
        Self-Sufficiency - SS
        */

        return this.solarValues.econKPISelfConsumption * this.funcKPISolarFraction() / 100;
      },

      getKpiSelfSufficiency(selfConsumptionFraction, kpiSolarFraction) {
        /*
        Self-sufficiency is fraction of the building’s total load covered by solar PV. Therefore, 
        it only includes the self-consumed PV in the numerator. Most commonly shown as a percentage.
        Self-Sufficiency - SS
        */

        return selfConsumptionFraction * kpiSolarFraction / 100;
      },

      funcKPIAnnualSavings() {
        /*
        The savings expected once the PV system is installed, represents the reduction in electricity costs 
        for the building owner, but does not include the investment cost needed to realize the savings 
        (for that we look at net savings).
        Annual savings (kr)
        */

        var cf = this.solarValues.econCashFlow;
        const reducer = (accumulator, item) => {
          return accumulator + item.totals.benefits;
        };

        return cf.reduce(reducer, 0) / cf.length;
      },

      funcKPIRevenueSources() {
        /*
        Energimyndigheten’s results show in absolute (kr) and relative (%) terms where all of the economic 
        benefits of a PV come from, which is very educational. This output is just that.
        Array of five revenue sources (savings, market value, elcertifikat, guarantee of origin, MCT) by two formats (kr, %)
        */
        var cf = this.solarValues.econCashFlow;

        var sumBenefits = {
          valueOfSavings: {
            kr: 0,
            percent: 0
          },
          valueOfGridSales: {
            npSpot: {
              kr: 0,
              percent: 0
            },
            go: {
              kr: 0,
              percent: 0
            },
            elCert: {
              kr: 0,
              percent: 0
            },
            mtc: {
              kr: 0,
              percent: 0
            }
          }
        };

        var sum = 0;
        for (var i = 0; i < cf.length; i++) {
          sumBenefits.valueOfSavings.kr += cf[i].benefits.valueOfSavings
          sumBenefits.valueOfGridSales.npSpot.kr += cf[i].benefits.valueOfGridSales.npSpot
          sumBenefits.valueOfGridSales.go.kr += cf[i].benefits.valueOfGridSales.go
          sumBenefits.valueOfGridSales.elCert.kr += cf[i].benefits.valueOfGridSales.elCert
          sumBenefits.valueOfGridSales.mtc.kr += cf[i].benefits.valueOfGridSales.mtc
          sum += (cf[i].totals.benefits)
        }
        sumBenefits.valueOfSavings.percent = sumBenefits.valueOfSavings.kr / sum;
        sumBenefits.valueOfGridSales.npSpot.percent = sumBenefits.valueOfGridSales.npSpot.kr / sum;
        sumBenefits.valueOfGridSales.go.percent = sumBenefits.valueOfGridSales.go.kr / sum;
        sumBenefits.valueOfGridSales.elCert.percent = sumBenefits.valueOfGridSales.elCert.kr / sum;
        sumBenefits.valueOfGridSales.mtc.percent = sumBenefits.valueOfGridSales.mtc.kr / sum;
        return sumBenefits;
      },

      funcKPIPaybackTime() {
        /*
        Also known as simple payback time, it is the number of years of savings required to overcome the initial cost of the PV system.
        Payback time (years) - PBT
        */
        var cf = this.solarValues.econCashFlow;
        var pbt = cf.length + '+';
        for (var i = 0; i < cf.length; i++) {
          if (cf[i].totals.cumulativeCashFlow >= 0) {
            pbt = i + (1 - (Math.round(cf[i].totals.cumulativeCashFlow / cf[i].totals.netCashFlow * 10) / 10));
            return pbt;
          }
        }

        return pbt;
      },

      getKpiPaybackTime(cashFlow) {
        /*
        Also known as simple payback time, it is the number of years of savings required to overcome the initial cost of the PV system.
        Payback time (years) - PBT
        */
        var cf = cashFlow;
        var pbt = cf.length + '+';
		var inflationRate = this.solarConstants.econDefInflationRate;
		
/*        for (var i = 0; i < cf.length; i++) {
          if (cf[i].totals.cumulativeCashFlow >= 0) {
            pbt = i + (1 - (Math.round(cf[i].totals.cumulativeCashFlow / cf[i].totals.netCashFlow * 10) / 10));
            return pbt;
          }
        }
		(cf[i].totals.netCashFlow * ((1 + inflationRate) ** (i + 1)))
*/
        for (var i = 0; i < cf.length; i++) {
          if (cf[i].totals.cumulativeCashFlowNominal >= 0) {
            pbt = i + (1 - (Math.round(cf[i].totals.cumulativeCashFlowNominal / (cf[i].totals.netCashFlow * ((1 + inflationRate) ** (i + 1))) * 10) / 10));
            return pbt;
          }
        }

        return pbt;
      },

      funcKPIDiscountedPaybackTime() {
        /*
        Also known as simple payback time, it is the number of years of savings required to overcome the initial cost of the PV system.
        Payback time (years) - PBT
        */
        var cf = this.solarValues.econDiscountedCashFlow;
        var pbt = cf.length + '+';
        for (var i = 0; i < cf.length; i++) {
          if (cf[i].totals.cumulativeCashFlow >= 0) {
            pbt = i + (1 - (Math.round(cf[i].totals.cumulativeCashFlow / cf[i].totals.netCashFlow * 10) / 10));
            return pbt;
          }
        }

        return pbt;
      },

      getKpiDiscountedPaybackTime(discountedCashFlow) {
        /*
        Also known as simple payback time, it is the number of years of savings required to overcome the initial cost of the PV system.
        Payback time (years) - PBT
        */
        var cf = discountedCashFlow;
        var pbt = cf.length + '+';
        for (var i = 0; i < cf.length; i++) {
          if (cf[i].totals.cumulativeCashFlow >= 0) {
            pbt = i + (1 - (Math.round(cf[i].totals.cumulativeCashFlow / cf[i].totals.netCashFlow * 10) / 10));
            return pbt;
          }
        }

        return pbt;
      },

      funcKPINetSavings() {
        /*
        Effectively identical to Net Present Value except that it does not include discounting.
        Net Savings (kr)
        */
        var cf = this.solarValues.econCashFlow;

        return cf[cf.length - 1].totals.cumulativeCashFlow;
      },


      funcKPIIRR() { // Internal Rate of Return (IRR) aka Return on Investment (ROI)
        /*
        Common investment metric that is equivalent to the discount rate that causes net present value to be zero.
        Internal rate of Return (%) - IRR
        */
        var cf = this.solarValues.econCashFlow;
        var array = [cf[0].totals.benefits - cf[0].costs.om];
        var inv = this.solarValues.outPVInvestment;

        for (var i = 1; i < cf.length; i++) {
          array.push(cf[i].totals.netCashFlow);
        }

        function NPV(discountRate, cashFlow) {
          var npv = 0;
          for (var t = 0; t < cashFlow.length; t++) {
            npv += cashFlow[t] / Math.pow((1 + discountRate), t + 1);
          }
          return npv;
        }

        function IRR(cashFlow, guess) {
          var nnpv = NPV(0, cashFlow);
          var x;
          var guessInc;
          guess = guess ? guess : 0;
          if (nnpv - inv > 0) {
            guessInc = 0.0001;
            x = 1;
          } else {
            guessInc = -0.0001;
            x = -1;
          }
          var cnt = 0;

          do {
            guess = guess + guessInc;
            nnpv = NPV(guess, cashFlow);

            cnt++;
          }
          while ((nnpv - inv) * x > 0 && cnt < 10000)
          return guess;
        }

        return IRR(array);
      },


      getKpiIrr(econCashFlow, pvInvestment) { // Internal Rate of Return (IRR) aka Return on Investment (ROI)
        /*
        Common investment metric that is equivalent to the discount rate that causes net present value to be zero.
        Internal rate of Return (%) - IRR
        */
        var cf = econCashFlow;
        var array = [cf[0].totals.benefits - cf[0].costs.om];
        var inv = pvInvestment.outPvInvestment;
        for (var i = 1; i < cf.length; i++) {
          array.push(cf[i].totals.netCashFlow);
        }

        function NPV(discountRate, cashFlow) {
          var npv = 0;
          for (var t = 0; t < cashFlow.length; t++) {
            npv += cashFlow[t] / Math.pow((1 + discountRate), t + 1);
          }
          return npv;
        }

        function IRR(cashFlow, guess) {
          var nnpv = NPV(0, cashFlow);
          var x;
          var guessInc;
          guess = guess ? guess : 0;
          if (nnpv - inv > 0) {
            guessInc = 0.0001;
            x = 1;
          } else {
            guessInc = -0.0001;
            x = -1;
          }
          var cnt = 0;

          do {
            guess = guess + guessInc;
            nnpv = NPV(guess, cashFlow);

            cnt++;
          }
          while ((nnpv - inv) * x > 0 && cnt < 10000)
		  if(cnt===10000){
		  return null;
		  }
          return guess;
        }
        return IRR(array);
      },

      funcKPINominalIRR() { // Nominal Internal Rate of Return (IRR) aka Return on Investment (ROI)
        return ((1 + this.solarValues.outKPIIRR / 100) * (1 + this.solarConstants.econDefInflationRate) - 1);
      },

      getKpiNominalIrr(kpiIrr) { // Nominal Internal Rate of Return (IRR) aka Return on Investment (ROI)
        return ((1 + kpiIrr / 100) * (1 + this.solarConstants.econDefInflationRate) - 1);
      },

      funcKPINPV() { // Net Present Value (NPV)
        /*
        Net present value is the same as net savings except that the value of the savings are reduced the further into the future you go.
        Net present value (kr) - NPV
        */
        var cf = this.funcDiscountedCashFlow();

        return cf[cf.length - 1].totals.cumulativeCashFlow;
      },

      getKpiNpv(discountedCashFlow) { // Net Present Value (NPV)
        /*
        Net present value is the same as net savings except that the value of the savings are reduced the further into the future you go.
        Net present value (kr) - NPV
        */
        var cf = discountedCashFlow;

        return cf[cf.length - 1].totals.cumulativeCashFlow;
      },

      funcKPILCOE() { // Levelized Cost of Electricity (LCOE)
        /*
        LCOE is the unit price of electricity that comes from the PV system.
        Levelized cost of energy (kr/kWh) - LCOE
        */
        var cf = this.funcDiscountedCashFlow();
        var discountedCosts = cf.reduce(function(a, b) {
          return a + b.totals.costs;
        }, 0);
        var discountRate = this.solarValues.vDiscountRate;
        var discountedOutput = this.solarValues.outPVYieldArray.reduce(function(a, b, index) {
          return a + (b / ((1 + discountRate) ** index));
        }, 1);
        var sum = discountedCosts / discountedOutput;
        return sum;
      },

      getKpiLcoe(discountedCashFlow, pvYieldArray) { // Levelized Cost of Electricity (LCOE)
        /*
        LCOE is the unit price of electricity that comes from the PV system.
        Levelized cost of energy (kr/kWh) - LCOE
        */
        var cf = discountedCashFlow;
        var discountedCosts = cf.reduce(function(a, b) {
          return a + b.totals.costs;
        }, 0);
        var discountRate = this.solarValues.vDiscountRate;
        var discountedOutput = pvYieldArray.reduce(function(a, b, index) {
          return a + (b / ((1 + discountRate) ** index));
        }, 1);
        var sum = discountedCosts / discountedOutput;
        return sum;
      },

      funcNumPanels() { // Number of panels
        return Math.floor(this.solarValues.vSystemSize / 0.320);
      },

      getNumPanels(systemSize) { // Number of panels
        return Math.floor(systemSize / 0.320);
      },

      funcPanelArea() { // Panels area
        return Math.round(this.funcNumPanels() * 1.67);
      },

      getPanelArea(numPanels) { // Panels area
        return Math.round(numPanels * 1.67);
      },

      funcLoadDistribution() {
        var L_inp = this.solarValues.vAnnualDemand * 1000;
        if (L_inp > 4000000) {
          var array = [
            (-137703.0955056548 + 0.14837356 * L_inp) / 1000, (-103522.83390614367 + 0.12249073 * L_inp) / 1000, (-39054.11236800603 + 0.11078008 * L_inp) / 1000, (61615.786607248476 + 0.0737252 * L_inp) / 1000, (58571.24145367707 + 0.0557144 * L_inp) / 1000, (257552.24861705233 + 6.8802228e-03 * L_inp + 1.1890186e-09 * L_inp ** 2) / 1000, (257181.34240053222 + 6.13883994e-03 * L_inp + 1.03025845e-09 * L_inp ** 2) / 1000, (283257.8019133915 + 4.76735245e-03 * L_inp + 1.19199828e-09 * L_inp ** 2) / 1000, (50541.7776532562 + 0.05332316 * L_inp) / 1000, (34662.24756507354 + 0.07843055 * L_inp) / 1000, (10939.372541060206 + 0.10171198 * L_inp) / 1000, (-32725.294794919435 + 0.1252091 * L_inp) / 1000
          ];
          var sum = array.reduce(function(a, b) {
            return a + b;
          }, 0);
          var adjustedArray = array.map(function(x) {
            return Math.round(x * L_inp / sum / 1000)
          });
          return adjustedArray;
        } else {
          var multipl = [0.095, 0.090, 0.090, 0.080, 0.075, 0.07, 0.07, 0.075, 0.085, 0.085, 0.090, 0.095];
          return multipl.map(x => Math.round(x * L_inp / 1000));
        }
      },

      getLoadDistribution() {
        var L_inp = this.solarValues.vAnnualDemand * 1000;
        if (L_inp > 4000000) {
          var array = [
            (-137703.0955056548 + 0.14837356 * L_inp) / 1000, (-103522.83390614367 + 0.12249073 * L_inp) / 1000, (-39054.11236800603 + 0.11078008 * L_inp) / 1000, (61615.786607248476 + 0.0737252 * L_inp) / 1000, (58571.24145367707 + 0.0557144 * L_inp) / 1000, (257552.24861705233 + 6.8802228e-03 * L_inp + 1.1890186e-09 * L_inp ** 2) / 1000, (257181.34240053222 + 6.13883994e-03 * L_inp + 1.03025845e-09 * L_inp ** 2) / 1000, (283257.8019133915 + 4.76735245e-03 * L_inp + 1.19199828e-09 * L_inp ** 2) / 1000, (50541.7776532562 + 0.05332316 * L_inp) / 1000, (34662.24756507354 + 0.07843055 * L_inp) / 1000, (10939.372541060206 + 0.10171198 * L_inp) / 1000, (-32725.294794919435 + 0.1252091 * L_inp) / 1000
          ];
          var sum = array.reduce(function(a, b) {
            return a + b;
          }, 0);
          var adjustedArray = array.map(function(x) {
            return Math.round(x * L_inp / sum / 1000)
          });
          return adjustedArray;
        } else {
          var multipl = [0.095, 0.090, 0.090, 0.080, 0.075, 0.07, 0.07, 0.075, 0.085, 0.085, 0.090, 0.095];
          return multipl.map(x => Math.round(x * L_inp / 1000));
        }
      },

      funcSelfConsumptionDistribution() {
        var loadDist = this.solarValues.outLoadDistribution;
        var PVYield = this.solarValues.outPVYield;
        var L_inp = this.solarValues.vAnnualDemand * 1000;
        var PV_inp = PVYield * 1000;
        var array = [
          (0.8111595902957935 + -2.31802909e-08 * PV_inp + 2.45222250e-08 * L_inp + -4.14103016e-17 * PV_inp ** 2 + 6.18318853e-16 * L_inp * PV_inp + -5.62219984e-16 * L_inp ** 2), (0.7093776226828836 + -3.69446026e-08 * PV_inp + 3.71540564e-08 * L_inp + -5.07663581e-17 * PV_inp ** 2 + 9.47561554e-16 * L_inp * PV_inp + -8.44470251e-16 * L_inp ** 2), (0.5149646030552602 + -6.80796873e-08 * PV_inp + 5.55159602e-08 * L_inp + 6.70516909e-16 * PV_inp ** 2 + 7.73436846e-16 * L_inp * PV_inp + -1.07305300e-15 * L_inp ** 2), (0.4576776644342541 + -7.31379065e-08 * PV_inp + 4.83777550e-08 * L_inp + 1.45430136e-15 * PV_inp ** 2 + -2.61500881e-18 * L_inp * PV_inp + -7.70409248e-16 * L_inp ** 2), (0.4199058681763036 + -6.50392606e-08 * PV_inp + 3.31615661e-08 * L_inp + 1.66382514e-15 * PV_inp ** 2 + -4.15090325e-16 * L_inp * PV_inp + -3.70396964e-16 * L_inp ** 2), (0.41243676733944323 + -5.72523579e-08 * PV_inp + 2.20102361e-08 * L_inp + 1.62223135e-15 * PV_inp ** 2 + -5.97814626e-16 * L_inp * PV_inp + -5.18916014e-17 * L_inp ** 2), (0.42559804299679155 + -5.57956323e-08 * PV_inp + 1.92011239e-08 * L_inp + 1.60146698e-15 * PV_inp ** 2 + -6.07414029e-16 * L_inp * PV_inp + -3.33546151e-18 * L_inp ** 2), (0.4595411532353202 + -6.08588577e-08 * PV_inp + 2.27152629e-08 * L_inp + 1.60630010e-15 * PV_inp ** 2 + -4.84813254e-16 * L_inp * PV_inp + -8.92007363e-17 * L_inp ** 2), (0.5441869461105981 + -6.85832578e-08 * PV_inp + 2.93062107e-08 * L_inp + 1.50777338e-15 * PV_inp ** 2 + -1.78406658e-16 * L_inp * PV_inp + -2.87435347e-16 * L_inp ** 2), (0.6258250473461742 + -6.21517705e-08 * PV_inp + 4.06098284e-08 * L_inp + 6.70373939e-16 * PV_inp ** 2 + 6.33728926e-16 * L_inp * PV_inp + -7.46191443e-16 * L_inp ** 2), (0.7741152402461166 + -3.20387277e-08 * PV_inp + 2.86921114e-08 * L_inp + 3.61770223e-17 * PV_inp ** 2 + 7.04808533e-16 * L_inp * PV_inp + -6.37532958e-16 * L_inp ** 2), (0.8664780492246025 + -1.87238937e-08 * PV_inp + 1.79580957e-08 * L_inp + -4.71181174e-17 * PV_inp ** 2 + 5.01217798e-16 * L_inp * PV_inp + -4.15708937e-16 * L_inp ** 2)
        ];
        array.forEach(function(val, index) {
          if (val > 1) {
            array[index] = 1
          } else if (val < 0) {
            array[index] = 0
          }
        })
        var systemSize = this.solarValues.vSystemSize;
        var systemProduction = this.solarValues.vProduction;
        var initialIrrYear = this.solarValues.initialIrrYear;
        var scArray = this.solarValues.userIrrMonthDistr.map(function(x, index) {
          return x * array[index] * systemSize * systemProduction / initialIrrYear
        });
        var scArrayQ = this.solarValues.userIrrMonthDistrQ.map(function(x, index) {
          return x * array[index] * PVYield
        });
        var sum = scArray.reduce(function(a, b) {
          return a + b;
        }, 0);
        var sumQ = scArrayQ.reduce(function(a, b) {
          return a + b;
        }, 0);
        var diff = sumQ - this.solarValues.outPVYield;
        if (diff < 0) {
          var test1 = this.solarValues.userIrrMonthDistrQ.map(function(x, index) {
            return x * PVYield - x * array[index] * PVYield
          });
          var sumT = test1.reduce(function(a, b) {
            return a + b;
          }, 0);
          var diff2 = PVYield * this.solarValues.econKPISelfConsumption / 100 - sum;
          var calculated = test1.map(x => x * diff2 / sumT);
          return this.solarValues.userIrrMonthDistrQ.map(function(x, index) {
            var calc = x * array[index] * PVYield + calculated[index];
            if (calc > loadDist[index]) {
              calc = loadDist[index];
            }
            if (calc < 0) {
              calc = 0;
            }
            return Math.round(calc);
          });
        }
        // TO BE FIXED^!^!
        return this.solarValues.userIrrMonthDistr.map(function(x, index) {
          return x * array[index] * systemSize * systemProduction / initialIrrYear
        });
      },

            getSelfConsumptionDistribution(loadDistribution, pvYieldYearOne, selfConsumptionFraction, systemSize, systemProduction, irrYear, irrArray, irrArrayQ) {
        var L_inp = this.solarValues.vAnnualDemand * 1000;
        var PV_inp = pvYieldYearOne * 1000;
        var array = [
          (0.8111595902957935 + -2.31802909e-08 * PV_inp + 2.45222250e-08 * L_inp + -4.14103016e-17 * PV_inp ** 2 + 6.18318853e-16 * L_inp * PV_inp + -5.62219984e-16 * L_inp ** 2), (0.7093776226828836 + -3.69446026e-08 * PV_inp + 3.71540564e-08 * L_inp + -5.07663581e-17 * PV_inp ** 2 + 9.47561554e-16 * L_inp * PV_inp + -8.44470251e-16 * L_inp ** 2), (0.5149646030552602 + -6.80796873e-08 * PV_inp + 5.55159602e-08 * L_inp + 6.70516909e-16 * PV_inp ** 2 + 7.73436846e-16 * L_inp * PV_inp + -1.07305300e-15 * L_inp ** 2), (0.4576776644342541 + -7.31379065e-08 * PV_inp + 4.83777550e-08 * L_inp + 1.45430136e-15 * PV_inp ** 2 + -2.61500881e-18 * L_inp * PV_inp + -7.70409248e-16 * L_inp ** 2), (0.4199058681763036 + -6.50392606e-08 * PV_inp + 3.31615661e-08 * L_inp + 1.66382514e-15 * PV_inp ** 2 + -4.15090325e-16 * L_inp * PV_inp + -3.70396964e-16 * L_inp ** 2), (0.41243676733944323 + -5.72523579e-08 * PV_inp + 2.20102361e-08 * L_inp + 1.62223135e-15 * PV_inp ** 2 + -5.97814626e-16 * L_inp * PV_inp + -5.18916014e-17 * L_inp ** 2), (0.42559804299679155 + -5.57956323e-08 * PV_inp + 1.92011239e-08 * L_inp + 1.60146698e-15 * PV_inp ** 2 + -6.07414029e-16 * L_inp * PV_inp + -3.33546151e-18 * L_inp ** 2), (0.4595411532353202 + -6.08588577e-08 * PV_inp + 2.27152629e-08 * L_inp + 1.60630010e-15 * PV_inp ** 2 + -4.84813254e-16 * L_inp * PV_inp + -8.92007363e-17 * L_inp ** 2), (0.5441869461105981 + -6.85832578e-08 * PV_inp + 2.93062107e-08 * L_inp + 1.50777338e-15 * PV_inp ** 2 + -1.78406658e-16 * L_inp * PV_inp + -2.87435347e-16 * L_inp ** 2), (0.6258250473461742 + -6.21517705e-08 * PV_inp + 4.06098284e-08 * L_inp + 6.70373939e-16 * PV_inp ** 2 + 6.33728926e-16 * L_inp * PV_inp + -7.46191443e-16 * L_inp ** 2), (0.7741152402461166 + -3.20387277e-08 * PV_inp + 2.86921114e-08 * L_inp + 3.61770223e-17 * PV_inp ** 2 + 7.04808533e-16 * L_inp * PV_inp + -6.37532958e-16 * L_inp ** 2), (0.8664780492246025 + -1.87238937e-08 * PV_inp + 1.79580957e-08 * L_inp + -4.71181174e-17 * PV_inp ** 2 + 5.01217798e-16 * L_inp * PV_inp + -4.15708937e-16 * L_inp ** 2)
        ];
        array.forEach(function(val, index) {
          if (val > 1) {
            array[index] = 1
          } else if (val < 0) {
            array[index] = 0
          }
        })
        var scArray = irrArray.map(function(x, index) {
          return x * array[index] * systemSize * systemProduction / irrYear
        });
        var scArrayQ = irrArrayQ.map(function(x, index) {
          return x * array[index] * pvYieldYearOne
        });
        var sum = scArray.reduce(function(a, b) {
          return a + b;
        }, 0);
        var sumQ = scArrayQ.reduce(function(a, b) {
          return a + b;
        }, 0);
        var diff = sumQ - pvYieldYearOne;
        if (diff < 0) {
          var test1 = irrArrayQ.map(function(x, index) {
            return x * pvYieldYearOne - x * array[index] * pvYieldYearOne
          });
          var sumT = test1.reduce(function(a, b) {
            return a + b;
          }, 0);
          var diff2 = pvYieldYearOne * selfConsumptionFraction / 100 - sum;
          var calculated = test1.map(x => x * diff2 / sumT);
          return irrArrayQ.map(function(x, index) {
            var calc = x * array[index] * pvYieldYearOne + calculated[index];
            if (calc > loadDistribution[index]) {
              calc = loadDistribution[index];
            }
            if (calc < 0) {
              calc = 0;
            }
            return Math.round(calc);
          });
        }
        // TO BE FIXED^!^!
        return irrArray.map(function(x, index) {
          return x * array[index] * systemSize * systemProduction / irrYear
        });
      },

      funcOverproductionDistribution() {
        var PVYield = this.solarValues.outPVYield;
        var array = this.solarValues.outSelfConsumptionDistribution;
        return this.solarValues.userIrrMonthDistrQ.map(function(x, index) {
          return Math.round(x * PVYield - array[index])
        })
      },

      getOverproductionDistribution(pvYieldYearOne, selfConsumptionDistribution, irrArrayQ) {
        return irrArrayQ.map(function(x, index) {
          return Math.round(x * pvYieldYearOne - selfConsumptionDistribution[index])
        })
      },

      funcGetSelfConsumption() {
        /*
        Self-consumption is the fraction of PV generation used directly in the building 
        relative to the total generation, most commonly shown as a percentage.
        Self-consumption - SC
        */
        var a = this.solarValues.vAnnualDemand * 1000;
        var b = this.solarValues.outPVYieldArray[0] * 1000;
        var c = 58;
        var annual_SC = 0.6286327937737457 + 3.55080846e-08 * a + -6.44122666e-08 * b + -4.03518201e-07 * c + -3.48986799e-16 * a ** 2 + -2.42141369e-16 * a * b + -6.96671160e-11 * a * c + 1.42085112e-15 * b ** 2 + 4.78724507e-11 * b * c + -4.73073580e-05 * c ** 2

        return annual_SC > 1 ? 100 : annual_SC < 0 ? 0 : Math.round(annual_SC * 100);

      },

      getSelfConsumptionFraction(pvYieldArray) {
        /*
        Self-consumption is the fraction of PV generation used directly in the building 
        relative to the total generation, most commonly shown as a percentage.
        Self-consumption - SC
        */
        var a = this.solarValues.vAnnualDemand * 1000;
        var b = pvYieldArray[0] * 1000;
        var c = 58;
        var annual_SC = 0.6286327937737457 + 3.55080846e-08 * a + -6.44122666e-08 * b + -4.03518201e-07 * c + -3.48986799e-16 * a ** 2 + -2.42141369e-16 * a * b + -6.96671160e-11 * a * c + 1.42085112e-15 * b ** 2 + 4.78724507e-11 * b * c + -4.73073580e-05 * c ** 2

        return annual_SC > 1 ? 100 : annual_SC < 0 ? 0 : Math.round(annual_SC * 100);

      },
	  
      funcGetIrradiation() {
        /*
        Self-consumption is the fraction of PV generation used directly in the building 
        relative to the total generation, most commonly shown as a percentage.
        Self-consumption - SC
        */
        /*
                var a = this.solarValues.vAnnualDemand * 1000;
          var b = this.solarValues.outPVYieldArray[0] * 1000;
          var c = 58;
        var annual_SC=0.6286327937737457 + 3.55080846e-08*a + -6.44122666e-08*b + -4.03518201e-07*c + -3.48986799e-16*a**2 + -2.42141369e-16*a*b + -6.96671160e-11*a*c + 1.42085112e-15*b**2 + 4.78724507e-11*b*c + -4.73073580e-05*c**2
        */
        //return annual_SC > 1 ? 100 : annual_SC < 0 ? 0 : Math.round(annual_SC * 100);
          var roofs = this.$root.$refs.SolarMap.roofs;
        var irr = [];
		var jsonObject;
		var irrArray;
		/*
          var roofs = [...clone].sort(function(a, b) {
            return a.irr_year - b.irr_year;
          }).reverse();
		  */
		  /*
		  roofs.sort(function(a, b) {
            return a.irr_year - b.irr_year;
          }).reverse();
		  */
			roofs.forEach((roof, index) => {
			jsonObject = roofs[index];
			irrArray = [jsonObject.irr_01 || 0, jsonObject.irr_02 || 0, jsonObject.irr_03 || 0,
			jsonObject.irr_04 || 0, jsonObject.irr_05 || 0, jsonObject.irr_06 || 0, jsonObject.irr_07 || 0, jsonObject.irr_04 || 0,
			jsonObject.irr_09 || 0, jsonObject.irr_10 || 0, jsonObject.irr_11 || 0, jsonObject.irr_12 || 0
			];
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
				this.solarValues.userIrrYear = Math.round(sum);
				this.solarValues.vProduction = this.funcPvYield();
				this.solarValues.userRoofArea = jsonObject.area_slope;
				this.solarValues.vSystemSize = this.funcMaxSystemSize();
				this.solarValues.outPVYieldArray = this.funcPvLifetime();
			roofs[index].irrArray = irrArray;
			roofs[index].irrYear =Math.round(sum);
			roofs[index].production = this.funcPvYield();
			roofs[index].roofArea = jsonObject.area_slope;
			roofs[index].maxSystemSize = this.funcMaxSystemSize();
			roofs[index].pvYieldArray = this.funcPvLifetime();
			});
			
		  roofs.sort(function(a, b) {
            return a.production - b.production;
          }).reverse();
       // var solarSystems = this.solarSystems;
        //var pvPower = this.solarConstants.techStandardIrradiation * this.solarConstants.techDefModuleEff / 1000; // 150
        //var annualYield = ( this.solarValues.userIrrYear * this.solarConstants.techDefModuleEff * this.solarConstants.techDefSysEff * (1 - this.solarConstants.techDefLocalLosses) ) / pvPower;
        //return Math.round(annualYield); // Should be around 1000
        var systemSize = parseFloat(this.solarValues.vSystemSize);
		console.log(roofs);
		if (roofs.length == 1) {
                jsonObject = roofs[0];
                irrArray = [jsonObject.irr_01 || 0, jsonObject.irr_02 || 0, jsonObject.irr_03 || 0,
                  jsonObject.irr_04 || 0, jsonObject.irr_05 || 0, jsonObject.irr_06 || 0, jsonObject.irr_07 || 0, jsonObject.irr_04 || 0,
                  jsonObject.irr_09 || 0, jsonObject.irr_10 || 0, jsonObject.irr_11 || 0, jsonObject.irr_12 || 0
                ];
		
		} else if (roofs.length == 2){
                jsonObject = roofs[0];
                irrArray = [jsonObject.irr_01 || 0, jsonObject.irr_02 || 0, jsonObject.irr_03 || 0,
                  jsonObject.irr_04 || 0, jsonObject.irr_05 || 0, jsonObject.irr_06 || 0, jsonObject.irr_07 || 0, jsonObject.irr_04 || 0,
                  jsonObject.irr_09 || 0, jsonObject.irr_10 || 0, jsonObject.irr_11 || 0, jsonObject.irr_12 || 0
                ];
		
		
		} else if (roofs.length == 3){
                jsonObject = roofs[0];
                irrArray = [jsonObject.irr_01 || 0, jsonObject.irr_02 || 0, jsonObject.irr_03 || 0,
                  jsonObject.irr_04 || 0, jsonObject.irr_05 || 0, jsonObject.irr_06 || 0, jsonObject.irr_07 || 0, jsonObject.irr_04 || 0,
                  jsonObject.irr_09 || 0, jsonObject.irr_10 || 0, jsonObject.irr_11 || 0, jsonObject.irr_12 || 0
                ];
		
		
		}
		
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
				this.solarValues.userIrrYear = Math.round(sum);
				this.solarValues.vProduction = this.funcPvYield();
				this.solarValues.userRoofArea = jsonObject.area_slope;
				this.solarValues.vSystemSize = this.funcMaxSystemSize();
				
				
				
				
				
                var irrDistributionArray = irrArray.map(x => x / sum);

                this.solarValues.initialIrrMonthDistr = irrArray; //solarValues
                this.solarValues.userIrrMonthDistr = irrArray; //solarValues
                this.solarValues.userIrrMonthDistrQ = irrDistributionArray; //solarValues Distribution

                this.solarValues.initialIrrYear = Math.round(sum) || 0;
                this.solarValues.userIrrYear = Math.round(sum) || 0;

                this.solarValues.initialRoofArea = jsonObject.area_slope || 0;
                this.solarValues.userRoofArea = jsonObject.area_slope || 0;
                this.solarValues.maxRoofArea = this.funcMaxRoofArea() || 0;

                this.solarValues.initialMaxSystemSize = this.funcMaxSystemSize();
                this.solarValues.initialNumPanels = Math.floor(this.solarValues.initialMaxSystemSize / 0.320);
                this.solarValues.vSystemSize = this.funcMaxSystemSize();

                this.solarValues.initialProduction = this.funcPvYield();
                this.solarValues.vProduction = this.funcPvYield();

                this.solarValues.initialPVPrice = this.funcPVPrice();
                this.solarForm.vPVPrice.disabled = true;
                this.solarForm.vSelfConsumption.disabled = true;
        return irr;
      },
      calculateSystem(roof, params = {}) {
	  var {
	  price,
	  selfConsumption,
	  production
	  } = params;
	  var system = {...roof};
	  var fraction = 1;
	  if(price && price.fraction > 0){
	  fraction = price.fraction;
	  }
	  //system.pvPrice = price ? price : this.getPvPrice(system.systemSize);
	  system.pvPrice = Math.round(this.getPvPrice(system.systemSize) * fraction);
	  system.pvYield = production ? production : this.getPvYield(system.irrYear);
	  system.pvInvestment = this.getPvInvestment(system.systemSize, system.pvPrice);
	  system.pvYieldArray = this.getPvYieldArray(system.pvYield, system.systemSize);
	  system.pvYieldYearOne = Math.round(system.pvYieldArray[0] / 10) * 10;
	  system.selfConsumptionFraction = selfConsumption ? selfConsumption : this.getSelfConsumptionFraction(system.pvYieldArray);
	  system.selfConsumptionArray = this.getSelfConsumptionArray(system.pvYieldArray, system.selfConsumptionFraction);
	  system.selfConsumption = Math.round(system.pvYieldArray[0] * system.selfConsumptionFraction / 1000) * 10;
	  system.overproduction = system.pvYieldYearOne - system.selfConsumption;
	  system.valueOfSavings = this.getValueOfSavings(system.selfConsumptionArray);
	  system.selfConsumptionValue = Math.round(system.valueOfSavings.selfConsumptionValue[0] / 10) * 10;
	  system.overproductionValue = Math.round(system.valueOfSavings.overproductionValue[0] / 10) * 10;
	  system.cashFlow = this.getCashFlow(system.valueOfSavings, system.selfConsumptionArray, system.pvInvestment, system.systemSize, system.pvPrice);
	  system.discountedCashFlow = this.getDiscountedCashFlow(system.cashFlow);
	  system.numPanels = this.getNumPanels(system.systemSize);
	  system.panelArea = this.getPanelArea(system.numPanels);
	  system.maxRoofArea = parseFloat(this.getMaxRoofArea(system.roofArea || 0));
	  system.maxSystemSize = parseFloat(this.getMaxSystemSize(system.roofArea || 0));
	  system.kpiSolarFraction = Math.round(this.getKpiSolarFraction(system.pvYieldYearOne) * 100);
	  system.kpiSelfSufficiency = Math.round(this.getKpiSelfSufficiency(system.selfConsumptionFraction, system.kpiSolarFraction));
	  system.kpiPaybackTime = this.getKpiPaybackTime(system.cashFlow);
	  system.kpiDiscountedPaybackTime = this.getKpiDiscountedPaybackTime(system.discountedCashFlow);
	  system.kpiNpv = Math.round(this.getKpiNpv(system.discountedCashFlow) / 10) * 10;
	  system.kpiIrr = Math.round(this.getKpiIrr(system.cashFlow, system.pvInvestment) * 100000) / 1000;
	  system.kpiNominalIrr = Math.round(this.getKpiNominalIrr(system.kpiIrr) * 10000) / 100;
	  system.kpiLcoe = Math.round(this.getKpiLcoe(system.discountedCashFlow, system.pvYieldArray) * 100) / 100;
	  system.loadDistribution = this.getLoadDistribution();
	  system.selfConsumptionDistribution = this.getSelfConsumptionDistribution(system.loadDistribution, system.pvYieldYearOne, system.selfConsumptionFraction, system.systemSize, system.pvYield, system.irrYear, system.irrArray, system.irrArrayQ);
	  system.overProductionDistribution = this.getOverproductionDistribution(system.pvYieldYearOne, system.selfConsumptionDistribution, system.irrArrayQ);
	  system.savingsSelfConsumption = Math.round(system.valueOfSavings.selfConsumptionValue.reduce((a,b)=>a+b));
	  system.savingsGridSales = Math.round(system.valueOfSavings.overproductionValue.reduce((a,b)=>a+b));
	  system.savingsLifetime = Math.round(system.valueOfSavings.selfConsumptionValue.reduce((a,b)=>a+b) + system.valueOfSavings.overproductionValue.reduce((a,b)=>a+b));
	  system.savingsNetLifetime = Math.round(system.cashFlow[system.cashFlow.length-1].totals.cumulativeCashFlow);
	  system.savingsAnnual = Math.round((system.valueOfSavings.selfConsumptionValue.reduce((a,b)=>a+b) + system.valueOfSavings.overproductionValue.reduce((a,b)=>a+b)) / this.solarValues.vLifelength);
	  system.savingsNetAnnual = Math.round(system.cashFlow[system.cashFlow.length-1].totals.cumulativeCashFlow / this.solarValues.vLifelength);
	  //console.log(this.solarSystems);
			return system;
      },
	  
	  getSystem(params = {}){
	  var {
	  size = 100, 
	  production, 
	  price, 
	  selfConsumption
	  } = params;
			var solarSystems = this.solarSystems;
	  var systems = [...solarSystems];
	  //console.log(systems);
	  var roofArea = systems[systems.length -1].roofArea;
	  var newSystem, inSystem;
	  var roofs = [];
	  if(systems.length > 0){
	  if(systems.length === 1){
	  roofs = [{
	    id: systems[0].id,
		quote: 0
		}]
		} else if(systems.length === 3){
	  roofs = [{
	    id: systems[0].id,
		quote: 0
		},{
	    id: systems[1].id,
		quote: 0
		}];
		} else if(systems.length === 7){
	  roofs = [{
	    id: systems[0].id,
		quote: 0
		},{
	    id: systems[1].id,
		quote: 0
		},{
	    id: systems[2].id,
		quote: 0
		}];
		}
	  if(systems[0].maxSystemSize >= size || systems.length == 1){
	  inSystem = {
		irrArray: systems[0].irrArray,
		irrArrayQ: systems[0].irrArrayQ,
		irrYear: systems[0].irrYear,
		production: production || this.getPvYield(irrYear),
		systemSize: size,
		roofArea
	  };
	  roofs[0] = {
	    id: systems[0].id,
		quote: size / systems[0].maxSystemSize,
		size: (Math.round((size) * 10) / 10)
		};
	  newSystem = this.calculateSystem(inSystem, {price, selfConsumption, production});
	  } else if(systems[0].maxSystemSize + systems[1].maxSystemSize >= size) {
            var quote = systems[0].maxSystemSize / size;
            var irrArray = systems[0].irrArray.map((x, index) => x * quote + systems[1].irrArray[index] * (1 - quote));
			
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
			var irrArrayQ = irrArray.map(x => x / sum);
			var irrYear = Math.round(sum);
	  inSystem = {
		irrArray,
		irrArrayQ,
		irrYear,
		production: production || this.getPvYield(irrYear),
		systemSize: size,
		roofArea
	  };
	  roofs[0] = {
	    id: systems[0].id,
		quote: 1,
		size: systems[0].maxSystemSize
		};
		roofs[1] = {
	    id: systems[1].id,
		quote: (size - systems[0].maxSystemSize) / systems[1].maxSystemSize,
		size: (Math.round((size - systems[0].maxSystemSize) * 10) / 10)
		};
	  newSystem = this.calculateSystem(inSystem, {price, selfConsumption, production});
	  } else if (systems.length === 7 && (systems[0].maxSystemSize + systems[1].maxSystemSize + systems[2].maxSystemSize) >= size) {
            var quote = systems[0].maxSystemSize / size;
            var quote2 = systems[1].maxSystemSize / size;
            var irrArray = systems[0].irrArray.map((x, index) => x * quote + systems[1].irrArray[index] * quote2 + systems[2].irrArray[index] * (1 - quote - quote2));
			
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
			var irrArrayQ = irrArray.map(x => x / sum);
			var irrYear = Math.round(sum);
	  inSystem = {
		irrArray,
		irrArrayQ,
		irrYear,
		production: production || this.getPvYield(irrYear),
		systemSize: size,
		roofArea
	  };
	  roofs = [{
	    id: systems[0].id,
		quote: 1,
		size: systems[0].maxSystemSize
		},{
	    id: systems[1].id,
		quote: 1,
		size: systems[1].maxSystemSize
		},{
	    id: systems[2].id,
		quote: (size - systems[0].maxSystemSize - systems[1].maxSystemSize) / systems[2].maxSystemSize,
		size: (Math.round((size - systems[0].maxSystemSize - systems[1].maxSystemSize) * 10) / 10)
		}];
	  newSystem = this.calculateSystem(inSystem, {price, selfConsumption, production});
	  }  else if (systems.length == 3) {
            var sumSize = systems[0].maxSystemSize + systems[1].maxSystemSize;
            var irrArray = systems[0].irrArray.map((x, index) => x * systems[0].maxSystemSize / sumSize + systems[1].irrArray[index] * systems[1].maxSystemSize / sumSize);
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
			var irrArrayQ = irrArray.map(x => x / sum);
			var irrYear = Math.round(sum);
	  inSystem = {
		irrArray,
		irrArrayQ,
		irrYear,
		production: production || this.getPvYield(irrYear),
		systemSize: size,
		roofArea
	  };
	  roofs = [{
	    id: systems[0].id,
		quote: 1,
		size: '-'
		},{
	    id: systems[1].id,
		quote: 1,
		size: '-'
		}];
	  newSystem = this.calculateSystem(inSystem, {price, selfConsumption, production});
          } else if (systems.length == 7) {
            var sumSize = systems[0].maxSystemSize + systems[1].maxSystemSize + systems[2].maxSystemSize;
            var irrArray = systems[0].irrArray.map((x, index) => x * systems[0].maxSystemSize / sumSize + systems[1].irrArray[index] * systems[1].maxSystemSize / sumSize + systems[2].irrArray[index] * systems[2].maxSystemSize / sumSize);
                var sum = irrArray.reduce(function(a, b) {
                  return parseInt(a) + parseInt(b);
                }, 0);
			var irrArrayQ = irrArray.map(x => x / sum);
			var irrYear = Math.round(sum);
	  inSystem = {
		irrArray,
		irrArrayQ,
		irrYear,
		production: production || this.getPvYield(irrYear),
		systemSize: size,
		roofArea
	  };
	  roofs = [{
	    id: systems[0].id,
		quote: 1,
		size: '-'
		},{
	    id: systems[1].id,
		quote: 1,
		size: '-'
		},{
	    id: systems[2].id,
		quote: 1,
		size: '-'
		}];
	  newSystem = this.calculateSystem(inSystem, {price, selfConsumption, production});
          } else {
		  console.log(systems.length);
		  console.log(systems);
		  alert("SOMETHING WENT WRONG!");
	    newSystem = []
	  } 
	  } else {
		  console.log(systems.length);
		  console.log(systems);
		  alert("SOMETHING WENT WRONG!");
	    newSystem = []
	  }
	  newSystem.roofs = roofs;
	  return newSystem;
	  },
	  
      setOptimalSystem() {
	  	  if(this.solarSystems[this.solarSystems.length - 1].maxSystemSize > 0 && this.solarSystems[this.solarSystems.length - 1].maxSystemSize <= 25){
	  var maxSize = this.solarSystems[this.solarSystems.length - 1].maxSystemSize || 25;
	  } else {
	  var maxSize = 25;
	  }
	  var chartData = {}
        chartData.labels = [];
        chartData.datasets = [{}, {}];
        chartData.datasets[0].data = [];
        chartData.datasets[0].pointStyle = [];
        chartData.datasets[1].data = [];
        chartData.datasets[0].pointRadius = [];
        chartData.datasets[1].pointRadius = [];
		
	  var fraction = 1;
	  if(!this.solarForm.vPVPrice.disabled){
	  var calculatedPrice = this.getPvPrice(this.solarValues.vSystemSize);
	  var inputPrice = this.solarValues.vPVPrice;
	  fraction = inputPrice / calculatedPrice;
	  }
	  
        for (var i = 1; i <= Math.ceil(maxSize); (i = i + 0.5)) {
 //       for (var i = 5; i <= 5; (i = i + 1)) {
		  var testSystemSize = i;
		var testSystem = this.getSystem({
		size: testSystemSize,
		production: this.solarForm.vProduction.disabled ? undefined : this.solarValues.vProduction,
		//price: this.solarForm.vPVPrice.disabled ? undefined : this.solarValues.vPVPrice,
		price: {price: this.solarForm.vPVPrice, fraction: fraction},
		selfConsumption: this.solarForm.vSelfConsumption.disabled ? undefined : this.solarValues.econKPISelfConsumption
		
		});
          chartData.labels.push(i);
         chartData.datasets[0].data.push(testSystem.kpiNominalIrr);
          chartData.datasets[1].data.push(testSystem.kpiPaybackTime);
          chartData.datasets[0].pointStyle.push('point');
          chartData.datasets[0].pointRadius.push(3);
        }
        var optimalSizeIndex = chartData.datasets[0].data.indexOf(Math.max.apply(Math, chartData.datasets[0].data));
        var shortestPayback = chartData.datasets[1].data.indexOf(Math.min.apply(Math, chartData.datasets[1].data.filter(n => !isNaN(n))));
        chartData.datasets[0].pointRadius[optimalSizeIndex] = 6;
        chartData.datasets[1].pointRadius[shortestPayback] = 6;
		
		 /*    this.irrChartData = {
          labels: chartData.labels,
          datasets: [{
            label: 'IRR',
            yAxisID: 'IRR',
            backgroundColor: this.$refs.nonsense.gradient,
            borderColor: '#777777',
            pointBackgroundColor: 'white',
            pointStyle: chartData.datasets[0].pointStyle,
            borderWidth: 1,
            pointBorderColor: 'rgba(0, 200, 0, 0.9)',
            pointBorderWidth: 3,
            pointRadius: chartData.datasets[0].pointRadius,
            data: chartData.datasets[0].data
          }, {
            label: 'Payback',
            yAxisID: 'payback',
            backgroundColor: this.$refs.nonsense.gradient2,
            borderColor: '#777777',
            pointBackgroundColor: 'white',
            pointStyle: [],
            borderWidth: 1,
            pointBorderColor: 'rgba(200, 0, 0, 0.9)',
            pointBorderWidth: 3,
            pointRadius: chartData.datasets[1].pointRadius,
            data: chartData.datasets[1].data
          }],
          options: {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            },
            responsive: true,
            maintainAspectRatio: false
          },
          styles: {
            height: '300px',
            width: '100%',
            position: 'relative',
          }
        };
		*/
		var optimalSize = chartData.labels[optimalSizeIndex];		
		this.optimalSystem = this.getSystem({size: optimalSize});
		this.solarSystem = this.optimalSystem;
		this.doUpdateCharts(this.solarSystem);
        this.solarValues.vPVPrice = this.optimalSystem.pvPrice;
        this.solarValues.vProduction = this.optimalSystem.pvYield;
        this.solarValues.econKPISelfConsumption = this.optimalSystem.selfConsumptionFraction;
        this.solarValues.vSystemSize = chartData.labels[optimalSizeIndex];
			return;
      },
      generateReport() {
        this.$refs.html2Pdf.generatePdf()
      },
      triggerClickOld() {
        var element = document.getElementById('accordion-1-top');
        element.scrollIntoView();
        var refs = this.$refs;
        window.setTimeout(function() {
          refs.html2Pdf.generatePdf()
        }, 200)
      },
      triggerClick() {
	  //console.log(document.getElementById('hjl'));
	  //console.log(document.getElementById('hjl').value);
        var searchAddress = document.getElementById('hjl').value || '';
		if(searchAddress){
		//document.getElementById('printAddress').innerHTML = ' på ' + searchAddress;
		document.getElementById('printAddress').innerHTML = 'på ett hus med ' + this.formatNumber(this.solarValues.vAnnualDemand) + ' kWh årsförbrukning på:<br />' + searchAddress;
		} else {
		document.getElementById('printAddress').innerHTML = 'på ett hus med ' + this.formatNumber(this.solarValues.vAnnualDemand) + ' kWh årsförbrukning';
		}
        //var element = document.getElementById('topp');
        //element.scrollIntoView();
		//var canvas = document.getElementById('app-wrapper').firstChild;
	//var itm = document.getElementById("app-wrapper2");

// Copy the <li> element and its child nodes
//var cln = itm.cloneNode(true);

// Append the cloned <li> element to <ul> with id="myList1"
//document.getElementById("node1").appendChild(cln);
//document.getElementById('printMap').appendChild(  document.getElementById('app-wrapper2') )
		this.position = window.scrollY;
		//console.log(window.scrollY);
		window.scrollTo(0,0);
		//console.log(this);
		//console.log(window);
		//console.log(window.screenTop);
        var refs = this.$refs;
		//console.log(refs);
		//console.log(this.$root);
        window.setTimeout(function() {
          refs.html2Pdf.generatePdf()
        }, 500)
      },
      async beforeDownload() {
        //console.log(`On Before PDF Generation`)
      },
      async beforeDownloadOld({
        html2pdf, options, pdfContent
      }) {
        await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {

          var popup = window.open();
          var link = document.createElement('a');
          link.setAttribute('href', pdf.output('bloburl'));
          link.setAttribute('download', 'export.pdf');
          popup.document.body.appendChild(link);
          link.click();
		//console.log(this);
		//console.log(this.position);
//document.getElementById('hiddenDiv').appendChild(  document.getElementById('app-wrapper2') )
window.scrollTo(0,this.position);
overlayWindow
        })
      }
    },
    computed: {
      btnVariant: function() {
        //console.log(this);
        return this.collapsed ?
          'primary' : 'primary'
      },
      btnTxt: function() {
        return this.collapsed ?
          '🡇 Show ' : '🡅 Hide';
      },
      nameState() {
        return this.name.length > 2 ? true : false
      }

    },
    created() {
      this.$root.$refs.SolarCalc = this;
    },

    components: {
    MiniMap,
      VueHtml2pdf
    },
    mounted: function() {
      //console.log("mounted");
      window.vuesite = this;
    },
  }
</script>